/** Webflow CMS placed-student review export */
export interface IntensiveReview {
  UID: string;
  slug: string;
  "Collection ID": string;
  "Locale ID": string;
  "Item ID": string;
  Archived: string;
  Draft: string;
  "Created On": string;
  "Updated On": string;
  "Published On": string;
  "Stundent Name": string;
  College: string;
  Branch: string;
  "Graduate year": string;
  "Student profile image Url": string;
  "Company Name": string;
  "Company logo Url": string;
  Designation: string;
  "linkedin profile link": string;
  "One liner Testimonial": string;
  "Branch Filter": string;
  "Page-specific filters Tags": string;
  "Placed month Date Formate": string;
  "Shortened Degree": string;
  "Package in lpa": string;
  "Full Testimonial": string;
  "Placed Month": string;
}

export const INTENSIVE_REVIEWS = [
  {
    "UID": "000f3837-1e78-4a9b-9489-f333514d2c17",
    "slug": "000f3837-1e78-4a9b-9489-f333514d2c17",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d77ac57f86406559373",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:03 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Daram Pragna",
    "College": "Seshadri Rao Gudlavalleru Engineering College ",
    "Branch": "Artificial Intelligence and Machine Learning",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/000f3837-1e78-4a9b-9489-f333514d2c17.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/pragna-daram/",
    "One liner Testimonial": "This achievement means a lot to me and my family. I’m thankful to NxtWave for shaping my learning journey and giving me the confidence to begin my career on the right path.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "01e42324-fcbb-4398-9da9-e7520b8c2030",
    "slug": "01e42324-fcbb-4398-9da9-e7520b8c2030",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4e59fe3a977a07abb6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Hemachandra Reddy Kalluru",
    "College": "Kalasalingam University, Maduri, Madurai",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/01e42324-fcbb-4398-9da9-e7520b8c2030.png",
    "Company Name": "Milestone Technologies Inc.",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/milestone-technologies-inc..png",
    "Designation": "Apprentice - Junior Remote Support Technician",
    "linkedin profile link": "https://www.linkedin.com/in/hemachandrakalluru/",
    "One liner Testimonial": "After missing out on a couple of offers, I felt low for a while. Through NxtWave, I got the opportunity I was waiting for.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "038da790-29b1-4296-aa73-7049cff1fe5d",
    "slug": "038da790-29b1-4296-aa73-7049cff1fe5d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d3e708f336e5be50dc",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ananya Majety",
    "College": "MLR Institute of Technology",
    "Branch": "Computer Science Engineering (ALML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/038da790-29b1-4296-aa73-7049cff1fe5d.png",
    "Company Name": "Quad One",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/quad-one.png",
    "Designation": "Data Science Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/ananyamajety/",
    "One liner Testimonial": "I’m learning a lot in my first month as a Data Science Engineer. The timely support from NxtWave during the interview made a real difference.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 31 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "046d81ad-8f71-43bd-b733-18ad85c09a15",
    "slug": "046d81ad-8f71-43bd-b733-18ad85c09a15",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4ba0c3cad95154c9bb",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Likhitha Siddamsetti",
    "College": "Sri Vasavi Institute of Engineering & Technology (SVIET), Nandamuru",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/046d81ad-8f71-43bd-b733-18ad85c09a15.png",
    "Company Name": "Capgemini",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/capgemini.png",
    "Designation": "Analyst/A4",
    "linkedin profile link": "https://www.linkedin.com/in/likhithasiddamsetti/",
    "One liner Testimonial": "I shifted from ECE to IT with doubts and pressure around me. My first interview through NxtWave placed me at Capgemini as an Analyst/A4",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "04c2618c-c0fc-4819-ab69-6a4444600591",
    "slug": "04c2618c-c0fc-4819-ab69-6a4444600591",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6f841b17e203b7cf0f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:55 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Madineni Kamali U",
    "College": "Annamacharya Institute of Technology & Sciences (AITS), Rajampet",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/04c2618c-c0fc-4819-ab69-6a4444600591.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Associate Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/madineni-kamali-u-5073a4213/",
    "One liner Testimonial": "Sometimes all it takes is starting again. After missing my GATE target, I went back to NxtWave, stayed consistent, and within months, landed my first job at ADP.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "05a08d33-e843-40dd-90b8-0cbd6ae42fb7",
    "slug": "05a08d33-e843-40dd-90b8-0cbd6ae42fb7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8f8171333ccee0ac6b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nithin Paila",
    "College": "Lovely Professional University (LPU), Phagwara",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/05a08d33-e843-40dd-90b8-0cbd6ae42fb7.png",
    "Company Name": "OVI Learning LLP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ovi-learning-llp.png",
    "Designation": "AI/ML Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/nithin18/",
    "One liner Testimonial": "I joined NxtWave after graduation hoping to start my IT career. My journey wasn’t smooth, but NxtWave made it possible. I’ve landed my first AI/ML role at OVI Learning LLP.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "05ce7b4a-9a87-40df-95ab-d226d79e4730",
    "slug": "05ce7b4a-9a87-40df-95ab-d226d79e4730",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7df82afe19cb47b6b4",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Veerababu Teki",
    "College": "Adikavi Nannaya University (ANU), Rajahmundry",
    "Branch": "Mathematics",
    "Graduate year": "2020",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/05ce7b4a-9a87-40df-95ab-d226d79e4730.png",
    "Company Name": "LovasIT",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lovasit.png",
    "Designation": "Oracle CPQ Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/veera-babu-t-37793a23b/",
    "One liner Testimonial": "Coming from a non-tech background and facing multiple rejections, I stayed committed, learned from zero at NxtWave, and secured my first IT role as an Oracle CPQ Trainee at LovasIT.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MS/MSc",
    "Package in lpa": "6.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "06d1c61e-7384-4908-bbdd-09c7ca40e8bf",
    "slug": "06d1c61e-7384-4908-bbdd-09c7ca40e8bf",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c7096877ffd9058d13188",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:49:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Banothu Nithin",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), Basar",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/06d1c61e-7384-4908-bbdd-09c7ca40e8bf.png",
    "Company Name": "Innoira",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innoira.png",
    "Designation": "Associate Agentic AI Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/banothu-nithin/recent-activity/all/",
    "One liner Testimonial": "I always believed I’d make it one day. NxtWave’s hands-on projects, flexibility, and placement support helped me land my first job as an Agentic AI Engineer.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "06f2a933-a43d-4452-94f5-fb0ce510375e",
    "slug": "06f2a933-a43d-4452-94f5-fb0ce510375e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6ff82afe19cb47ad03",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:55 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Daraniswar P",
    "College": "Kongunadu College of Engineering and Technology (KCET), Namakkal",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/06f2a933-a43d-4452-94f5-fb0ce510375e.png",
    "Company Name": "BootLabs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/bootlabs.png",
    "Designation": "Software Engineer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/daraniswar-poobalan/",
    "One liner Testimonial": "Learning in my own language and at my own pace through NxtWave helped me confidently start my tech career at BootLabs.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "0775d886-3976-42c7-ab36-9071368fd0f3",
    "slug": "0775d886-3976-42c7-ab36-9071368fd0f3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b507dcdc579b1d96c7d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Samrat Veldhandi",
    "College": "Chaitanya - Deemed to be University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0775d886-3976-42c7-ab36-9071368fd0f3.png",
    "Company Name": "Pando",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/pando.png",
    "Designation": "Quality Analyst Intern",
    "linkedin profile link": "https://www.linkedin.com/in/samrat-veldhandi-4a2433214/",
    "One liner Testimonial": "At NxtWave, I learned practically every day and that helped me land my first role. Seeing my parents proud made everything worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "07969cd6-810f-46b1-92d3-536eeac4bddb",
    "slug": "07969cd6-810f-46b1-92d3-536eeac4bddb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5ec6a81cb06b2a4499",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:38 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Kumar Bhukya",
    "College": "Keshav Memorial College of Engineering (KMCE)",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/07969cd6-810f-46b1-92d3-536eeac4bddb.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Software Engineer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/sai-kumar-bhukya-71046a257/",
    "One liner Testimonial": "There were times I doubted myself after rejections, but the mock interviews and support from NxtWave’s coaches kept me going. All that effort finally paid off when I got placed at Phenom.",
    "Branch Filter": "NxtWave Features",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "08a6f762-d758-47cc-be87-87e1e1d465e7",
    "slug": "08a6f762-d758-47cc-be87-87e1e1d465e7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d479519dfd06eb6aba6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Meenatchi M",
    "College": "Dhanalakshmi Srinivasan Engineering College (DSEC), Perambalur",
    "Branch": "MCA (Master of Computer Application)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/08a6f762-d758-47cc-be87-87e1e1d465e7.png",
    "Company Name": "PALC Networks",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/palc-networks.png",
    "Designation": "UI Developer",
    "linkedin profile link": "https://www.linkedin.com/in/meenatchimurugan-b7b0712a1/",
    "One liner Testimonial": "Balancing MCA studies with NxtWave wasn’t easy, but it gave me the skills and confidence I needed. Today, I’m working as a UI Developer at PALC Networks",
    "Branch Filter": "Women In Tech",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "0ae5ab0f-d0a0-4db8-b840-f02762dd87eb",
    "slug": "0ae5ab0f-d0a0-4db8-b840-f02762dd87eb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d58918f5cf3ea5f9149",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:32 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Deepa S",
    "College": "Nss College Rajakumari",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0ae5ab0f-d0a0-4db8-b840-f02762dd87eb.png",
    "Company Name": "fxis.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fxis.ai.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/deepas1200",
    "One liner Testimonial": "Even with an IT background, I struggled to turn theory into real-world skills, until I joined NxtWave. Their hands-on projects and mock interviews gave me the confidence I needed.",
    "Branch Filter": "Doubts Resolution",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BCA",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "0d01bc30-7449-4be7-bea5-1e8c73f0d59d",
    "slug": "0d01bc30-7449-4be7-bea5-1e8c73f0d59d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d62e70849ff1fc1e39d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:42 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Sripadh Varma Alimilla",
    "College": "Chaitanya Bharathi Institute of Technology (CBIT), Gandipet",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0d01bc30-7449-4be7-bea5-1e8c73f0d59d.png",
    "Company Name": "Prolifics Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/prolifics-corporation.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sai-sripadh-varma-alimilla-03a4b5333/",
    "One liner Testimonial": "I joined NxtWave on my father’s suggestion to upskill. The course takes you from zero to advanced, and within a year, I was able to secure this job.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "0d045cad-09bb-4ac5-b6a9-225f2b46c010",
    "slug": "0d045cad-09bb-4ac5-b6a9-225f2b46c010",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9e73ea97d4409cdb53",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:42 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Gaikwad Kaustubh Nitin",
    "College": "IIT Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0d045cad-09bb-4ac5-b6a9-225f2b46c010.png",
    "Company Name": "Lloyd Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lloyd-technologies.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/kaustubh-gaikwad2332/",
    "One liner Testimonial": "After graduation, I struggled to convert opportunities. Applying through NxtWave changed that and helped me start my career as a Software Engineer.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "M.Tech",
    "Package in lpa": "12.5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "0d13a1e8-02fa-490f-b8ca-9c7b48494cd4",
    "slug": "0d13a1e8-02fa-490f-b8ca-9c7b48494cd4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5bfe99411b5224dfe8",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jasswanth Gujarathi",
    "College": "Mahbub Degree College, Secunderabad",
    "Branch": "Computer Applications",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0d13a1e8-02fa-490f-b8ca-9c7b48494cd4.png",
    "Company Name": "Qwipo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qwipo.png",
    "Designation": "Junior Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/jasswanth/",
    "One liner Testimonial": "Despite having a BCom background and no prior coding experience, I built my tech skills with NxtWave’s guidance. Today, I’m proud to start as a Junior Software Developer at Qwipo,",
    "Branch Filter": "Non-English Medium To It Job",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Com",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "0e75028c-3eee-4c67-8c64-153fee3d9187",
    "slug": "0e75028c-3eee-4c67-8c64-153fee3d9187",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcb50f4b2bc0b066443",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Umesh Chandra",
    "College": "Indian Institute of Information Technology, Nagpur",
    "Branch": "Electronics and Computer Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0e75028c-3eee-4c67-8c64-153fee3d9187.png",
    "Company Name": "Fission Labs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fission-labs.png",
    "Designation": "Associate Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/umeshch/",
    "One liner Testimonial": "This is my third opportunity through NxtWave, and I’ve now joined a full-time software role in Hyderabad. Everything is going well, and I’m happy with this start.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue Dec 16 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "7",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "0e8a4bc4-446b-4116-a3a2-85d8ff791045",
    "slug": "0e8a4bc4-446b-4116-a3a2-85d8ff791045",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6473ea97d4409cb5d9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:44 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Likhitha Mantini",
    "College": "Adikavi Nannaya University (ANU), Rajahmundry",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0e8a4bc4-446b-4116-a3a2-85d8ff791045.png",
    "Company Name": "Actalyst",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/actalyst.png",
    "Designation": "Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/mantini-likhitha-5a7480238/",
    "One liner Testimonial": "I joined NxtWave after graduation, and it turned out to be the best decision. The support and guidance I got here helped me land my first job.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "114541ab-ad63-4d62-ab95-ed735c84404f",
    "slug": "114541ab-ad63-4d62-ab95-ed735c84404f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c9393f83b89a7c0701",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Aniket Ranjan",
    "College": "VIT Bhopal",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/114541ab-ad63-4d62-ab95-ed735c84404f.png",
    "Company Name": "Crayon Data",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/crayon-data.png",
    "Designation": "AI Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/aniket-ranjan-32b8a4247/",
    "One liner Testimonial": "I’m still in final year and got selected as an AI Engineer Intern at Crayon Data. NxtWave helped me apply to roles that actually fit my skills.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "128be44a-8cf9-4602-b190-cb3a36c77b87",
    "slug": "128be44a-8cf9-4602-b190-cb3a36c77b87",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8fac57f86406559cb9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Praveen kumar Alluri",
    "College": "Rajeev Gandhi Memorial College of Engineering & Technology (RGMCET), Nandyal",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/128be44a-8cf9-4602-b190-cb3a36c77b87.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/alluri-praveen-kumar/",
    "One liner Testimonial": "Everyone in my family is in government jobs, but NxtWave helped me build my own path in tech. Proud to start my career at Cubic Corporation as an Engineering Trainee.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "12f4588a-5334-4dfe-be98-71db07d38a5c",
    "slug": "12f4588a-5334-4dfe-be98-71db07d38a5c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6a9896b863004e80f6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:50 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Harshavardhan Penumala",
    "College": "College Sree Venkateswara College of Engineering kodavaluru nellore",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2018",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/12f4588a-5334-4dfe-be98-71db07d38a5c.png",
    "Company Name": "Arizon Digital",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/arizon-digital.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/harshavardhan332/",
    "One liner Testimonial": "I had a long career break after graduation and never expected to get an IT job. Thanks to NxtWave, I finally got placed at Arizon Digital as a Full Stack Developer.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "12fffd8a-50b1-4ea8-a996-b42af49379b6",
    "slug": "12fffd8a-50b1-4ea8-a996-b42af49379b6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c6efc8ad3adc66e40a3c6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:42:36 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Praneeth Eagala",
    "College": "Raghu Engineering College (REC), Dakamarri",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2021",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/12fffd8a-50b1-4ea8-a996-b42af49379b6.png",
    "Company Name": "Parivartan Software & Multimedia Pvt. Ltd.",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/parivartan-software-&-multimedia-pvt.-ltd..png",
    "Designation": "Jr. Mernstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/praneeth-4e33/",
    "One liner Testimonial": "I switched from a non-IT background and stayed consistent with NxtWave. Working as a MERN developer now feels like the right turn in my career.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "134d2a43-1ffa-41b3-8473-3973551362fc",
    "slug": "134d2a43-1ffa-41b3-8473-3973551362fc",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d76e70849ff1fc1f3ba",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:02 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Prasad Golla",
    "College": "Nalla Malla Reddy Engineering College",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/134d2a43-1ffa-41b3-8473-3973551362fc.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/sai-prasad-g-181b75263/",
    "One liner Testimonial": "It feels extra special to begin my first job at LTI Mindtree and even more so because I’m joining alongside my friend who learned with me at NxtWave.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "15c8f3a9-3021-4c3d-bdad-bc672389e209",
    "slug": "15c8f3a9-3021-4c3d-bdad-bc672389e209",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d458428c65d6b5491b8",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Allada lokesh",
    "College": "Gayatri Vidya parishad College of Engineering(Autonomous)",
    "Branch": "Mechanical Engineering Robotics",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/15c8f3a9-3021-4c3d-bdad-bc672389e209.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Product Development Engineer [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/allada-lokesh-1a0b36251/",
    "One liner Testimonial": "Never thought a Mechanical guy like me would crack an IT job… but here I am, starting as a Product Development Engineer at Phenom.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "16720fdb-ab2c-4f14-9ccf-59365dc6ded4",
    "slug": "16720fdb-ab2c-4f14-9ccf-59365dc6ded4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4dd527b41d7b7e5bf6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Aadya Katara",
    "College": "G.Pulla Reddy Engineering College ",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/16720fdb-ab2c-4f14-9ccf-59365dc6ded4.png",
    "Company Name": "HTC Global Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/htc-global-services.png",
    "Designation": "Software Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/aadya-katara/",
    "One liner Testimonial": "The first opportunity didn’t go through, but I stayed patient. Through NxtWave, I got another chance, and now I’m starting my first job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "17e6fdf4-dfac-4765-be6c-8ae0a4707eeb",
    "slug": "17e6fdf4-dfac-4765-be6c-8ae0a4707eeb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6416063ff2f8b13e8c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:44 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sri Harsha Mogilicharla",
    "College": "Tirumala Engineering College (TEC), Narasaraopeta",
    "Branch": "Computer Science Engineering (AI / ML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/17e6fdf4-dfac-4765-be6c-8ae0a4707eeb.png",
    "Company Name": "Actalyst",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/actalyst.png",
    "Designation": "Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/mogilicharla-sri-harsha-442266254/",
    "One liner Testimonial": "Before joining NxtWave, I didn’t have a clear idea of what to learn. Their roadmap gave me direction and helped me get placed at Actalyst.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "18593aab-405a-43f2-a21e-c5211bc6ead7",
    "slug": "18593aab-405a-43f2-a21e-c5211bc6ead7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d76165187f9bcdf350d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:02 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Chetla Arjun Naidu",
    "College": "Srinidhi Institute of Engineering andTechnology ",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/18593aab-405a-43f2-a21e-c5211bc6ead7.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/arjun-naidu-315136339/",
    "One liner Testimonial": "Hard work, persistence, and the right guidance truly pay off! After months of learning and practice with NxtWave, I’m thrilled to begin my journey with LTI Mindtree in CyberSecurity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "1a18e6a5-5e40-4eb4-8a4a-1faf9c7dc838",
    "slug": "1a18e6a5-5e40-4eb4-8a4a-1faf9c7dc838",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d70fe99411b5224ed4c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:56 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Satish Nemali",
    "College": "Vishnu Institute of Technology (VIT), Bhimavaram",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1a18e6a5-5e40-4eb4-8a4a-1faf9c7dc838.png",
    "Company Name": "SOL9X | AVTECHFIN",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/sol9x-|-avtechfin.png",
    "Designation": "MERN Stack Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/satish-nemali/",
    "One liner Testimonial": "While most of my classmates began learning coding in final year, I had already built projects and practiced through NxtWave.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "1f32d1c4-e994-40f7-8dcc-1d967fe86499",
    "slug": "1f32d1c4-e994-40f7-8dcc-1d967fe86499",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d397bba7243ec4522c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nadimidoddi Surya Kiran",
    "College": "Methodist College of Engineering & Technology (MCET), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1f32d1c4-e994-40f7-8dcc-1d967fe86499.png",
    "Company Name": "Ashling Partners",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ashling-partners.png",
    "Designation": "Associate L1 support consultant",
    "linkedin profile link": "https://www.linkedin.com/in/suryakirannadimidoddi/",
    "One liner Testimonial": "This is my first job, and it came after a long phase of learning and patience. NxtWave played a steady role in that journey.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "213ff2f3-3687-4158-9e24-470c23cc5018",
    "slug": "213ff2f3-3687-4158-9e24-470c23cc5018-6263c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcaa0e3d79c33239ff5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Feb 19 2026 04:01:24 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Feb 19 2026 04:01:38 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Charan Eggadi",
    "College": "Bharath University, Chennai",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/213ff2f3-3687-4158-9e24-470c23cc5018.png",
    "Company Name": "Probe 42",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/probe-42.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/saicharaneggadi/",
    "One liner Testimonial": "My campus offer never came through, so I kept trying. With NxtWave sharing opportunities and feedback, I finally landed a software role I didn’t even expect.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "7.5",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "217e69a5-57b3-40e9-b796-21b03f6d1ed4",
    "slug": "217e69a5-57b3-40e9-b796-21b03f6d1ed4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8c8428c65d6b54b0c5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jennu Suryateja",
    "College": "Rajiv Gandhi University of knowledge technologies, basar campus",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/217e69a5-57b3-40e9-b796-21b03f6d1ed4.png",
    "Company Name": "Tracxn",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/tracxn.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/suryateja-jennu-6011a8217/",
    "One liner Testimonial": "After quitting my first job, I felt stuck and unsure about my next step. One shot through NxtWave turned it around. Now I’m a Full Stack Developer at Tracxn.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "22079222-84e3-4cfc-beeb-ebdc16d9c701",
    "slug": "22079222-84e3-4cfc-beeb-ebdc16d9c701",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d3877ffd9058d1518d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Sesha Reddy Chundi",
    "College": "Narayana Engineering College (NEC), Gudur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/22079222-84e3-4cfc-beeb-ebdc16d9c701.png",
    "Company Name": "Kajkarma",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kajkarma.png",
    "Designation": "Full-Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sai-sesha-reddy/",
    "One liner Testimonial": "Recently joined as a Full-Stack Developer and things feel steady. After a brief break, NxtWave helped me get back on track with the right opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "22495144-312f-4877-b0e5-5952b9d9cd91",
    "slug": "22495144-312f-4877-b0e5-5952b9d9cd91",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6073ea97d4409cb29c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:40 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Seshu G",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), RK Valley",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/22495144-312f-4877-b0e5-5952b9d9cd91.png",
    "Company Name": "Parivartan Software & Multimedia Pvt. Ltd.",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/parivartan-software-&-multimedia-pvt.-ltd..png",
    "Designation": "React JS Developers",
    "linkedin profile link": "https://www.linkedin.com/in/seshu63/",
    "One liner Testimonial": "With consistent learning and mentorship from NxtWave, I finally turned my passion into a profession, joining Parivartan Software & Multimedia Pvt. Ltd. as a React JS Developer.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "230e610f-c297-483c-a51e-77a5e9101f16",
    "slug": "230e610f-c297-483c-a51e-77a5e9101f16",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8efe99411b5224ff88",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kethan Reddy Devireddy",
    "College": "Narsimha Reddy Engineering College (NRE), Secunderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/230e610f-c297-483c-a51e-77a5e9101f16.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/kethan-reddy212002?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "Watching my friend write Python code easily made me join NxtWave. Now, I’ve landed my first job at Cubic Corporation and feel confident in my skills.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "2543c78f-b1ce-4ebb-a4ca-f76a83d1c925",
    "slug": "2543c78f-b1ce-4ebb-a4ca-f76a83d1c925",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4a9519dfd06eb6ac88",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Prashant Iranna Jamagondi",
    "College": "BLDEA's V.P. Dr.P.G.Halakatti College of Engineering & Technology, Bijapur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2543c78f-b1ce-4ebb-a4ca-f76a83d1c925.png",
    "Company Name": "LPAR systems LLC",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lpar-systems-llc.png",
    "Designation": "Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/prashant-iranna-jamagondi-72a540287/",
    "One liner Testimonial": "Learning in my own language at NxtWave gave me the confidence to go from basics to building projects. Today, that effort helped me land a Fullstack Developer role at LPAR Systems",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "258255d7-77d2-46c7-8f72-9510560e1bed",
    "slug": "258255d7-77d2-46c7-8f72-9510560e1bed",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8a841b17e203b7da8e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nandu Ala",
    "College": "KL University, Guntur",
    "Branch": "Computer Science Engineering (Cyber Security)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/258255d7-77d2-46c7-8f72-9510560e1bed.png",
    "Company Name": "Image InfoSystems Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/image-infosystems-private-limited.png",
    "Designation": "Software Programmer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/nandu-ala/",
    "One liner Testimonial": "Joined NxtWave in my final year, improved my programming skills, and cracked my first job at Image InfoSystems. Couldn’t be happier with this start.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "2668235c-fa93-44c9-99a6-017affea4a2b",
    "slug": "2668235c-fa93-44c9-99a6-017affea4a2b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c8393f83b89a7c068c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mohammed Azad Ali",
    "College": "Jayalakshmi Institute of Technology",
    "Branch": "AI & Data Science",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2668235c-fa93-44c9-99a6-017affea4a2b.png",
    "Company Name": "Metayb",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/metayb.png",
    "Designation": "MERN Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/mohammed-azad-ali-developer?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "After trying for jobs for a long time, getting selected through NxtWave in my first attempt feels like a big relief and a good start for me.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.8",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "2905a441-5300-4468-9f54-5c4b671699eb",
    "slug": "2905a441-5300-4468-9f54-5c4b671699eb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8afe99411b5224fe12",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Madhu Sai Hemanth Nayani",
    "College": "Bapatla Engineering College (BEC), Bapatla",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2905a441-5300-4468-9f54-5c4b671699eb.png",
    "Company Name": "Kaara Info Systems",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kaara-info-systems.png",
    "Designation": "Trainee Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/madhunayani",
    "One liner Testimonial": "I joined NxtWave because I didn’t know where to start after graduation. It helped me gain real skills and confidence. Today, I’ve started my first job at Kaara Info Systems.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "29ca95a6-6ed0-4a3a-9c71-a298ce4c7efa",
    "slug": "29ca95a6-6ed0-4a3a-9c71-a298ce4c7efa",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c6efd8ad3adc66e40a547",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:42:37 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:27:38 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:28:56 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sanjeevan Thangaraj",
    "College": "Priyadarshini Institute of Technology (PIT), Kanuparthipadu",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/29ca95a6-6ed0-4a3a-9c71-a298ce4c7efa.png",
    "Company Name": "GVCC Solutions Private Limited ",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/gvcc-solutions-private-limited-.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sanjeevan-thangaraj/",
    "One liner Testimonial": "This is my first job, and it came after a lot of learning and trial. NxtWave helped me move faster and feel more confident.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Jan 02 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "2c467fe5-fa35-4b5a-90b3-142b986fbb14",
    "slug": "2c467fe5-fa35-4b5a-90b3-142b986fbb14",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d80c6a81cb06b2a5cca",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sasi Kumar Raju D ",
    "College": "Madanapalle Institute Of Technology & Science",
    "Branch": "MCA",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2c467fe5-fa35-4b5a-90b3-142b986fbb14.png",
    "Company Name": "Arizon Digital",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/arizon-digital.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sasi-kumar-raju/",
    "One liner Testimonial": "NxtWave’s structured learning and mentor guidance helped me build a solid foundation and begin my IT career as a Full Stack Developer at Arizon Digital.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "2df33dbc-4679-4d44-b3e2-45a25a6771bc",
    "slug": "2df33dbc-4679-4d44-b3e2-45a25a6771bc",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5773ea97d4409cac94",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:31 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rakesh Pabbathi",
    "College": "Visvesvaraya National Institute of Technology (VNIT), Nagpur",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2df33dbc-4679-4d44-b3e2-45a25a6771bc.png",
    "Company Name": "Plugseal Innovation Services Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/plugseal-innovation-services-private-limited.png",
    "Designation": "Frontend React.js Intern",
    "linkedin profile link": "https://www.linkedin.com/in/rakesh-pabbathi-80bb4b256/",
    "One liner Testimonial": "I started with almost no coding experience, but NxtWave’s structured guidance and constant support helped me build confidence and skills.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "2e4a8b16-0832-4e58-a242-fc7049f005ba",
    "slug": "2e4a8b16-0832-4e58-a242-fc7049f005ba",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d493f5ca641caa7c3d4",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sriram Marka",
    "College": "Vaagdevi Engineering College (VEC), Bollikunta",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2e4a8b16-0832-4e58-a242-fc7049f005ba.png",
    "Company Name": "GSPANN",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/gspann.png",
    "Designation": "Software Engineer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/sriram-marka/",
    "One liner Testimonial": "Happy to begin my professional journey at GSPANN! NxtWave’s guidance and mock interviews played a big role in landing my first job.",
    "Branch Filter": "About Classes",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "2ea43e85-155f-4d2a-9587-d60c390ed64b",
    "slug": "2ea43e85-155f-4d2a-9587-d60c390ed64b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d63fe99411b5224e592",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:43 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ashish ",
    "College": "VIT, Vellore",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2ea43e85-155f-4d2a-9587-d60c390ed64b.png",
    "Company Name": "Sutherland",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/sutherland.png",
    "Designation": "AI/ML Engineer/Data Scientist Fresher",
    "linkedin profile link": "https://www.linkedin.com/in/ashishpandey107?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I faced uncertainty after graduation, but NxtWave changed everything with the right guidance and opportunities. Now, I’m thrilled to begin my journey at Sutherland",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "2eca7063-3798-43c0-9bc2-0a538381b7f0",
    "slug": "2eca7063-3798-43c0-9bc2-0a538381b7f0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c4bc8d94379afcb2cf",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Lakshmi Priya Chilakalapudi",
    "College": "St Martin's Engineering College",
    "Branch": "Computer Science Engineering (AIML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2eca7063-3798-43c0-9bc2-0a538381b7f0.png",
    "Company Name": "Capgemini",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/capgemini.png",
    "Designation": "Analyst A4",
    "linkedin profile link": "https://www.linkedin.com/in/lakshmi-priya-729582292",
    "One liner Testimonial": "Starting my career at Capgemini feels exciting. NxtWave played an important role in helping me take this first step with confidence.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "2ff67a10-4abd-4a77-ace4-e7a44423755e",
    "slug": "2ff67a10-4abd-4a77-ace4-e7a44423755e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bce70fb6aced1b68cc0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Teja Sree Chitirala",
    "College": "Sri Venkateswara Engineering college, Tirupati",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2ff67a10-4abd-4a77-ace4-e7a44423755e.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/tejasree-chitirala-0b834422b",
    "One liner Testimonial": "I was confused about what to learn and how to prepare. NxtWave gave me a clear roadmap, strong basics, and the confidence to move towards a good tech role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "312c7a2b-4262-45b2-ad62-e7167a83983c",
    "slug": "312c7a2b-4262-45b2-ad62-e7167a83983c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d91ac57f86406559df1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Harshith Ayyapusetty",
    "College": "Malla Reddy University (MRU), Maisammaguda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/312c7a2b-4262-45b2-ad62-e7167a83983c.png",
    "Company Name": "Image InfoSystems Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/image-infosystems-private-limited.png",
    "Designation": "Software Programmer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/sai-harshith-061376259/",
    "One liner Testimonial": "My dad's friend suggested me to joined NxtWave. Today, I’m a Software Programmer Trainee at Image InfoSystems. Grateful for NxtWave's constant support and guidance.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "3144e57c-fd09-4eef-98cd-5eb6b1b6eda4",
    "slug": "3144e57c-fd09-4eef-98cd-5eb6b1b6eda4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d61ed62ac8a5b7fa439",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:41 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vijaya Power",
    "College": "Jawaharlal Nehru Technological University (JNTU), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3144e57c-fd09-4eef-98cd-5eb6b1b6eda4.png",
    "Company Name": "Prolifics Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/prolifics-corporation.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/power-vijaya-80a17a253/",
    "One liner Testimonial": "I’m very grateful to NxtWave for supporting me. With their help, I gained knowledge, confidence, and finally got placed at Prolifics Corporation.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "319c8144-2a13-4206-b698-64c7d00b4e74",
    "slug": "319c8144-2a13-4206-b698-64c7d00b4e74",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c6efe1dd0e15d34c306a7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:42:38 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:27:12 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:28:56 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Ram Polisetty",
    "College": "Narasaraopeta Engineering College",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/319c8144-2a13-4206-b698-64c7d00b4e74.png",
    "Company Name": "Aaro7",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aaro7.png",
    "Designation": "Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sairam-polisetty/",
    "One liner Testimonial": "I focused on building real skills instead of worrying about outcomes. Getting selected through NxtWave feels like a strong start for me.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Jan 02 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "32a66e93-3ca9-40bf-aa68-df4f8de5d5b3",
    "slug": "32a66e93-3ca9-40bf-aa68-df4f8de5d5b3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c6f9ba77ce404f39e6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Surya Sai Pranav Mortha",
    "College": "SRKR Engineering College (SRKREC), Bhimavaram",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/32a66e93-3ca9-40bf-aa68-df4f8de5d5b3.png",
    "Company Name": "Winfo Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/winfo-solutions.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/suryasaipranavmortha/",
    "One liner Testimonial": "NxtWave’s focused training and interview prep helped me convert learning into results. Starting my career as a Software Engineer feels like the right move.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "33e1dd12-2af1-4c7d-a9f0-b20e48e2f8e4",
    "slug": "33e1dd12-2af1-4c7d-a9f0-b20e48e2f8e4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5e8428c65d6b549a95",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:38 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "G v Hemashree",
    "College": "Shaskiya kakatiya Mahavidyalaya",
    "Branch": "BCA",
    "Graduate year": "2020",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/33e1dd12-2af1-4c7d-a9f0-b20e48e2f8e4.png",
    "Company Name": "LovasIT",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lovasit.png",
    "Designation": "Salesforce Developer",
    "linkedin profile link": "https://www.linkedin.com/in/g-v-h-235a29228/",
    "One liner Testimonial": "After years in teaching, I finally followed my passion for IT. Thanks to NxtWave, I’m now a Salesforce Developer at LovasIT, ready to build my dream career.",
    "Branch Filter": "Non - IT job to IT",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "Other",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "3457f78a-a1b3-4a76-a1a7-509e7f769d80",
    "slug": "3457f78a-a1b3-4a76-a1a7-509e7f769d80",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d50fe99411b5224d870",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vasireddy Vignesh",
    "College": "Vignan University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3457f78a-a1b3-4a76-a1a7-509e7f769d80.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/vignesh-vasireddy-581266294/",
    "One liner Testimonial": "I was unsure about my path after graduation until NxtWave opened opportunities for me. Now, I’m thrilled to begin my career at HighRadius as SDE-1.",
    "Branch Filter": "High package",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "34986b0f-aa0a-4ce8-b835-2c344735c991",
    "slug": "34986b0f-aa0a-4ce8-b835-2c344735c991-0a7ba",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d673c94da715b13097",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:30 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Abhisikta Moharana",
    "College": "National Institute of Technology Rourkela",
    "Branch": "Biotechnology",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/34986b0f-aa0a-4ce8-b835-2c344735c991.png",
    "Company Name": "Vyapar",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/vyapar.png",
    "Designation": "Data Analyst",
    "linkedin profile link": "https://www.linkedin.com/in/abhisikta-moharana-983052270/",
    "One liner Testimonial": "Switching from biotechnology to a tech role wasn’t easy, but NxtWave helped make it possible. Happy with how this new chapter has started.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "35929d17-aba9-401c-aa01-c49c0665e2da",
    "slug": "35929d17-aba9-401c-aa01-c49c0665e2da",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d492aea3343ba27f38d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Charan Aedurinti",
    "College": "Ananthalakshmi Institute of Technology and Sciences",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/35929d17-aba9-401c-aa01-c49c0665e2da.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Product Development Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/saicharan-aedurinti/",
    "One liner Testimonial": "The guidance and training I received from NxtWave helped me achieve what once felt impossible. Now, I’m proud to begin my journey at Phenom as a Product Development Engineer.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "35dd1402-8e27-48ea-80fe-f54d93c1b3a4",
    "slug": "35dd1402-8e27-48ea-80fe-f54d93c1b3a4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7ec6a81cb06b2a5b06",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ramcharan Maram",
    "College": "Bharath Institute of Higher Education & Research (BIHER), Chennai",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/35dd1402-8e27-48ea-80fe-f54d93c1b3a4.png",
    "Company Name": "Innomax IT Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innomax-it-solutions.png",
    "Designation": "UI Developer",
    "linkedin profile link": "https://www.linkedin.com/in/ramcharan-maram-996b022aa/",
    "One liner Testimonial": "What started as a flexible online learning choice became the turning point. NxtWave’s support helped me earn my first UI Developer opportunity at Innomax.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "36ebc7a5-5d1e-4707-a7b3-a9b8cf365f59",
    "slug": "36ebc7a5-5d1e-4707-a7b3-a9b8cf365f59",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d397bba7243ec45244",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Chittibomma Vara Prasanna Parvathi",
    "College": "Vignana Bharathi Institute of Technology",
    "Branch": "Computer Science Engineering (Data Science)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/36ebc7a5-5d1e-4707-a7b3-a9b8cf365f59.png",
    "Company Name": "Accedepro Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/accedepro-private-limited.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/chittibomma-vara-prasanna-parvathi-10b217256/",
    "One liner Testimonial": "I liked how straightforward things were through NxtWave. Getting this software role feels aligned with the experience I’ve built so far.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "3936bc7d-8035-4e94-ac50-58773680ac3c",
    "slug": "3936bc7d-8035-4e94-ac50-58773680ac3c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d508171333ccee0a0d6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vuddagiri Prahasith",
    "College": "Jawaharlal Nehru Technological University -Gurjada Vizinagaram",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3936bc7d-8035-4e94-ac50-58773680ac3c.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/prahasithvuddagiri63/",
    "One liner Testimonial": "NxtWave’s guidance helped me secure my first job as SDE-1 at HighRadius. This journey taught me the value of persistence and believing in yourself.",
    "Branch Filter": "Tests/Exams",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "39dd764f-7735-4689-9470-e8e61e732844",
    "slug": "39dd764f-7735-4689-9470-e8e61e732844",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8e8171333ccee0abdd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pavan Nagula",
    "College": "Malla Reddy Institute of Engineering & Technology (MRIET) - Maisammaguda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/39dd764f-7735-4689-9470-e8e61e732844.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/pavan-nagula/",
    "One liner Testimonial": "I was still in the middle of my NxtWave course when I cracked my first job at Cubic Corporation. The guidance and timely placement support made a huge difference.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "3becbcdc-f6de-46ac-bdae-2850ef837843",
    "slug": "3becbcdc-f6de-46ac-bdae-2850ef837843",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7cf82afe19cb47b65d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manjunath Dk",
    "College": "PES University (PU), Bengaluru",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3becbcdc-f6de-46ac-bdae-2850ef837843.png",
    "Company Name": "InferWorks",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/inferworks.png",
    "Designation": "Associate Fullstack Consultant",
    "linkedin profile link": "https://www.linkedin.com/feed/update/urn:li:activity:7383392830041493504/",
    "One liner Testimonial": "Joined NxtWave after seeing a friend learn there. The focused skill training helped me crack my first interview and land an Associate Fullstack Consultant role at InferWorks.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "3f9fda16-84bf-4b5d-8aae-ca946bb10e22",
    "slug": "3f9fda16-84bf-4b5d-8aae-ca946bb10e22",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d801c890ccb664679b6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anjali Chimata",
    "College": "Sri Sai Degree College ",
    "Branch": "Computer Science ",
    "Graduate year": "2020",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3f9fda16-84bf-4b5d-8aae-ca946bb10e22.png",
    "Company Name": "Arizon Digital",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/arizon-digital.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/anjalichimata520741/",
    "One liner Testimonial": "Balancing motherhood, responsibilities, and learning wasn’t easy, but with NxtWave’s support I restarted my career and became a Full Stack Developer.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BSc",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "3fbba2a0-a882-467d-88a1-829d119cd85d",
    "slug": "3fbba2a0-a882-467d-88a1-829d119cd85d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d751e4d55548e4bd90b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:01 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bogasamudram V Pavan Kumar Reddy",
    "College": "Laki Reddy Bali Reddy College of Engineering ",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3fbba2a0-a882-467d-88a1-829d119cd85d.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/pavansprofile/",
    "One liner Testimonial": "Joining NxtWave was the turning point as it helped me turn hard work into reality. Proud to begin my journey as a Graduate Cyber Security Trainee at LTI Mindtree.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "40b62b0a-3edb-43ad-9395-3f869f2fc745",
    "slug": "40b62b0a-3edb-43ad-9395-3f869f2fc745",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d679519dfd06eb6b2cf",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:47 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sandeep Indugula",
    "College": "Dr. Paul Raj Engineering College (DPREC), Yetapaka",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/40b62b0a-3edb-43ad-9395-3f869f2fc745.png",
    "Company Name": "AspireNext Academy Pvt Ltd",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aspirenext-academy-pvt-ltd.png",
    "Designation": "Full Stack Developer [Offline Drive]",
    "linkedin profile link": "https://www.mouthshut.com/review/nxtwave-review-luomurssoop",
    "One liner Testimonial": "My brother completed a program with NxtWave and got a job, so I joined too. Their guidance helped me get placed at AspireNext Academy as a Full Stack Developer.",
    "Branch Filter": "Online Advantage",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "40f4b8c7-19a6-4d2e-aeb6-b5d68683a8c4",
    "slug": "40f4b8c7-19a6-4d2e-aeb6-b5d68683a8c4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d69be3771f17d265af6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:49 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Aryan Jaiswal",
    "College": "Indian Institute of Information Technology (IIIT), Dharwad",
    "Branch": "Computer Science Engineering (AI / ML)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/40f4b8c7-19a6-4d2e-aeb6-b5d68683a8c4.png",
    "Company Name": "Exotel",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/exotel.png",
    "Designation": "Tech Intern",
    "linkedin profile link": "https://www.linkedin.com/in/aryanjstar/",
    "One liner Testimonial": "I didn’t get success in my campus placements, but through NxtWave’s support, I got this opportunity at Exotel. I’m really happy about it.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "12",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "4128748e-caa2-45b7-bbb4-176955ee6d6c",
    "slug": "4128748e-caa2-45b7-bbb4-176955ee6d6c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d95779eeb394c441020",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:33 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Naga Anvesh Sodisetti",
    "College": "Bonam Venkata Chalamayya Engineering College (BVCEC), Odalarevu",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2017",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/4128748e-caa2-45b7-bbb4-176955ee6d6c.png",
    "Company Name": "Innomick",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innomick.png",
    "Designation": "Fullstack Developer ",
    "linkedin profile link": "https://www.linkedin.com/in/anvesh-software/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I’m an EEE graduate and started coding only after NxtWave. It took time, but the learning helped me crack a Fullstack role at Innomick.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "444c1943-44b8-421f-876c-e3af44c95977",
    "slug": "444c1943-44b8-421f-876c-e3af44c95977",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c8747236110ec19700",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sampath Zakkula",
    "College": "ACE Engineering College (ACE), Ghatkesar",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/444c1943-44b8-421f-876c-e3af44c95977.png",
    "Company Name": "Metayb",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/metayb.png",
    "Designation": "MERN Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/zakkulasampath/",
    "One liner Testimonial": "I didn’t know coding properly before NxtWave. After learning there, I felt ready for interviews and now I’m starting my first job as a MERN developer.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.8",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "44a56b3b-1327-482f-80c9-ce72fe58754e",
    "slug": "44a56b3b-1327-482f-80c9-ce72fe58754e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6d9896b863004e8247",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:53 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Suhana Bhanu Earla",
    "College": "Mohan Babu University (MBU), Tirupati",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/44a56b3b-1327-482f-80c9-ce72fe58754e.png",
    "Company Name": "Lexora Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lexora-technologies.png",
    "Designation": "Software Development Intern",
    "linkedin profile link": "https://www.linkedin.com/in/earla-suhana-bhanu/",
    "One liner Testimonial": "With NxtWave’s guidance, I went from learning coding basics to cracking my first internship at Lexora Technologies. It feels amazing to apply what I’ve learned!",
    "Branch Filter": "NxtWave Features",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "44fdfce7-46fb-498c-a77e-14a027ba0a0b",
    "slug": "44fdfce7-46fb-498c-a77e-14a027ba0a0b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcf7dcdc579b1d9a87e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Datta Gollapudi",
    "College": "MNR College of Engineering & Technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/44fdfce7-46fb-498c-a77e-14a027ba0a0b.png",
    "Company Name": "Delta Technology and Management Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/delta-technology-and-management-services.png",
    "Designation": "Associate Consultant ",
    "linkedin profile link": "https://www.linkedin.com/in/gsvva-datta/",
    "One liner Testimonial": "I started with a non-IT role, kept learning through NxtWave, and continued applying. Now I’ve been shortlisted for a tech role it feels good to see things moving forward.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "45cc31d3-9fa3-4541-9dbb-ad1698d00b08",
    "slug": "45cc31d3-9fa3-4541-9dbb-ad1698d00b08",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d74165187f9bcdf33fd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:00 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sambasivarao Prathipati",
    "College": "Vasireddy Venkatadri Institute of Technology",
    "Branch": "Computer Science Engineering (Cyber Security)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/45cc31d3-9fa3-4541-9dbb-ad1698d00b08.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/sambasivarao-prathipati-516b1622b/",
    "One liner Testimonial": "Excited to start my career with LTI Mindtree. A big thanks to NxtWave for their constant support and guidance throughout my journey.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "45f45460-0aac-4e55-badb-3cae63749a5b",
    "slug": "45f45460-0aac-4e55-badb-3cae63749a5b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c5747236110ec19513",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "R.Bhanu Prakash Repaka",
    "College": "Siddhartha Institute of Technology and Sciences (SITS), Narapally,Telangana",
    "Branch": "Software Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/45f45460-0aac-4e55-badb-3cae63749a5b.png",
    "Company Name": "DataGaps",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/datagaps.png",
    "Designation": "Associate Developer [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/bhanu-repaka/",
    "One liner Testimonial": "Choosing NxtWave early in my journey helped me build strong fundamentals through projects, and that confidence played a key role in starting my career as a developer.",
    "Branch Filter": "others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "478f7383-261f-4857-bf25-fcacc04da13c",
    "slug": "478f7383-261f-4857-bf25-fcacc04da13c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6c9896b863004e81d6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:52 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Viswateja Tummala",
    "College": "Parul Institute of Engg. And Technology (PIET), Limda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/478f7383-261f-4857-bf25-fcacc04da13c.png",
    "Company Name": "Smarter.Codes",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/smarter.codes.png",
    "Designation": "Full Stack Developer ",
    "linkedin profile link": "https://www.linkedin.com/in/viswateja-tummala/",
    "One liner Testimonial": "The mock interviews, projects, and guidance at NxtWave turned my learning into confidence and that confidence got me my first job",
    "Branch Filter": "About Classes",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "7",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "49425ad2-ca57-4bab-93f0-1af16614610a",
    "slug": "49425ad2-ca57-4bab-93f0-1af16614610a",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d78c6a81cb06b2a5686",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:04 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Daveed Gangi",
    "College": "Avanthi Institute Of Engineering & Technology, Abdullahpurmet",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2021",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/49425ad2-ca57-4bab-93f0-1af16614610a.png",
    "Company Name": "Global Orizon",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/global-orizon.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/g-daveed-365958190/",
    "One liner Testimonial": "The practical learning approach and structured curriculum helped me learn things and apply them effectively. Really happy to share that I’ve received a job offer as a Full Stack Developer",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "4c1fd773-af4d-4463-bce3-70ccdc163fee",
    "slug": "4c1fd773-af4d-4463-bce3-70ccdc163fee",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7f73ea97d4409cc5d1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Saniya Chandpasha",
    "College": "Malla Reddy College of Engineering For Women (MRCEW), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/4c1fd773-af4d-4463-bce3-70ccdc163fee.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Software Engineer Trainee ",
    "linkedin profile link": "https://www.linkedin.com/in/saniyachand/",
    "One liner Testimonial": "Daily progress update, mock interviews, and hands-on practice at NxtWave boosted my confidence and helped me crack the Software Engineer Trainee role at Phenom.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "4fe408d3-7fd6-4999-bc6b-c81e05a8fe8b",
    "slug": "4fe408d3-7fd6-4999-bc6b-c81e05a8fe8b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70ce7bdc54fe30b4e2df",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anthony Gopu",
    "College": "Vignana Bharathi Institute of Technology (VBIT), Ghatkesar",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/4fe408d3-7fd6-4999-bc6b-c81e05a8fe8b.png",
    "Company Name": "Jaihokisan",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/jaihokisan.png",
    "Designation": "MERN Developer",
    "linkedin profile link": "https://www.linkedin.com/in/anthony-reddy-439223257/",
    "One liner Testimonial": "NxtWave felt less like a course and more like practice for real work. Starting my first job as a MERN developer now feels like a natural continuation of that work.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "50526ccd-a746-4ae8-8282-e8dc05704cd6",
    "slug": "50526ccd-a746-4ae8-8282-e8dc05704cd6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70cd7bdc54fe30b4e136",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kowshik Chamala",
    "College": "Parul Institute of Engg. And Technology (PIET), Limda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/50526ccd-a746-4ae8-8282-e8dc05704cd6.png",
    "Company Name": "MediaNV",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/medianv.png",
    "Designation": "MERN Stack developer",
    "linkedin profile link": "https://www.linkedin.com/in/kowshik-reddy-chamala-ab367825b/",
    "One liner Testimonial": "I trusted a friend’s suggestion and joined NxtWave. That decision helped me find direction and start my career as a MERN Stack Developer.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "510fa9c4-bd77-47df-811b-ad586ad504ab",
    "slug": "510fa9c4-bd77-47df-811b-ad586ad504ab",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70977bdc54fe30b4bf29",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:49:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Safura Tehreen",
    "College": "Appa Institute of Engineering and Technology ",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/510fa9c4-bd77-47df-811b-ad586ad504ab.png",
    "Company Name": "Capgemini",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/capgemini.png",
    "Designation": "Analyst A4",
    "linkedin profile link": "https://www.linkedin.com/in/safura-tehreen-91434127a/",
    "One liner Testimonial": "When college placements didn’t give much hope, NxtWave really helped. Getting placed now gives me confidence that I can stand on my own feet.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "525af6c7-1576-413b-a2fd-9152468a0af4",
    "slug": "525af6c7-1576-413b-a2fd-9152468a0af4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bce92fac925ba80d971",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pothagouni Madhav Goud",
    "College": "Vellore Institute of Technology (VIT), Vellore",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/525af6c7-1576-413b-a2fd-9152468a0af4.png",
    "Company Name": "Omni Reach",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/omni-reach.png",
    "Designation": "Junior Java Developer",
    "linkedin profile link": "https://www.linkedin.com/in/madhav-potha-gouni-4a3aa3279/",
    "One liner Testimonial": "I lost my first job due to layoffs, came back to NxtWave, stayed focused on learning and now I’ve got another tech role. That support really mattered.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "5bc96545-060a-4f5e-b1e8-b7c8da935f52",
    "slug": "5bc96545-060a-4f5e-b1e8-b7c8da935f52",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7c1c890ccb66467855",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Avinash Gummadi",
    "College": "University of Bridgeport",
    "Branch": "Electrical Engineering",
    "Graduate year": "2015",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5bc96545-060a-4f5e-b1e8-b7c8da935f52.png",
    "Company Name": "LovasIT",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lovasit.png",
    "Designation": "Oracle CPQ Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/sai-avinash-gummadi-ba709012b/",
    "One liner Testimonial": "After 8 years in Capgemini, I joined NxtWave casually and wasn’t consistent initially, but the learning strengthened my skills and helped me land an Oracle CPQ Trainee role at LovasIT.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MS/MSc",
    "Package in lpa": "6.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "5cb0c124-a984-484a-88d3-6782e5d3067d",
    "slug": "5cb0c124-a984-484a-88d3-6782e5d3067d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d93ac57f86406559ef1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:31 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pantula Durga Naga Kameswara Vijay",
    "College": "VKR, VNB & AGK College of Engineering (VKR), Gudivada",
    "Branch": "AI & Data Science",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5cb0c124-a984-484a-88d3-6782e5d3067d.png",
    "Company Name": "Digitap.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/digitap.ai.png",
    "Designation": "Python Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/vijay-pantula-85785a264/?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "One liner Testimonial": "I was learning on my own before NxtWave. The learning, structure, mocks, and placement support helped me land this Python role at Digitap.ai.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "20k",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "5e0a0fd6-1ef8-43c1-90b9-aba0912ecef1",
    "slug": "5e0a0fd6-1ef8-43c1-90b9-aba0912ecef1",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8dc6a81cb06b2a63fc",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Durga Prasad Tadi",
    "College": "Vignan University, Guntur",
    "Branch": "MCA (Master of Computer Application)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5e0a0fd6-1ef8-43c1-90b9-aba0912ecef1.png",
    "Company Name": "LMV Financial Services Pvt Ltd",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lmv-financial-services-pvt-ltd.png",
    "Designation": "Jr. Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/durgaprasadtadi/",
    "One liner Testimonial": "I spent months trying other institutes and still felt stuck. Joining NxtWave changed everything. The support and learning gave me confidence. Now, I’ve landed my first IT job at LMV.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "5e5c708a-8c4d-4219-bd71-1a9cd206646e",
    "slug": "5e5c708a-8c4d-4219-bd71-1a9cd206646e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d96c6a81cb06b2a6954",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:34 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mahesh Veeraboina",
    "College": "Holy Mary Institute of Technology and Science (HMITS), Keesara",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5e5c708a-8c4d-4219-bd71-1a9cd206646e.png",
    "Company Name": "OpenScale",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/openscale.png",
    "Designation": "Software Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/mahesh-veeraboina/",
    "One liner Testimonial": "I joined NxtWave in my final year, stayed consistent, and finally got my first job as a Software Engineer Intern.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "5f07632a-19c3-4301-938d-fafcf0175e4f",
    "slug": "5f07632a-19c3-4301-938d-fafcf0175e4f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c5f9ba77ce404f3935",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vinay Malyala",
    "College": "Raghu Engineering College (REC), Dakamarri",
    "Branch": "Computer Science Engineering (Data Science)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5f07632a-19c3-4301-938d-fafcf0175e4f.png",
    "Company Name": "DataGaps",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/datagaps.png",
    "Designation": "Associate Developer ",
    "linkedin profile link": "https://www.linkedin.com/in/vinay-malyala-7bbaa1240/",
    "One liner Testimonial": "Getting selected as an Associate Developer feels rewarding. NxtWave helped me build strong fundamentals and consistency that made me confident in interviews.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "5f4650c0-946c-4148-9ece-89e23a249929",
    "slug": "5f4650c0-946c-4148-9ece-89e23a249929",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d66fe99411b5224e6de",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:46 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mohan Pannala",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), Basar",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5f4650c0-946c-4148-9ece-89e23a249929.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Software Engineer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/mohan-pannala-669860244/",
    "One liner Testimonial": "I joined NxtWave during my B.Tech when I couldn’t get the CSE branch. Their clear roadmap, and practice modules helped me build strong coding foundations.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "610d0c8e-195c-4b1a-8f3d-c1fc99ff5123",
    "slug": "610d0c8e-195c-4b1a-8f3d-c1fc99ff5123",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d2ce07f30ea78611a1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bhargav Sunil Yalamati",
    "College": "Bonam Venkata Chalamayya Engineering College (BVCEC)",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/610d0c8e-195c-4b1a-8f3d-c1fc99ff5123.png",
    "Company Name": "RapidCareGroup",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/rapidcaregroup.png",
    "Designation": "Fullstack AI Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/bhargav-sunil-yalamati/",
    "One liner Testimonial": "From being unsure about coding to working as a Fullstack AI intern, my journey at NxtWave gave me the confidence to make this shift.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 31 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "635abf12-32ad-4580-a685-2419d7922eeb",
    "slug": "635abf12-32ad-4580-a685-2419d7922eeb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d57bdc54fe30b4e8ad",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Gangavarapu Uday Kumar Reddy",
    "College": "R.V.R. & J.C.College of Engineering",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/635abf12-32ad-4580-a685-2419d7922eeb.png",
    "Company Name": "DigitalTrust Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/digitaltrust-technologies.png",
    "Designation": "Software Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/gukr/",
    "One liner Testimonial": "Getting placed through NxtWave in my very first application feels exciting. Happy to start my career alongside a friend in the same company.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "638f66b6-8bd0-40f5-8d0b-726ee448e745",
    "slug": "638f66b6-8bd0-40f5-8d0b-726ee448e745",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5ff82afe19cb47a795",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:39 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nikhil Kumar",
    "College": "Vellore Institute of Technology, Bhopal",
    "Branch": "Computer Science Engineering (AI / ML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/638f66b6-8bd0-40f5-8d0b-726ee448e745.png",
    "Company Name": "Leadsquard",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/leadsquard.png",
    "Designation": "Software Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/nikhil-kumar-730470271/",
    "One liner Testimonial": "I’ve joined LeadSquared as a Software Engineer Intern! A huge thanks to NxtWave for guiding me, keeping me consistent, and helping me navigate placements with confidence.",
    "Branch Filter": "High package",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "64682fac-bbd9-4e90-a7d8-c34637bd477c",
    "slug": "64682fac-bbd9-4e90-a7d8-c34637bd477c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bd244b1e57e5c08622f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jagadesh Kumar Sangani",
    "College": "Aditya Degree College, Amalapuram",
    "Branch": "Computer Science",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/64682fac-bbd9-4e90-a7d8-c34637bd477c.png",
    "Company Name": "Effigent Software Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/effigent-software-solutions.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/jagadesh-kumar-sangani-b7aa93204/",
    "One liner Testimonial": "After working in sales and odd jobs for years, I trusted NxtWave and cracked my first tech interview. This is my first IT job and it feels really good.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BSc",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "657bba00-1a6c-4c3a-b033-4791e3d9d716",
    "slug": "657bba00-1a6c-4c3a-b033-4791e3d9d716",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9f6643bc5e93ae4e4e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:43 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kavya D M",
    "College": "Shridevi Degree College",
    "Branch": "BCA (Bachelor of Computer Applications)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/657bba00-1a6c-4c3a-b033-4791e3d9d716.png",
    "Company Name": "Media Nv",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/media-nv.png",
    "Designation": "MERN Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/kavya-d-m-2003dm/",
    "One liner Testimonial": "I got selected once and then heard nothing. That’s when I knew I needed real skills, not hope. NxtWave helped me restart properly.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BCA",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "65b5ed20-c4c3-4091-a6c4-8c8694c682db",
    "slug": "65b5ed20-c4c3-4091-a6c4-8c8694c682db",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d45fe99411b5224d062",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Chilveri Prathamesh",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), Basara",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/65b5ed20-c4c3-4091-a6c4-8c8694c682db.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Product Development Engineer [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/chilveri-prathamesh-369b51258/",
    "One liner Testimonial": "Balancing college and NxtWave wasn’t easy, but I stayed consistent. That journey helped me crack my very first interview and get placed at Phenom.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "66291506-7fb1-4058-a31b-ab0b5a2c5567",
    "slug": "66291506-7fb1-4058-a31b-ab0b5a2c5567",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bce50f4b2bc0b066690",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Karlapalepu Lakshmi Saisri",
    "College": "Prasad V. Potluri Siddhartha Institute of Technology (PVPSIT), Kanuru",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2021",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/66291506-7fb1-4058-a31b-ab0b5a2c5567.png",
    "Company Name": "Bhasaka Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/bhasaka-technologies.png",
    "Designation": "Java Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/lakshmi-saisri-k-727693242?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I’m from an EEE background with a long career gap. Through NxtWave, I built tech skills and now I’m finally starting my first job as a developer.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "66900a8b-d07e-4219-a16a-d9d16efe54e3",
    "slug": "66900a8b-d07e-4219-a16a-d9d16efe54e3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4da1c0fec2a5ea702f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Charan Srinivas Ramisetty",
    "College": "Malla Reddy University (MRU), Maisammaguda",
    "Branch": "Computer Science Engineering (AIML)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/66900a8b-d07e-4219-a16a-d9d16efe54e3.png",
    "Company Name": "DiligenceVault",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/diligencevault.png",
    "Designation": "Software Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/charansrinivas99/",
    "One liner Testimonial": "I did internships, kept learning, and waited for the right opportunity. My first interview through NxtWave worked out, and I’m happy with how things are moving.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "67eadc0d-7c88-41e6-ae4c-f108ca046dcf",
    "slug": "67eadc0d-7c88-41e6-ae4c-f108ca046dcf",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d831c890ccb66467b6e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pallavi Gonepalli",
    "College": "Dhanekula Institute of Engineering & Technology (DIET), Ganguru",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/67eadc0d-7c88-41e6-ae4c-f108ca046dcf.png",
    "Company Name": "Innomax IT Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innomax-it-solutions.png",
    "Designation": "UI Developer",
    "linkedin profile link": "https://www.linkedin.com/in/pallavi-gonepalli/",
    "One liner Testimonial": "A senior’s recommendation led me to NxtWave. From zero-level learning to confident interviews with NxtMock, the support helped me secure my UI Developer role at Innomax.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "69014ae0-cf09-4d4b-b133-cd8aaba14b1c",
    "slug": "69014ae0-cf09-4d4b-b133-cd8aaba14b1c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5f8171333ccee0a4c9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:39 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kodanda Venkata Ramakrishna Nakka",
    "College": "National Institute of Technology Mizoram (NIT), Chaltlang",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/69014ae0-cf09-4d4b-b133-cd8aaba14b1c.png",
    "Company Name": "DeepKlarity",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/deepklarity.png",
    "Designation": "Intern",
    "linkedin profile link": "https://www.linkedin.com/in/ramakrishna-n-k-v/",
    "One liner Testimonial": "Balancing college and learning coding from scratch wasn’t easy, but consistency paid off. Grateful to NxtWave for the guidance that helped me secure my first IT role at DeepKlarity.",
    "Branch Filter": "About Classes",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "69613471-b81c-4c6d-86fb-ff422cbb9814",
    "slug": "69613471-b81c-4c6d-86fb-ff422cbb9814",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c98ad3adc66e4281ca",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nand Narayan Singh",
    "College": "National Institute of Technology Agartala",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/69613471-b81c-4c6d-86fb-ff422cbb9814.png",
    "Company Name": "Isimplexity",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/isimplexity.png",
    "Designation": "MERN Full Stack",
    "linkedin profile link": "https://www.linkedin.com/in/nand-narayan-singh-7167b2230/",
    "One liner Testimonial": "I had already done a 6-month internship, and this role feels like the right next step. Things finally moved once I started applying through NxtWave.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "69754445-16e5-4ce9-95fb-ab52b355df30",
    "slug": "69754445-16e5-4ce9-95fb-ab52b355df30",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d84e70849ff1fc20398",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Srivastav Ramineni",
    "College": "DVR & Dr. HS MIC College of Technology, Kanchikacherla",
    "Branch": "Artificial Intelligence and Data Science",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/69754445-16e5-4ce9-95fb-ab52b355df30.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/srivastav-ramineni/",
    "One liner Testimonial": "Balancing farm work and learning wasn’t easy, but NxtWave’s structured training and constant support helped me stay on track. Today, I’m proud to start as a Software Engineer at LovasIT.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "6b2551ab-0b12-4558-8b34-3ddd9d1dab8b",
    "slug": "6b2551ab-0b12-4558-8b34-3ddd9d1dab8b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c7ce07f30ea7860ef6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rushi Bokka",
    "College": "Sri Vasavi Engineering College",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6b2551ab-0b12-4558-8b34-3ddd9d1dab8b.png",
    "Company Name": "Jaihokisan",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/jaihokisan.png",
    "Designation": "UI/ MERN Developer",
    "linkedin profile link": "https://www.linkedin.com/in/rushi-b-bb5708254/",
    "One liner Testimonial": "I’m from an EEE background, but I always liked web development. Happy to start my career as a UI/MERN Developer.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "6cabac56-af62-455f-8d68-79c7284f9684",
    "slug": "6cabac56-af62-455f-8d68-79c7284f9684",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c773c94da715b12934",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Samineni Sai Deepthi",
    "College": "Sri Indu College of Engineering & Technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6cabac56-af62-455f-8d68-79c7284f9684.png",
    "Company Name": "Agivant Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/agivant-technologies.png",
    "Designation": "Associate Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/saideepthi-samineni/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I secured my Associate Engineer role through focused interview preparation. My learning and practice with NxtWave helped me convert this opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.2",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "6cc4d8ff-f1cf-4cf1-9ba6-3931419b5090",
    "slug": "6cc4d8ff-f1cf-4cf1-9ba6-3931419b5090",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4f918f5cf3ea5f8c93",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bommina Srinivasarao",
    "College": "Lakireddy Bali Reddy College of Engineering, Vizag",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6cc4d8ff-f1cf-4cf1-9ba6-3931419b5090.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/srinivasarao-bommina/",
    "One liner Testimonial": "After facing tough days and many rejections, this placement at HighRadius feels like a dream come true. NxtWave’s mentorship and constant support made this achievement possible.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "6e540051-dc3a-4804-962b-716d4b7ba99d",
    "slug": "6e540051-dc3a-4804-962b-716d4b7ba99d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7473ea97d4409cbe5a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:00 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Boddu Gowri Priya",
    "College": "Nalla Malla Reddy Engineering College",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6e540051-dc3a-4804-962b-716d4b7ba99d.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/gowripriya-yadav/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "From learning the basics of tech to landing my first IT job at LTI Mindtree. Big thanks to NxtWave for their mentorship, workshops, and constant guidance.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "6e95968f-341a-4e69-ac82-1355ee5271a3",
    "slug": "6e95968f-341a-4e69-ac82-1355ee5271a3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d85fe99411b5224fb3d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Kiran Devara",
    "College": "G. Pullaiah College of Engineering and Technology (GPCET), Kurnool",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6e95968f-341a-4e69-ac82-1355ee5271a3.png",
    "Company Name": "Ashling Partners",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ashling-partners.png",
    "Designation": "Associate L1 Support Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/devara-sai-kiran-4b7514257/",
    "One liner Testimonial": "I tried so many times and failed, but I didn’t stop. With NxtWave’s support, I finally got my first IT job at Ashling Partners. Seeing my parents proud makes all the pain worth it.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "6f63775d-e26d-4fff-a627-e216624d6c59",
    "slug": "6f63775d-e26d-4fff-a627-e216624d6c59",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5c73ea97d4409caec0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:36 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Lakshmeepathi Nakka",
    "College": "Vishnu Institute of Technology (VIT), Bhimavaram",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6f63775d-e26d-4fff-a627-e216624d6c59.png",
    "Company Name": "Actalyst",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/actalyst.png",
    "Designation": "Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/lakshmeepathinakka/",
    "One liner Testimonial": "Thanks to NxtWave, not just for teaching, but for keeping me on track when I started doubting myself. Today, I’ve joined Actalyst as a Software Developer.",
    "Branch Filter": "NxtWave Features",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "7377d3eb-a383-4943-b20f-bab76305bdb9",
    "slug": "7377d3eb-a383-4943-b20f-bab76305bdb9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d57165187f9bcdf2230",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:31 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Yaswanth Bolisetty",
    "College": "Lovely Professional University (LPU), Phagwara",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7377d3eb-a383-4943-b20f-bab76305bdb9.png",
    "Company Name": "fxis.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fxis.ai.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/yaswanthbb/",
    "One liner Testimonial": "After graduating, I joined NxtWave on my sister’s suggestion. The structured learning and constant support helped me build strong web development skills.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "#REF!",
    "Package in lpa": "#REF!",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "7377d3eb-a383-4943-b20f-bab76305bdb9",
    "slug": "7377d3eb-a383-4943-b20f-bab76305bdb9-d3dbd",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8a791fa4c2fcaf770b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Yaswanth Bolisetty",
    "College": "Lovely Professional University (LPU), Phagwara",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7377d3eb-a383-4943-b20f-bab76305bdb9.png",
    "Company Name": "Media Nv",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/media-nv.png",
    "Designation": "Associate FullStack Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/yaswanthbb/",
    "One liner Testimonial": "I used to learn from my sister’s NxtWave portal, but joining myself made all the difference. Now I’ve landed my first job at Media Nv, and my parents are proud we both made it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "73c78911-c674-464b-b32d-252e28d79002",
    "slug": "73c78911-c674-464b-b32d-252e28d79002",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d73e70849ff1fc1f13a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:59 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bairy Vishnu Vardhan",
    "College": "Trinity college of Engineering ",
    "Branch": "Artificial Intelligence and Machine Learning",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/73c78911-c674-464b-b32d-252e28d79002.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/bairy-vishnu-vardhan/",
    "One liner Testimonial": "Thrilled to share that I’ve started my career as a Graduate Engineer Trainee at LTI Mindtree! Grateful to NxtWave for the mentorship, mock interviews, and guidance that made this possible.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Oct 24 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "73e186c2-3e85-481e-a868-bcc7bf19bb47",
    "slug": "73e186c2-3e85-481e-a868-bcc7bf19bb47",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4a2d73edb6b05c4c38",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Ram Kottu",
    "College": "Dhanekula Institute of Engineering & Technology (DIET), Ganguru",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/73e186c2-3e85-481e-a868-bcc7bf19bb47.png",
    "Company Name": "Niroggyan",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/niroggyan.png",
    "Designation": "Frontend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sairamkottu/",
    "One liner Testimonial": "I joined NxtWave unsure of where to start. Today, I’m building real-world apps as a Frontend Developer at Niroggyan. The journey was tough, but staying consistent made it possible",
    "Branch Filter": "Tests/Exams",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "75dd4c64-e2e8-4a28-a18f-4fd7d30d2e9c",
    "slug": "75dd4c64-e2e8-4a28-a18f-4fd7d30d2e9c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c6efe8ad3adc66e40a612",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:42:38 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:26:30 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:28:56 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kulkarni Rohith Kumar",
    "College": "Matrusri Engineering College, Saidabad",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2019",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/75dd4c64-e2e8-4a28-a18f-4fd7d30d2e9c.png",
    "Company Name": "Aaro7",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aaro7.png",
    "Designation": "Intern",
    "linkedin profile link": "https://www.linkedin.com/in/kulkarni-rohith-kumar-886878111/",
    "One liner Testimonial": "I didn’t expect to move into tech after so long, but here I am. Learning through NxtWave made this transition feel possible.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Jan 02 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "7647fb24-61dc-4f46-b382-18947f0d85a1",
    "slug": "7647fb24-61dc-4f46-b382-18947f0d85a1",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9afe99411b52250612",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:38 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Srija Thaduri",
    "College": "Vidya Jyothi Institute of Technology (VJIT), Hyderabad",
    "Branch": "Artificial Intelligence and Machine Learning",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7647fb24-61dc-4f46-b382-18947f0d85a1.png",
    "Company Name": "Kaara Info Systems",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kaara-info-systems.png",
    "Designation": "Trainee Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/thaduri-srija-4a090238b/",
    "One liner Testimonial": "NxtWave gave me everything that takes me to get into the tech domain. It feels less like a course and more like a virtual family that never let me quit",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "76da15e1-e464-4a1c-9701-30570a710995",
    "slug": "76da15e1-e464-4a1c-9701-30570a710995",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d418171333ccee09c06",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Praveen Kumar Dasari",
    "College": "Teegala Krishna Reddy Engineering College (TKREC), Hyderabad",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/76da15e1-e464-4a1c-9701-30570a710995.png",
    "Company Name": "Anvi Robotics",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/anvi-robotics.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/praveenkumar-dasari/",
    "One liner Testimonial": "After my graduation, I had a 1-year gap and wasn’t sure where my career was going. NxtWave gave me the push and skills to get back on track as a Full Stack Developer.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "797410e6-79fa-4fd7-91e1-8b26996418d1",
    "slug": "797410e6-79fa-4fd7-91e1-8b26996418d1",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d462aea3343ba27f17d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Gopisetti Gopi",
    "College": "Study World College of Engineering,Coimbatore",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/797410e6-79fa-4fd7-91e1-8b26996418d1.png",
    "Company Name": "Palc Networks",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/palc-networks.png",
    "Designation": "UI Developer",
    "linkedin profile link": "https://www.linkedin.com/in/gopisettigopi/",
    "One liner Testimonial": "Excited to begin my journey at PalC Networks. Grateful to the team for this opportunity and to NxtWave for their guidance and support that helped me reach this milestone.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "7af72b25-ec06-4758-b05e-096eda14b0b9",
    "slug": "7af72b25-ec06-4758-b05e-096eda14b0b9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5afe99411b5224df80",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:34 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kalyan Pandaga",
    "College": "University College of Science, Saifabad, Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7af72b25-ec06-4758-b05e-096eda14b0b9.png",
    "Company Name": "Qwipo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qwipo.png",
    "Designation": "Junior Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/kalyan-pandaga/",
    "One liner Testimonial": "After a 1.5-year career break, I rebuilt my skills and confidence with NxtWave. Today, I’m excited to start as a Junior Software Developer.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "7c7822af-fd8b-4cb3-b1a1-cc5fae959e28",
    "slug": "7c7822af-fd8b-4cb3-b1a1-cc5fae959e28",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c6efb225cba076a3243d5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:42:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pankaj Kumar",
    "College": "Indian Institute of information Technology (IIIT), Vadodara",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7c7822af-fd8b-4cb3-b1a1-cc5fae959e28.png",
    "Company Name": "Kajkarma",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kajkarma.png",
    "Designation": "Full-Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/pnkj10/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I joined NxtWave to get clarity and practical skills. That consistency paid off, and starting as a Full-Stack Developer now feels really satisfying.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "7c991bc7-31ed-494a-b0fa-300d8cba1e0f",
    "slug": "7c991bc7-31ed-494a-b0fa-300d8cba1e0f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c4572a311f00ec8aae",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Guru Nitheesh Kumar Patnam",
    "College": "SVR Engineering College (SVREC), Ayyalur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7c991bc7-31ed-494a-b0fa-300d8cba1e0f.png",
    "Company Name": "DataGaps",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/datagaps.png",
    "Designation": "Associate Developer",
    "linkedin profile link": "https://www.linkedin.com/in/guru-nitheesh-patnam-523a42253/",
    "One liner Testimonial": "Joining as an Associate Developer feels like a solid start. NxtWave helped me build the skills and consistency I needed to step into a real development role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "7cc7994f-ecb1-4d67-b71f-8bb4c1a5ab07",
    "slug": "7cc7994f-ecb1-4d67-b71f-8bb4c1a5ab07",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d84ac57f8640655975b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ramu Banda",
    "College": "Aurora's Degree and PG College, Hyderabad",
    "Branch": "Information Technology",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7cc7994f-ecb1-4d67-b71f-8bb4c1a5ab07.png",
    "Company Name": "LovasIT",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lovasit.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/ramu-banda-83aa5224a",
    "One liner Testimonial": "I studied while helping my father on the farm, and NxtWave’s guidance made the transition smooth. Their support built my confidence, and now I’ve started my IT career at LovasIT.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "7d34912e-c78a-45b3-a1fb-eb13502b2fac",
    "slug": "7d34912e-c78a-45b3-a1fb-eb13502b2fac",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4dfe99411b5224d5cd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kamal Teja Pasham",
    "College": "Kakatiya University",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7d34912e-c78a-45b3-a1fb-eb13502b2fac.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/kamalteja1/",
    "One liner Testimonial": "Getting my first job at HighRadius feels amazing. The mentorship and support from NxtWave helped me stay on track and succeed.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "7fca6217-d331-4b85-8fe4-482bb64ed6f2",
    "slug": "7fca6217-d331-4b85-8fe4-482bb64ed6f2",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6be70849ff1fc1ea76",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:51 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pitchika Manaswi",
    "College": "Shri Vishnu Engineering College for Women (SVECW), Bhimavaram",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7fca6217-d331-4b85-8fe4-482bb64ed6f2.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Associate Functional Consultant ",
    "linkedin profile link": "https://www.linkedin.com/in/manaswi-pitchika-71b924215/",
    "One liner Testimonial": "After college, I joined NxtWave through my cousin. With their support and my commitment to learning, I built the right skills and landed a job at ADP.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "806d1748-0920-458c-93c4-22dd08712751",
    "slug": "806d1748-0920-458c-93c4-22dd08712751",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9e1e4d55548e4be2f1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:42 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jan 06 2026 08:40:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jan 06 2026 08:41:04 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mohammed Ashik",
    "College": "B.S. Abdur Rahman Crescent Institute of Science and Technology, Chennai",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/806d1748-0920-458c-93c4-22dd08712751.png",
    "Company Name": "Skylights Energy",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/skylights-energy.png",
    "Designation": "Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/mohammed-ashik-130727385/",
    "One liner Testimonial": "I was already working, but NxtWave helped me level up. What I learned there helped me crack better software roles and keep moving forward.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "81ddf504-f875-4ac3-93e7-7b19cf922318",
    "slug": "81ddf504-f875-4ac3-93e7-7b19cf922318",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5b779eeb394c440e23",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ashok Ilapuram",
    "College": "JNTUH University College of Engineering Jagtial",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/81ddf504-f875-4ac3-93e7-7b19cf922318.png",
    "Company Name": "Actalyst",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/actalyst.png",
    "Designation": "Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/ashok-ilapuram-a93882247/",
    "One liner Testimonial": "From managing NxtWave’s learning alongside college to cracking interviews, this journey was worth every effort. Excited to begin my role as a Software Developer at Actalyst!",
    "Branch Filter": "Online Advantage",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "81ef5456-ccb0-453b-a9fb-083c7378a677",
    "slug": "81ef5456-ccb0-453b-a9fb-083c7378a677",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6d9896b863004e8210",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:53 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bharath Narasimha Nandyala",
    "College": "G.Pulla Reddy Engineering College (GPREC), Kurnool",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/81ef5456-ccb0-453b-a9fb-083c7378a677.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Associate Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/bharath716/",
    "One liner Testimonial": "Coming from an EEE background, NxtWave’s structured approach made my transition into tech smooth and helped me start my career at ADP.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "83d8361e-8caa-4d11-b61b-0bff476c651b",
    "slug": "83d8361e-8caa-4d11-b61b-0bff476c651b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d932aea3343ba2810ce",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:31 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Salman Mohammad",
    "College": "Malla Reddy University (MRU), Maisammaguda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/83d8361e-8caa-4d11-b61b-0bff476c651b.png",
    "Company Name": "Agivant Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/agivant-technologies.png",
    "Designation": "Associate Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/salmanmohammadd/",
    "One liner Testimonial": "I had zero clarity in coding and mostly mugged things up. NxtWave helped me actually understand programs and get my first job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.2",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "83d8e6f2-a772-44d5-bc3d-94df0fd8962c",
    "slug": "83d8e6f2-a772-44d5-bc3d-94df0fd8962c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c6efd8ad3adc66e40a4b5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:42:37 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:28:07 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:28:56 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manoj Kancharla",
    "College": "Guru Nanak Institutions(GNI)",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/83d8e6f2-a772-44d5-bc3d-94df0fd8962c.png",
    "Company Name": "nGenue - Natural Gas Operational Excellence",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ngenue---natural-gas-operational-excellence.png",
    "Designation": "Software Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/manoj-kancharla-384590231/",
    "One liner Testimonial": "I’d been trying for a while, so getting this opportunity through NxtWave feels reassuring. Happy to finally get started.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Jan 02 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "87ae8927-5792-4833-ad81-db2ee83bbf62",
    "slug": "87ae8927-5792-4833-ad81-db2ee83bbf62",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9a841b17e203b7e555",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:38 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Gowthami Bondapalli",
    "College": "Prasad V. Potluri Siddhartha Institute of Technology (PVPSIT), Kanuru",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/87ae8927-5792-4833-ad81-db2ee83bbf62.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/gowthami-bondapalli/",
    "One liner Testimonial": "I paused NxtWave once to focus on campus placements, didn’t succeed, came back, and that decision changed everything.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "88dc8394-9a0b-4334-94ac-9c97166387c9",
    "slug": "88dc8394-9a0b-4334-94ac-9c97166387c9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d993f5ca641caa7d352",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:37 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Yugandhar Gubbala",
    "College": "Vishnu Institute of Technology (VIT), Bhimavaram",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/88dc8394-9a0b-4334-94ac-9c97166387c9.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/yugandhargubbala34/",
    "One liner Testimonial": "NxtWave didn’t just teach me tech. It made consistency a habit, and that’s what helped me land my role at Cubic.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "893170e0-3cb4-4a0f-8748-e73e9278cc31",
    "slug": "893170e0-3cb4-4a0f-8748-e73e9278cc31",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6bfe99411b5224ea57",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:51 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Chandrika Jalluri",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), Ongole",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/893170e0-3cb4-4a0f-8748-e73e9278cc31.png",
    "Company Name": "Wow Labz",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/wow-labz.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/chandrika-jalluri-229654308/",
    "One liner Testimonial": "With NxtWave’s guidance and flexible learning, I built strong coding and aptitude skills and landed my first job as a Full Stack Developer at Wow Labz",
    "Branch Filter": "Online Advantage",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "8adf8f47-7c7e-4135-b5ee-a3cc859735d3",
    "slug": "8adf8f47-7c7e-4135-b5ee-a3cc859735d3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcc44b1e57e5c085f37",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Lakshmi Sriram Badugu",
    "College": "KL University, Guntur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8adf8f47-7c7e-4135-b5ee-a3cc859735d3.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/badugu-lakshmi-sriram-2103ba249/",
    "One liner Testimonial": "I joined NxtWave in my second year, built practical skills, and skipped sales roles. Now I’ve started my first tech job and I feel much more confident.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Oct 15 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "8b21e9a4-e7bb-491d-b9a8-3903330f7374",
    "slug": "8b21e9a4-e7bb-491d-b9a8-3903330f7374",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4e918f5cf3ea5f8be4",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Deepthi Mittakola",
    "College": "Visvesvaraya College of Engineering and technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2020",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8b21e9a4-e7bb-491d-b9a8-3903330f7374.png",
    "Company Name": "TinyKola",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/tinykola.png",
    "Designation": "Frontend developer",
    "linkedin profile link": "https://www.linkedin.com/in/deepthi-d-a32015250/",
    "One liner Testimonial": "I thought breaking into IT with so much competition would be tough, but with consistent effort and NxtWave’s mentorship, I’ve joined Gridspark Solutions as a Full Stack Developer!",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "8c68c64f-4cbf-4066-a2bc-bcd9ac3cb7f1",
    "slug": "8c68c64f-4cbf-4066-a2bc-bcd9ac3cb7f1",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c702382adc157fcfe9923",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:47:31 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Raveen Karri",
    "College": "Sri Venkateswara College of Engineering And Technology (SVCET), Etcherla",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2021",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8c68c64f-4cbf-4066-a2bc-bcd9ac3cb7f1.png",
    "Company Name": "Pasovit Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/pasovit-technologies.png",
    "Designation": "Software Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/raveenkarri/",
    "One liner Testimonial": "This is my first job, and I couldn’t be happier. NxtWave’s hands-on learning, mocks, and guidance helped me move into full-stack development from a non-tech background.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "8c9a2029-ba88-4ec3-a26d-cfd7184cea7d",
    "slug": "8c9a2029-ba88-4ec3-a26d-cfd7184cea7d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7d9896b863004e89da",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Venkata Tejesh Dumpala",
    "College": "Vignan'S Lara Institute of Technology & Science (VLITS), Vadlamudi",
    "Branch": "MCA (Master of Computer Application)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8c9a2029-ba88-4ec3-a26d-cfd7184cea7d.png",
    "Company Name": "i-Vista Web Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/i-vista-web-solutions.png",
    "Designation": "Trainee | Web Developer",
    "linkedin profile link": "https://www.linkedin.com/in/venkata-tejesh-dumpala/",
    "One liner Testimonial": "I wasn’t consistent at first, but NxtWave’s clear teaching and daily placement support helped me improve and secure a Web Developer position at i-Vista.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "8e18844c-0283-46df-aa90-7ae07f26e984",
    "slug": "8e18844c-0283-46df-aa90-7ae07f26e984",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d799896b863004e87ea",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:05 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Tharun Teja Pellakuru",
    "College": "NBKR Institute of Science and Technology",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8e18844c-0283-46df-aa90-7ae07f26e984.png",
    "Company Name": "Parivartan Software & Multimedia Pvt. Ltd.",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/parivartan-software-&-multimedia-pvt.-ltd..png",
    "Designation": "Jr. MERN Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/tharuntejapellakuru/",
    "One liner Testimonial": "It took time, patience, and a lot of small steps. Grateful to NxtWave for helping me turn my learning into something real.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "8e5bb940-b35d-4f15-9788-2a3e45e87087",
    "slug": "8e5bb940-b35d-4f15-9788-2a3e45e87087-926c2",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcaa0e3d79c33239fdf",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rupa Naga Sri Uppala",
    "College": "Mother Teresa Institute of Science and Technology (MTIST), Khammam",
    "Branch": "Computer Science Engineering (AIML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8e5bb940-b35d-4f15-9788-2a3e45e87087.png",
    "Company Name": "Ray Business Technologies ",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ray-business-technologies-.png",
    "Designation": "Associate Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/rupa-naga-sri-uppala-43609924b/",
    "One liner Testimonial": "I used to find coding very hard. After learning at NxtWave, I slowly started understanding it and now I’ve got my first job offer.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "8ee82530-2750-40be-bc77-0a381c2b8932",
    "slug": "8ee82530-2750-40be-bc77-0a381c2b8932",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9cbe3771f17d266f96",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:40 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rishika Goud ",
    "College": "Mahaveer Institute of Science and Technology (MIST)",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8ee82530-2750-40be-bc77-0a381c2b8932.png",
    "Company Name": "Media Nv",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/media-nv.png",
    "Designation": "Associate Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/rishika-goud-298a372a8/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "After trying placements elsewhere and hearing nothing, NxtWave was the first place that helped me land my first full-stack role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "8f92c752-a72a-4498-8294-9c79f3f17cee",
    "slug": "8f92c752-a72a-4498-8294-9c79f3f17cee",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4e73ea97d4409ca77b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ganesh Bandaru",
    "College": "Aditya College Of Engineering & Technology",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8f92c752-a72a-4498-8294-9c79f3f17cee.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/ganesh-bandaru-287081247/",
    "One liner Testimonial": "The journey to landing my first tech job wasn’t easy, but NxtWave helped me stay on track. Today, I’m proud to join HighRadius as an SDE-1.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "91ee5d09-41fe-4b35-b9a2-0859801eedf5",
    "slug": "91ee5d09-41fe-4b35-b9a2-0859801eedf5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5a165187f9bcdf237d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:34 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Srinivas Vasamsetti",
    "College": "Aditya College of Engineering and Technology (ACEAT), Surampalem",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/91ee5d09-41fe-4b35-b9a2-0859801eedf5.png",
    "Company Name": "Qwipo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qwipo.png",
    "Designation": "Junior Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/srinivas-vasamsetti-34a65a245/",
    "One liner Testimonial": "3 years after graduation with guidance from NxtWave, I finally turned my dream into reality. Starting as a Junior Software Developer feels like the perfect new beginning",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "9217fe84-7419-4566-b2cf-d44e3bd06e35",
    "slug": "9217fe84-7419-4566-b2cf-d44e3bd06e35-0011e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bca70fb6aced1b68ab7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sandhya Rani Chitturi",
    "College": "Swarnandhra College of Engineering and Technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9217fe84-7419-4566-b2cf-d44e3bd06e35.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/ch-sandhyarani/",
    "One liner Testimonial": "I joined NxtWave in my 4th year, practiced consistently, and cracked my first interview. Getting my first job now feels really good.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "92499b5c-ad36-41c2-828d-394953464372",
    "slug": "92499b5c-ad36-41c2-828d-394953464372",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bd16a422fb21c0ebef0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Hemalatha Vatnala",
    "College": "Mahatma Gandhi University (MGU), Nalgonda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/92499b5c-ad36-41c2-828d-394953464372.png",
    "Company Name": "Delta Technology and Management Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/delta-technology-and-management-services.png",
    "Designation": "Associate Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/hemalatha-vatnala/",
    "One liner Testimonial": "I went through many interviews before cracking my first job. NxtWave kept supporting me, and I’m really happy it worked out.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 11 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "9258a19c-1853-491e-ac5b-b3c80ef9a5f5",
    "slug": "9258a19c-1853-491e-ac5b-b3c80ef9a5f5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d173c94da715b12ef7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Siripurapu Srija",
    "College": "Malla Reddy Institute of Engineering & Technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9258a19c-1853-491e-ac5b-b3c80ef9a5f5.png",
    "Company Name": "Bridgesoft Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/bridgesoft-solutions.png",
    "Designation": "Java Developer",
    "linkedin profile link": "https://www.linkedin.com/in/siripurapu-srija-a38a44255/",
    "One liner Testimonial": "Starting my career as a Java developer and learning on the job feels reassuring. Applying through NxtWave worked out well for me.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 31 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "92a361d1-ea96-44f2-9a10-c0230a0eb75e",
    "slug": "92a361d1-ea96-44f2-9a10-c0230a0eb75e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d60165187f9bcdf2715",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:40 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pavan Kumar Muppidi",
    "College": "Csi Wesley Institute of Technology And Sciences (CWITS), Secunderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/92a361d1-ea96-44f2-9a10-c0230a0eb75e.png",
    "Company Name": "Redon Systems",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/redon-systems.png",
    "Designation": "Software Engineer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/pavan-kumar-muppidi/",
    "One liner Testimonial": "I joined NxtWave because it helps students learn new skills and also supports placements. Compared to other programs, it was very well organized and easy to follow.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "934bcbfa-3b6b-45f5-9761-890971d78d7c",
    "slug": "934bcbfa-3b6b-45f5-9761-890971d78d7c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d996643bc5e93ae4bf9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:37 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sathvik Reddy Thumma",
    "College": "Aditya Institute of Technology and Management (AIRM), Tekkali",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/934bcbfa-3b6b-45f5-9761-890971d78d7c.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/sathvikreddytumma/",
    "One liner Testimonial": "I started college thinking about GATE, switched paths with NxtWave, built real skills over time, and got placed as an Engineering Trainee at Cubic.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "94308a85-8b68-49bb-bac7-405121dbc223",
    "slug": "94308a85-8b68-49bb-bac7-405121dbc223",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d0a62120b7c09f7040",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Dinesh Thallapaku",
    "College": "Vellore Institute of Technology (VIT), Vellore",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/94308a85-8b68-49bb-bac7-405121dbc223.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/dineshthallapku/",
    "One liner Testimonial": "I built confidence in my skills through NxtWave, and that helped me step into my first role as a Functional Consultant.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "95878b76-5593-4f43-b83e-ebe7812073c4",
    "slug": "95878b76-5593-4f43-b83e-ebe7812073c4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7273ea97d4409cbd3d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:58 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kudipudi Jithesh",
    "College": "Malla Reddy Institute of Engineering & Technology (MRIET) - Maisammaguda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/95878b76-5593-4f43-b83e-ebe7812073c4.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/jithesh-kudipudi/",
    "One liner Testimonial": "Coming from a tier-3 college, I was initially unsure about how to build a career in IT. That’s when I found NxtWave, and it turned out to be one of the best decisions of my life.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "95ebb1bb-99d4-4fd2-9b34-ed94a92c13a5",
    "slug": "95ebb1bb-99d4-4fd2-9b34-ed94a92c13a5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9b6643bc5e93ae4ca2",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:39 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jan 06 2026 08:40:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jan 06 2026 08:41:04 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nandyala Swarnalatha",
    "College": "RGUKT Ongole",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/95ebb1bb-99d4-4fd2-9b34-ed94a92c13a5.png",
    "Company Name": "Capgemini",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/capgemini.png",
    "Designation": "Analyst - A4",
    "linkedin profile link": "https://www.linkedin.com/in/swarnalatha-nandyala-829970289/",
    "One liner Testimonial": "I’m from an ECE background. After many failed attempts, NxtWave support is what finally led to my first job at Capgemini.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "96831e20-1938-4e0a-b20e-d0a1dfe5076e",
    "slug": "96831e20-1938-4e0a-b20e-d0a1dfe5076e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70ca572a311f00ec8f55",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rahul Rajpurohit",
    "College": "Indian Institute of Information Technology Ranchi",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/96831e20-1938-4e0a-b20e-d0a1dfe5076e.png",
    "Company Name": "Agivant Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/agivant-technologies.png",
    "Designation": "Associate Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/rahul-rajpurohit-here/",
    "One liner Testimonial": "I was clear that I wanted a tech role, not just any offer. Through NxtWave, I got the right opportunity and consistent updates till selection.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.2",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "973262ed-3f02-4431-8711-0f4a3a9828a9",
    "slug": "973262ed-3f02-4431-8711-0f4a3a9828a9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5dbe3771f17d2654a2",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:37 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jashwanth Sai Togata Sankarapu",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), RK Valley",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/973262ed-3f02-4431-8711-0f4a3a9828a9.png",
    "Company Name": "Position²",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/position².png",
    "Designation": "Web Development Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/jashwanth-sai-togata-sankarapu/",
    "One liner Testimonial": "I wasn’t confident in my skills after graduation, but NxtWave’s structured learning and live support helped me build a strong foundation.",
    "Branch Filter": "NxtWave Features",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "97c23d1f-4b83-438a-9bd6-0f089af6aaf9",
    "slug": "97c23d1f-4b83-438a-9bd6-0f089af6aaf9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d989519dfd06eb6c0b0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:36 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jan 06 2026 08:40:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jan 06 2026 08:41:04 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rahul Padidhela",
    "College": "Malla Reddy College of Engineering and Technology (MRCET), Maisammaguda",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/97c23d1f-4b83-438a-9bd6-0f089af6aaf9.png",
    "Company Name": "Media Nv",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/media-nv.png",
    "Designation": "Associate Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/rahul-padidhela/",
    "One liner Testimonial": "I planned to go abroad, but when that didn’t work out, I chose to build skills instead. With NxtWave’s guidance, I’m starting my first job as a Fullstack Developer at MediaNV.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "99161bd8-6cd4-4505-a17f-a4abbb1237ef",
    "slug": "99161bd8-6cd4-4505-a17f-a4abbb1237ef",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4d566775940f011318",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Santhoshi Ravikoti",
    "College": "Sridevi Women's Engineering College",
    "Branch": "Computer Science Engineering (AIML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/99161bd8-6cd4-4505-a17f-a4abbb1237ef.png",
    "Company Name": "Bluesprings Innovations Pvt Ltd",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/bluesprings-innovations-pvt-ltd.png",
    "Designation": "Trainee Pre-Sales",
    "linkedin profile link": "https://www.linkedin.com/in/santhoshiravikoti/",
    "One liner Testimonial": "My brother and I joined NxtWave together and started from zero. I kept learning, handled rejections on my own, and now I’ve started my first job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "99e7eab6-debd-4e00-b235-bb0979c2a27f",
    "slug": "99e7eab6-debd-4e00-b235-bb0979c2a27f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9b841b17e203b7e607",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:39 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jan 06 2026 08:40:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jan 06 2026 08:41:04 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manisha Kumari Sah",
    "College": "Academy of Technology",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/99e7eab6-debd-4e00-b235-bb0979c2a27f.png",
    "Company Name": "Capgemini",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/capgemini.png",
    "Designation": "Analyst - A4",
    "linkedin profile link": "https://www.linkedin.com/in/manisha-kumari-sah-290309276/",
    "One liner Testimonial": "I used to doubt myself because no company replied. NxtWave gave me the push and support I was missing. Without NxtWave’s support, I honestly feel I’d still be waiting for replies.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "9b44c937-e886-48e6-bbc9-a857511004e4",
    "slug": "9b44c937-e886-48e6-bbc9-a857511004e4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d89e70849ff1fc20751",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shani Kasaudhan",
    "College": "IIT Patna",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9b44c937-e886-48e6-bbc9-a857511004e4.png",
    "Company Name": "Anand Rathi",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/anand-rathi.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/shani-kasaudhan-912630252/",
    "One liner Testimonial": "I’m still in my final year, yet I cracked an SDE Intern role at Anand Rathi on my first try, thanks to NxtWave’s test and placement support.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "20",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "9bd626c8-fa81-4e48-bf7d-e4edfd558398",
    "slug": "9bd626c8-fa81-4e48-bf7d-e4edfd558398",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d56841b17e203b7c17b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:30 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ganesh Somari",
    "College": "Geethanjali College of Engineering & Technology (GCET), Cheeryal",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2019",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9bd626c8-fa81-4e48-bf7d-e4edfd558398.png",
    "Company Name": "Authority Entrepreneurs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/authority-entrepreneurs.png",
    "Designation": "CRM Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/ganeshs88/",
    "One liner Testimonial": "NxtWave gave me the guidance and confidence to switch from a non-IT background to a tech career. Their support and my persistence helped me land a CRM Engineer role.",
    "Branch Filter": "Non - IT job to IT",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "9c73d042-7f6d-42df-86b6-340519f75152",
    "slug": "9c73d042-7f6d-42df-86b6-340519f75152",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d54fe99411b5224db35",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:28 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pradeepkumar Mende",
    "College": "Balaji Institute of Technology & Science (BITS), Narsampet",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9c73d042-7f6d-42df-86b6-340519f75152.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Associate Software Test Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/pradeepkumar-mende-2a6707336/",
    "One liner Testimonial": "NxtWave gave me the guidance and confidence to succeed in a highly competitive market. I cracked my role at Cubic Corporation.",
    "Branch Filter": "High package",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "9cbf772b-3409-47e9-8363-e8ee628ec89d",
    "slug": "9cbf772b-3409-47e9-8363-e8ee628ec89d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d83e70849ff1fc20244",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shreyansh Goel",
    "College": "Indian Institute of Information Technology Ranchi",
    "Branch": "Data Science and Artificial Intelligence (AI)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9cbf772b-3409-47e9-8363-e8ee628ec89d.png",
    "Company Name": "SalesDuo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/salesduo.png",
    "Designation": "Software Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/03shreyanshgoel/",
    "One liner Testimonial": "With NxtWave’s constant support, I secured SDE internship at SalesDuo. Excited to start this journey",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "9d3fdf1f-de5f-4e66-a8aa-129525a352fe",
    "slug": "9d3fdf1f-de5f-4e66-a8aa-129525a352fe",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d44779eeb394c44080f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Balaji Sugur",
    "College": "Sreyas Institute of Engineering and Technology, Nagole",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9d3fdf1f-de5f-4e66-a8aa-129525a352fe.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Product Development Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/balaji-sugur/",
    "One liner Testimonial": "Managing college and NxtWave side by side wasn’t easy, but it paid off, today I’m starting my journey at Phenom with confidence in my skills.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "9e83e73a-da44-40f9-abb4-2526182d955b",
    "slug": "9e83e73a-da44-40f9-abb4-2526182d955b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d48e70849ff1fc1d001",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shiva Kumar Mantheni",
    "College": "HRD degree & pg college",
    "Branch": "Computer science",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9e83e73a-da44-40f9-abb4-2526182d955b.png",
    "Company Name": "PALC Networks",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/palc-networks.png",
    "Designation": "Python Developer Fresher [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/shiva-kumar-mantheni-525a45288",
    "One liner Testimonial": "I was a BSc Computer Science student with only theory knowledge. NxtWave gave me the confidence and skills to face the industry.",
    "Branch Filter": "NxtWave Features",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BSc",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "a0fa3d1b-94e8-4d09-9a89-129c3ee751a6",
    "slug": "a0fa3d1b-94e8-4d09-9a89-129c3ee751a6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7a1c890ccb66467777",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:06 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Hemanth Kumar Thiruvaipati",
    "College": "Sri Venkateswara College of Engineering (SVCE), Tirupati",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a0fa3d1b-94e8-4d09-9a89-129c3ee751a6.png",
    "Company Name": "DigitalTrust Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/digitaltrust-technologies.png",
    "Designation": "Software Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/thiruvaipati-hemanth-kumar-40b62a24a/",
    "One liner Testimonial": "I joined NxtWave in my 2nd year, built real projects like a chat app, and gained the skills that finally helped me crack placements and start my career at DigitalTrust Technologies.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.2",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "a1ada06a-3df3-48e8-9567-7eaf330d7a88",
    "slug": "a1ada06a-3df3-48e8-9567-7eaf330d7a88",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d71e70849ff1fc1ef52",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:57 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kartik",
    "College": "Indian Institute of Information Technology, Design & Manufacturing, Kurnool A.P.",
    "Branch": "Artificial intelligence and Data Science ",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a1ada06a-3df3-48e8-9567-7eaf330d7a88.png",
    "Company Name": "Exotel",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/exotel.png",
    "Designation": "Software Development Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/kartikjaiswal9/",
    "One liner Testimonial": "The way NxtWave guided me through each stage, from applications to interviews, made all the difference. Proud to start my career as a Software Engineer Intern at Exotel.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "12",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "a21a848c-e7cd-4e86-b99c-1045e65e4b20",
    "slug": "a21a848c-e7cd-4e86-b99c-1045e65e4b20",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9d8428c65d6b54b95c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:41 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:05:59 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Kumar Gattu",
    "College": "Sreenidhi Institute of Science & Technology (SNIST), Ghatkesar",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a21a848c-e7cd-4e86-b99c-1045e65e4b20.png",
    "Company Name": "Vesonix TechLabs Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/vesonix-techlabs-private-limited.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/saikumar-gattu/",
    "One liner Testimonial": "Learning tech felt tough at first. Classes in my native language, mock interviews, and patience helped me crack my first software job.",
    "Branch Filter": "others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "a24f0b7f-1a29-4f4f-9d02-7e12bae3ac03",
    "slug": "a24f0b7f-1a29-4f4f-9d02-7e12bae3ac03",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d79918f5cf3ea5fa2b9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:05 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sachith Krishna",
    "College": "Bansilal Ramnath Agarwal Charitable Trust’s Vishwakarma Institute of information Technology (VIIT), Pune",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a24f0b7f-1a29-4f4f-9d02-7e12bae3ac03.png",
    "Company Name": "Latracal Solutions Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/latracal-solutions-private-limited.png",
    "Designation": "Full Stack Development Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sachith-krishna/",
    "One liner Testimonial": "One big change I’ve noticed in myself after joining NxtWave is consistency. I’m grateful to them mentors for their continued support and guidance.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "a328a0b7-ac57-4973-8a97-49be7b9efea4",
    "slug": "a328a0b7-ac57-4973-8a97-49be7b9efea4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c6efa393f83b89a7a9cfd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:42:34 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anuj Yadav",
    "College": "Medicaps University, Indore",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a328a0b7-ac57-4973-8a97-49be7b9efea4.png",
    "Company Name": "Agivant Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/agivant-technologies.png",
    "Designation": "Associate Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/anuj-yadav-206702210/",
    "One liner Testimonial": "Having spent time at NxtWave, I was clear I wanted to grow deeper in tech. This role aligns well with that shift.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.2",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "a331cf06-3c72-476e-a736-8163f34e5a2b",
    "slug": "a331cf06-3c72-476e-a736-8163f34e5a2b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d90c6a81cb06b2a660d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:28 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Dileep Kumar Tankala",
    "College": "St.Martin's Engineering College, Secunderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a331cf06-3c72-476e-a736-8163f34e5a2b.png",
    "Company Name": "Hathority, LLC",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/hathority,-llc.png",
    "Designation": "Boomi Intern ",
    "linkedin profile link": "https://www.linkedin.com/in/dileep-kumar-771557263/",
    "One liner Testimonial": "A senior told me about NxtWave. I joined, learned step by step, and now I’ve landed my first job at Hathority as a Boomi Intern.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "a34df945-aa1a-423d-b070-a1358332f679",
    "slug": "a34df945-aa1a-423d-b070-a1358332f679",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b507dcdc579b1d96c67",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Tripurari Nath Singh",
    "College": "IIIT, UNA ",
    "Branch": "Information Technology ",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a34df945-aa1a-423d-b070-a1358332f679.png",
    "Company Name": "lumberfi.com",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lumberfi.com.png",
    "Designation": "SDE Intern ",
    "linkedin profile link": "https://www.linkedin.com/in/tripurari-nath-singh-a50569257/",
    "One liner Testimonial": "I’m still in college, but I already got an SDE internship. Seeing how tough the job market is, this opportunity through NxtWave really means a lot to me",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "11",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "a45bc8ff-aebd-4463-97b9-32e7242261b7",
    "slug": "a45bc8ff-aebd-4463-97b9-32e7242261b7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6cac57f86406558d40",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:52 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bharath Kumar Padira",
    "College": "Vaagdevi College Of Engineering, Warangal",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a45bc8ff-aebd-4463-97b9-32e7242261b7.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Member Technical",
    "linkedin profile link": "https://www.linkedin.com/in/bharathkumar-padira/",
    "One liner Testimonial": "Started learning tech out of curiosity, and before even completing my course, I landed my first job at ADP. NxtWave made me confident in the tech world.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "a4ae4f7f-ce7a-4cfc-b644-193d7555b164",
    "slug": "a4ae4f7f-ce7a-4cfc-b644-193d7555b164",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d68e70849ff1fc1e877",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:48 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pothula",
    "College": "IIT, Palakkad",
    "Branch": "Computer Science",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a4ae4f7f-ce7a-4cfc-b644-193d7555b164.png",
    "Company Name": "Neurealm",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/neurealm.png",
    "Designation": "Fresher Developer",
    "linkedin profile link": "https://www.linkedin.com/in/pothula-sai-praneeth-812986357/",
    "One liner Testimonial": "NxtWave made a huge difference. Their guidance, resources, and constant support helped me throughout, and I’m really thankful to the team for helping me achieve this.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6.75",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "a4fd9805-5527-40af-be9e-964b3adcd098",
    "slug": "a4fd9805-5527-40af-be9e-964b3adcd098",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d92165187f9bcdf4310",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:30 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kalyan Chakravarthi Bandaru",
    "College": "Anurag University, Hyderabad",
    "Branch": "Computer Science Engineering (Data Science)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a4fd9805-5527-40af-be9e-964b3adcd098.png",
    "Company Name": "Agivant Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/agivant-technologies.png",
    "Designation": "Associate Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/bandaru-kalyanchakravarthi06/",
    "One liner Testimonial": "What I couldn’t achieve through job portals, I achieved through NxtWave’s structured guidance and constant support. I cracked my first job at Agivant Technologies.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.2",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "a5620cfb-4241-4470-a95d-e6be529dabd2",
    "slug": "a5620cfb-4241-4470-a95d-e6be529dabd2",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d54841b17e203b7be67",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:28 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rohit Bhupalam Lakshmi",
    "College": "Guru Nanak Institute of Technology (GNIT), Ibrahimpatnam",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a5620cfb-4241-4470-a95d-e6be529dabd2.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Associate Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/rohit-bhupalam/",
    "One liner Testimonial": "With consistent effort, I was able to crack multiple placements and finally join Cubic Corporation as an Associate Software Engineer.",
    "Branch Filter": "Online Advantage",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "a8a97448-ec53-4b61-b01f-0e0d1a8acda8",
    "slug": "a8a97448-ec53-4b61-b01f-0e0d1a8acda8-2557b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bc9d4dc91747b8e6fd5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nehasri Jajala",
    "College": "Malla Reddy (MR) Deemed to be University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a8a97448-ec53-4b61-b01f-0e0d1a8acda8.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/jajalanehasri/",
    "One liner Testimonial": "I started coding from zero in my 2nd year, built projects, and even got noticed on LinkedIn. Getting selected in my first interview gave me a lot of confidence.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "aa5158b9-ff83-4308-b74b-bc65e70e251d",
    "slug": "aa5158b9-ff83-4308-b74b-bc65e70e251d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d8d6643bc5e93ae48a2",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Veeresh B",
    "College": "Arts College (Govt Degree College), Anantapur",
    "Branch": "Mathematics, Statistics & Accounts",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/aa5158b9-ff83-4308-b74b-bc65e70e251d.png",
    "Company Name": "Homes247.in",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/homes247.in.png",
    "Designation": "Web Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/veeresh-b-b88531299/",
    "One liner Testimonial": "I planned for government exams, but NxtWave changed my direction. With no tech background, I learned from scratch and finally landed my first job as a Web Developer Intern at Homes247.in.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BSc",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "ab574166-ac2f-4ad6-a262-8a8c4c19302c",
    "slug": "ab574166-ac2f-4ad6-a262-8a8c4c19302c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70ca58734a8e5f57d910",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jakka Sreehari ",
    "College": "Chaitanya Bharathi Institute of Technology ",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ab574166-ac2f-4ad6-a262-8a8c4c19302c.png",
    "Company Name": "Winfo Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/winfo-solutions.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sreehari-jakka-1912b929a/",
    "One liner Testimonial": "I was applying regularly and almost decided to join NxtWave, and then this offer came through. Seeing my parents happy after the placement means more to me than anything else.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "ac4c5245-6ead-40ba-aa33-3e02f8e38643",
    "slug": "ac4c5245-6ead-40ba-aa33-3e02f8e38643",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d5cbe3771f17d26533f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:36 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Midhun Mohan M",
    "College": "Sree Buddha College of Engineering (SBCE), Pattoor",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ac4c5245-6ead-40ba-aa33-3e02f8e38643.png",
    "Company Name": "Position²",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/position².png",
    "Designation": "Web Development Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/midhunmohanm/",
    "One liner Testimonial": "I always wondered how websites and apps are built. NxtWave helped me turn that curiosity into reality. Thrilled to begin my career as a Web Development Trainee at Position²!",
    "Branch Filter": "NxtWave Features",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "ada26901-e37f-41ff-ae74-d28164636b49",
    "slug": "ada26901-e37f-41ff-ae74-d28164636b49",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70cc7bdc54fe30b4e08f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Hemanth Kumar Addagada",
    "College": "Vasireddy Venkatadri Institute of Technology (VVIT), Pedakakani",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ada26901-e37f-41ff-ae74-d28164636b49.png",
    "Company Name": "DeepKlarity",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/deepklarity.png",
    "Designation": "Full-stack Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/hemanth14/",
    "One liner Testimonial": "This is my first job, and I joined it while studying. Learning step by step at NxtWave made handling actual tasks feel doable for me.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "adad2c10-4c7e-417b-88a1-7479412938b1",
    "slug": "adad2c10-4c7e-417b-88a1-7479412938b1",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bd092fac925ba80dab7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mani Bharathi V",
    "College": "Kongunadu College of Engineering and Technology (KCET), Namakkal",
    "Branch": "Artificial Intelligence & Data Science",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/adad2c10-4c7e-417b-88a1-7479412938b1.png",
    "Company Name": "WombTo18",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/wombto18.png",
    "Designation": "Full Stack Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/manibharathi20/",
    "One liner Testimonial": "I attended many interviews and stayed consistent with NxtWave, even when it was hard. Now I’ve finally got my first tech opportunity all that effort feels worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 11 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "af9d233b-98c4-4902-a847-35c3745881c5",
    "slug": "af9d233b-98c4-4902-a847-35c3745881c5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcf70fb6aced1b68ce7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Prakash Raju Medida",
    "College": "BVCE Odalarevu",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/af9d233b-98c4-4902-a847-35c3745881c5.png",
    "Company Name": "Delta Technology and Management Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/delta-technology-and-management-services.png",
    "Designation": "Associate Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/prakash-medida-0b168633b/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=a",
    "One liner Testimonial": "This was my first interview through NxtWave, and I cracked it. I’ve now joined the company and feel good about this new beginning.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue Jan 06 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "b01b514e-599e-47c4-8ef6-b27900a2a6ca",
    "slug": "b01b514e-599e-47c4-8ef6-b27900a2a6ca",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d0877ffd9058d14fd0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sanjay Kumar Vanapatla",
    "College": "Saveetha School of Engineering, Chennai",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b01b514e-599e-47c4-8ef6-b27900a2a6ca.png",
    "Company Name": "cararth",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cararth.png",
    "Designation": "Software Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sanjay-kumar-vanapatla-35131022b/",
    "One liner Testimonial": "I started learning with NxtWave from my first year itself. That early start helped me build real skills and step into my first developer role now.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "b01b8b79-f23b-4d5e-addd-9088eab0fbcd",
    "slug": "b01b8b79-f23b-4d5e-addd-9088eab0fbcd",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d63c6a81cb06b2a4871",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:43 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Veera Venkata Sai Ram Kolavennu",
    "College": "Kakatiya Institute of Technology & Science (KITS), Warangal",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b01b8b79-f23b-4d5e-addd-9088eab0fbcd.png",
    "Company Name": "AspireNext Academy",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aspirenext-academy.png",
    "Designation": "Full satck developer",
    "linkedin profile link": "https://www.linkedin.com/in/sairam-kolavennu-746598219?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "The hands-on projects and support from Success Coaches really boosted my confidence. Their guidance kept me motivated, and finally, I got placed as a Full Stack Developer.",
    "Branch Filter": "Offline Drive",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "b2b93123-dec5-43b7-9825-8cad8862de2a",
    "slug": "b2b93123-dec5-43b7-9825-8cad8862de2a",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7f918f5cf3ea5fa640",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Siddharth Jamalpur",
    "College": "MVSR Engineering college",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b2b93123-dec5-43b7-9825-8cad8862de2a.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Product Development Engineer [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/siddharth-jamalpur/",
    "One liner Testimonial": "Campus placements didn’t work out for me, but NxtWave’s practical learning and guidance opened the door that finally led me to Phenom.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "b3ddbd71-144b-43d9-8bd9-0a29f05273e6",
    "slug": "b3ddbd71-144b-43d9-8bd9-0a29f05273e6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bccbf39dbf4228ceac3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bhargav Krishna Chanamolu",
    "College": "MLR Institute of Technology (MLRIT), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b3ddbd71-144b-43d9-8bd9-0a29f05273e6.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/bhargav-krishna/",
    "One liner Testimonial": "I got my internship and now my full-time role through NxtWave. I kept learning consistently, built projects, and finally joined a company I’m happy with.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Oct 15 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "b5984172-bd2d-4f18-aa15-b30c95ce2bf0",
    "slug": "b5984172-bd2d-4f18-aa15-b30c95ce2bf0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d95f82afe19cb47c3c5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:33 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jan 06 2026 08:40:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jan 06 2026 08:41:04 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ramu Runja",
    "College": "KLR College of Engineering and Technology",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b5984172-bd2d-4f18-aa15-b30c95ce2bf0.png",
    "Company Name": "InnoWorks Software Solutions Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innoworks-software-solutions-private-limited.png",
    "Designation": "Associate Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/ramu-runja-8744a0272/",
    "One liner Testimonial": "I already had 8 months of work experience, but NxtWave’s support helped me switch confidently and land my role at InnoWorks on my first attempt.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "b95c44f4-c1ca-4b47-83e0-72cf8b4be192",
    "slug": "b95c44f4-c1ca-4b47-83e0-72cf8b4be192",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a49a0c3cad95154c8bf",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Praveen Kumar Yajjala",
    "College": "Aditya College of Engineering",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b95c44f4-c1ca-4b47-83e0-72cf8b4be192.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - Cyber Security",
    "linkedin profile link": "https://www.linkedin.com/in/praveen-kumar-yajjala-81b815215/",
    "One liner Testimonial": "I had to step away from tech for a while. But the goal never changed. Today, I’m joining LTIMindtree as a Cyber Security GET. Thanks to NxtWave for the opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jan 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "bbab8f15-2804-46c2-94dc-010c4f875afe",
    "slug": "bbab8f15-2804-46c2-94dc-010c4f875afe",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4441366f7fa79f72a3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Yadhu Krishna K.V",
    "College": "Sri Krishna College of Engineering and Technology, Coimbatore",
    "Branch": "Information Technology",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/bbab8f15-2804-46c2-94dc-010c4f875afe.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee- Cyber Security",
    "linkedin profile link": "https://www.linkedin.com/in/yadhu-krishna-50060335a/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I just decided to attempt one drive shared by NxtWave. That single decision led me to LTIMindtree as a Cyber Security Graduate Engineer Trainee. Grateful for that chance.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jan 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "bced93b3-79f9-459f-8b51-afb623f76e5f",
    "slug": "bced93b3-79f9-459f-8b51-afb623f76e5f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4c2d73edb6b05c4cbe",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manoj Chunchu",
    "College": "Nalla malla reddy engineering college",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/bced93b3-79f9-459f-8b51-afb623f76e5f.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/manoj-chunchu-4a66bb260/",
    "One liner Testimonial": "NxtWave gave me guidance, opportunities, and the confidence to start my career right after graduation. I’m proud to begin my next chapter at HighRadius as an SDE-1.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "bf04694d-eee8-4825-b243-38e6e4a44896",
    "slug": "bf04694d-eee8-4825-b243-38e6e4a44896",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d908428c65d6b54b251",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:28 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kishan Kada",
    "College": "Aditya Engineering College (AEC), Surampalem",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/bf04694d-eee8-4825-b243-38e6e4a44896.png",
    "Company Name": "Ashling Partners",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ashling-partners.png",
    "Designation": "Associate L1 support consultant",
    "linkedin profile link": "https://www.linkedin.com/in/kishan-kada-9770a9293/",
    "One liner Testimonial": "I thought missing out on college placements meant I wasn’t good enough. NxtWave proved me wrong and became the turning point. Now I have my first job at Ashling Partners.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "bf6fc03c-9443-411a-8567-d036a4a9c94e",
    "slug": "bf6fc03c-9443-411a-8567-d036a4a9c94e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c7097f9ba77ce404f1bc3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:49:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Venkata Rama Prasanth Erapaneedi",
    "College": "Pragati Engineering College (PEC), Surampalem",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/bf6fc03c-9443-411a-8567-d036a4a9c94e.png",
    "Company Name": "Cubastion Consulting",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubastion-consulting.png",
    "Designation": "Tech intern",
    "linkedin profile link": "https://www.linkedin.com/in/erapaneedi-venkata-rama-prasanth-a4ab131b7/",
    "One liner Testimonial": "My journey took time and had ups and downs, but the support I got from NxtWave kept me moving. Starting my first tech role now feels worth all the patience.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "c0f45931-2c5d-4e63-980a-cf5fc6a4178f",
    "slug": "c0f45931-2c5d-4e63-980a-cf5fc6a4178f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d816643bc5e93ae4784",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Guru Brahmam Puli",
    "College": "Scient Institute of Technology (SIT), Ibrahimpatnam",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c0f45931-2c5d-4e63-980a-cf5fc6a4178f.png",
    "Company Name": "Accenflair IT Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/accenflair-it-solutions.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/guru-brahmam-puli/",
    "One liner Testimonial": "Joined NxtWave in 2nd year with minimal coding skills. Built projects, gained confidence, and cleared interviews. Now placed as a Full Stack Developer at Accenflair IT Solutions.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "c2aa3053-a8e1-45b5-9df1-31df7fc4e4e5",
    "slug": "c2aa3053-a8e1-45b5-9df1-31df7fc4e4e5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcf92fac925ba80d9b5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:19 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shashank Shetty",
    "College": "Jayaprakash Narayan College of Engineering (JPNCE)",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c2aa3053-a8e1-45b5-9df1-31df7fc4e4e5.png",
    "Company Name": "My Apps Development",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/my-apps-development.png",
    "Designation": "Full stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/shashank-shetty-58961a244/",
    "One liner Testimonial": "I was confused about my career after college. NxtWave helped me learn step by step, and today I’m working as a Full Stack Developer.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue Jan 13 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "c36a0cb3-3471-4ab3-aca4-2c29eda73a26",
    "slug": "c36a0cb3-3471-4ab3-aca4-2c29eda73a26",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d611e4d55548e4bd425",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:41 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sasankananda Swaroop M",
    "College": "Vidya Jyothi Institute of Technology (VJIT), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c36a0cb3-3471-4ab3-aca4-2c29eda73a26.png",
    "Company Name": "Prolifics Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/prolifics-corporation.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sasank-swaroop/",
    "One liner Testimonial": "I joined NxtWave because I wanted proper guidance. The placement team was very supportive, giving timely updates and opportunities.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "c3f9e402-a487-44ac-9d98-bda5a6fe1424",
    "slug": "c3f9e402-a487-44ac-9d98-bda5a6fe1424",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d48f82afe19cb479971",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ghouse Mohiddin SHAIK",
    "College": "Anil Neerukonda Institute of technology and sciences",
    "Branch": "mechanical engineering",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c3f9e402-a487-44ac-9d98-bda5a6fe1424.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Product Development Engineer [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/ghouse-mohiddin-55897b259/",
    "One liner Testimonial": "Coming from a Mechanical background, coding felt completely new at first. But with NxtWave’s structure and support, I found direction and confidence.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "c4100cb1-7039-47f1-8bed-1d808fe31d24",
    "slug": "c4100cb1-7039-47f1-8bed-1d808fe31d24",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d98fe99411b522504fb",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:36 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sreeniketh Raj Kothakonda",
    "College": "Guru Nanak Institutions Technical Campus (GNITC), Ibrahimpatnam",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c4100cb1-7039-47f1-8bed-1d808fe31d24.png",
    "Company Name": "PlatinumRx",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/platinumrx.png",
    "Designation": "Data Analyst Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sreeniketh-raj-602371299/",
    "One liner Testimonial": "I faced rejections and had very limited experience before NxtWave. With structured prep and placement guidance, I finally secured my first opportunity at PlatinumRx.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "c5b2a1e5-b5ca-46d2-b3c6-6bec98d43536",
    "slug": "c5b2a1e5-b5ca-46d2-b3c6-6bec98d43536",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d6e73ea97d4409cbae0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:54 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shashank Cheruku",
    "College": "Keshav Memorial Engineering College",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c5b2a1e5-b5ca-46d2-b3c6-6bec98d43536.png",
    "Company Name": "Bridgesoft",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/bridgesoft.png",
    "Designation": "Java Developer",
    "linkedin profile link": "https://www.linkedin.com/in/shashank-cheruku/",
    "One liner Testimonial": "Joining NxtWave right after intermediate gave me a head start, helped me build real skills early and land my first job as a Java Developer at Bridgesoft.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "c6266d65-9826-4a74-88ed-9bb35e7aee60",
    "slug": "c6266d65-9826-4a74-88ed-9bb35e7aee60",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcbbf39dbf4228ce9dc",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ankit Raj",
    "College": "Lovely Professional University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c6266d65-9826-4a74-88ed-9bb35e7aee60.png",
    "Company Name": "Clink",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/clink.png",
    "Designation": "SDE",
    "linkedin profile link": "https://www.linkedin.com/in/ankitdotraj/",
    "One liner Testimonial": "I’m still in my final year, and I cracked an SDE role on my second attempt through NxtWave. My family is proud, and I’m excited to start my career.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 21 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "9",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "c69bf5f6-956c-4947-88ee-4c0900303032",
    "slug": "c69bf5f6-956c-4947-88ee-4c0900303032",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b4f7dcdc579b1d96c3d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mantri Prudhvi Narayana",
    "College": "Raghu Engineering College",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c69bf5f6-956c-4947-88ee-4c0900303032.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/mantri-prudhvi-narayana/",
    "One liner Testimonial": "I’m from an ECE background and kept getting only non-IT roles. Through NxtWave, I finally got IT opportunities and today I’ve started my first IT job",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Oct 15 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "c70c6c23-cf56-469a-af19-2337e882329b",
    "slug": "c70c6c23-cf56-469a-af19-2337e882329b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c7096877ffd9058d13170",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:49:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Harika Vadlamudi",
    "College": "Malineni Lakshmaiah Womens Engineering College (MLWEC), Guntur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c70c6c23-cf56-469a-af19-2337e882329b.png",
    "Company Name": "DataGaps",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/datagaps.png",
    "Designation": "Associate Developer",
    "linkedin profile link": "https://www.linkedin.com/in/harika-vadlamudi-53aa69268/",
    "One liner Testimonial": "Campus placements didn’t work out, but NxtWave did. The structured learning helped me gain clarity and confidence, and I cracked my first interview on my first attempt.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "c7baa470-675d-4da3-b25f-18a156889ed3",
    "slug": "c7baa470-675d-4da3-b25f-18a156889ed3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b4fd4dc91747b8e413e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "B Chandrashekar Reddy",
    "College": "J B Institute of Engineering and Technology (JBIET)",
    "Branch": "Artificial Intelligence and Machine Learning",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c7baa470-675d-4da3-b25f-18a156889ed3.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/bchandrashekarreddy/",
    "One liner Testimonial": "My first interview didn’t work out, but it helped me improve. With NxtWave’s guidance and support, I did better this time and landed my first job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Oct 15 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "c820d1dc-2dd9-4460-8e03-7359a15f8055",
    "slug": "c820d1dc-2dd9-4460-8e03-7359a15f8055",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d928428c65d6b54b476",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:30 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Asrith Vatsal Pallanti",
    "College": "Lovely Professional University (LPU), Phagwara",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c820d1dc-2dd9-4460-8e03-7359a15f8055.png",
    "Company Name": "Agivant Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/agivant-technologies.png",
    "Designation": "Associate Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/asrith-vatsal-00358521b/",
    "One liner Testimonial": "My friend told me NxtWave’s placement support works. I joined, followed the process, and now I’m joining Agivant Technologies as an Associate Engineer.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.2",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "c8bfa960-eae8-49b8-9420-2dc918c351a9",
    "slug": "c8bfa960-eae8-49b8-9420-2dc918c351a9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d97779eeb394c441065",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nikhil Kumar Itharaju",
    "College": "Sri Indu College of Engineering & Technology (SICET), Ibrahimpatnam",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c8bfa960-eae8-49b8-9420-2dc918c351a9.png",
    "Company Name": "Latracal Solutions Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/latracal-solutions-private-limited.png",
    "Designation": "Full Stack Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/nikhil-itharaju/",
    "One liner Testimonial": "I didn’t take learning seriously at first. When I finally did, the results followed. Thanks to NxtWave, I’m starting my first internship now.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "12k",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "c9a8d2cb-8ae5-4bee-8e69-e4e39885e1b5",
    "slug": "c9a8d2cb-8ae5-4bee-8e69-e4e39885e1b5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70cf58734a8e5f57db51",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Tanguturi Venkata Sai Sharath",
    "College": "Sri Indu College of Engineering & Technology (SICET), Ibrahimpatnam",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c9a8d2cb-8ae5-4bee-8e69-e4e39885e1b5.png",
    "Company Name": "LPAR systems LLC",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lpar-systems-llc.png",
    "Designation": "Backend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/tvs-sharath-911925258/",
    "One liner Testimonial": "I knew theory from college, but I actually learned backend development at NxtWave. That clarity helped me start my career as a backend developer.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "ca50cca0-5b06-49ea-9202-9cc2450bb595",
    "slug": "ca50cca0-5b06-49ea-9202-9cc2450bb595",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d55165187f9bcdf2107",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sairam Chandragi",
    "College": "Vellore Institute of Technology, Amaravati",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ca50cca0-5b06-49ea-9202-9cc2450bb595.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Associate Software Test Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sairam-chandragi/",
    "One liner Testimonial": "This isn’t just a job offer. It’s a fresh chapter filled with new learnings and opportunities. Special thanks to the NxtWave team for being there at every step.",
    "Branch Filter": "High package",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "cb5215d1-774b-418e-9cf2-26c291c7791c",
    "slug": "cb5215d1-774b-418e-9cf2-26c291c7791c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d72ed62ac8a5b7fac16",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:58 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kantamsetti Sai Phanindhra",
    "College": "Jayaprakash Narayan College of Engineering (JPNCE), Mahabubnagar",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/cb5215d1-774b-418e-9cf2-26c291c7791c.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/saiphanindhra-kantamsetti/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    "One liner Testimonial": "In just 10 months with NxtWave, I’ve grown from learning the basics to cracking multiple final rounds. Truly thankful for their structured guidance",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "cb54bd3f-d0c5-4110-b17e-8763adea846e",
    "slug": "cb54bd3f-d0c5-4110-b17e-8763adea846e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a437063081677fad6ce",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ruthika Shetty",
    "College": "Presidency University (PU), Bengaluru",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/cb54bd3f-d0c5-4110-b17e-8763adea846e.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/ruthikashetty/",
    "One liner Testimonial": "I almost doubted myself after months without an offer. But staying consistent at NxtWave paid off. I’m now a Graduate Engineer Trainee at LTIMindtree.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jan 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "ce19f555-2c0f-4dc9-8d69-00850072f490",
    "slug": "ce19f555-2c0f-4dc9-8d69-00850072f490",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70d2877ffd9058d150cb",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:42 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bhanuteja Gutti",
    "College": "Sathyabama Institute of Science and Technology (SIST), Chennai",
    "Branch": "Computer Science Engineering (Data Science)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ce19f555-2c0f-4dc9-8d69-00850072f490.png",
    "Company Name": "Image InfoSystems Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/image-infosystems-private-limited.png",
    "Designation": "Software Programmer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/bhanu-teja/",
    "One liner Testimonial": "I didn’t learn much in college, but things changed after joining NxtWave. That learning helped me land this software role and feel ready for real work.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 31 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3.3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "ce4e6546-3fff-4805-9ce6-25b03985f975",
    "slug": "ce4e6546-3fff-4805-9ce6-25b03985f975",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7bf82afe19cb47b5cb",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mahesh Babu Garnepudi",
    "College": "Prasad V. Potluri Siddhartha Institute Of Technology",
    "Branch": "Computer Science Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ce4e6546-3fff-4805-9ce6-25b03985f975.png",
    "Company Name": "DigitalTrust Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/digitaltrust-technologies.png",
    "Designation": "Software Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/maheshbabugarnepudi/",
    "One liner Testimonial": "Starting my tech journey at DigitalTrust Technologies feels amazing. NxtWave’s placement team guided me at every stage and kept me motivated throughout.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.2",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "d01e47d2-b645-4018-9a41-e6ea32c844b5",
    "slug": "d01e47d2-b645-4018-9a41-e6ea32c844b5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcc44b1e57e5c085eed",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:08:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "K Srinivas",
    "College": "Chandigarh University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d01e47d2-b645-4018-9a41-e6ea32c844b5.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/k-srinivas-578501231/",
    "One liner Testimonial": "I was already working, but wanted a better tech role. Through NxtWave, I got the right opportunity and now I’m doing well in my new job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Thu Oct 16 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "d6491726-8418-4201-8faa-1e575ab86df5",
    "slug": "d6491726-8418-4201-8faa-1e575ab86df5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4c305ee6209af781c2",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pavan Daniel Gurram",
    "College": "SRKR Engineering College (SRKREC), Bhimavaram",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d6491726-8418-4201-8faa-1e575ab86df5.png",
    "Company Name": "symplr",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/symplr.png",
    "Designation": "SDE- Apprentice",
    "linkedin profile link": "https://www.linkedin.com/in/pavandaniel/",
    "One liner Testimonial": "I joined NxtWave in my third year with almost no coding knowledge. I kept practicing, building projects, and applying. Now I’ve cracked symplr as an SDE Apprentice. ",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "7",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "d7440b05-f86c-4988-a39f-f53c3a56dbe7",
    "slug": "d7440b05-f86c-4988-a39f-f53c3a56dbe7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d55be3771f17d264e06",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Lokesh Reddy Kothur",
    "College": "Sri Indu College of Engineering & Technology (SICET), Ibrahimpatnam",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d7440b05-f86c-4988-a39f-f53c3a56dbe7.png",
    "Company Name": "fxis.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fxis.ai.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/kothurlokeshreddy/",
    "One liner Testimonial": "There was a time I doubted if I could break into IT with so much competition. With NxtWave’s guidance and consistent effort, I’ve joined fxis.ai as a Full Stack Developer!",
    "Branch Filter": "Doubts Resolution",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "d975f505-471e-48d1-b7b4-11ac8cc0104d",
    "slug": "d975f505-471e-48d1-b7b4-11ac8cc0104d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c4f9ba77ce404f3857",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shayan Zafar Ansari",
    "College": "IIT Patna",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d975f505-471e-48d1-b7b4-11ac8cc0104d.png",
    "Company Name": "Anand Rathi",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/anand-rathi.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/shayan-zafar-4202b4257?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "Getting selected for my first SDE role while still in college feels exciting. Grateful to NxtWave for making the entire placement process seamless.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 31 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "da23f55c-227e-46f7-a913-3f5fc4e44be7",
    "slug": "da23f55c-227e-46f7-a913-3f5fc4e44be7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d429896b863004e6cbc",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "sravya veeramshetti",
    "College": "Anurag Engineering College (ACE), Kodad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/da23f55c-227e-46f7-a913-3f5fc4e44be7.png",
    "Company Name": "YuppTV",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/yupptv.png",
    "Designation": "Frontend Developer [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/sravya-veeramshetti/",
    "One liner Testimonial": "At NxtWave, I got hands-on learning and guidance that college never gave me. Today, I’ve started my career as a Frontend Developer at YuppTV",
    "Branch Filter": "Tests/Exams",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "db8d5b9a-5e9d-49fd-88e9-d96654916231",
    "slug": "db8d5b9a-5e9d-49fd-88e9-d96654916231",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d535ba38f05528d819e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Durga Jahnavi Barma",
    "College": "Hyderabad Institute of Technology and Management",
    "Branch": "Computer Science Engineering (Al / ML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/db8d5b9a-5e9d-49fd-88e9-d96654916231.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Associate Software Test Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sai-durga-jahnavi-barma/",
    "One liner Testimonial": "Before NxtWave, I had no coding experience, but their structured learning and mentorship changed that. I stayed consistent and successfully landed a role at Cubic Corporation.",
    "Branch Filter": "High package",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "dc2e525c-ea7d-4f10-ae5f-fee388f4bbe6",
    "slug": "dc2e525c-ea7d-4f10-ae5f-fee388f4bbe6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d86be3771f17d26680b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Varshit Badera",
    "College": "Indian Institute of Information Technology Bhagalpur",
    "Branch": "Computer Science Engineering (Cyber Security)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/dc2e525c-ea7d-4f10-ae5f-fee388f4bbe6.png",
    "Company Name": "Anand Rathi",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/anand-rathi.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/varshit-badera-b57002323/",
    "One liner Testimonial": "I wasn’t getting anywhere with my interviews, but NxtWave.s team kept checking on me and pushing me to try again. That helped me land an SDE Intern role at Anand Rathi.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "20",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "dda6aff2-3830-48c4-94c5-c0716bd93a83",
    "slug": "dda6aff2-3830-48c4-94c5-c0716bd93a83",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b51fbc80e340f213575",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Tekumatla Karthik",
    "College": "Bharath Institute of Higher Education and Research",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/dda6aff2-3830-48c4-94c5-c0716bd93a83.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/tekumatla-karthik/",
    "One liner Testimonial": "I faced multiple interview failures, but NxtWave kept sharing opportunities. I built real skills, kept applying, and getting my first offer felt like a huge relief for me and my family.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "de43219f-7ad6-4fcd-9163-f8639b7f0d7c",
    "slug": "de43219f-7ad6-4fcd-9163-f8639b7f0d7c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c758734a8e5f57d762",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jayasundhar Chalakaveri",
    "College": "Mother Theresa Institute of Engineering and Technology",
    "Branch": "AI & Data Science",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/de43219f-7ad6-4fcd-9163-f8639b7f0d7c.png",
    "Company Name": "Jaihokisan",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/jaihokisan.png",
    "Designation": "UI/ MERN Developer",
    "linkedin profile link": "https://www.linkedin.com/in/jayasundhar/",
    "One liner Testimonial": "This first job offer feels like a strong start to my career. NxtWave’s consistent guidance and timely support helped me improve with every interview attempt.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "dfd8532d-7f58-458c-af4b-c27e5affacf0",
    "slug": "dfd8532d-7f58-458c-af4b-c27e5affacf0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcdbf39dbf4228ceb75",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Harsh Mishra",
    "College": "IIIT Jabalpur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/dfd8532d-7f58-458c-af4b-c27e5affacf0.png",
    "Company Name": "Clink",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/clink.png",
    "Designation": "SDE",
    "linkedin profile link": "https://www.linkedin.com/in/harsh-mishra-636311248/",
    "One liner Testimonial": "I’m still studying, and I got this SDE opportunity through NxtWave in my second interview. It feels really good to get started early.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "9",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "e05b56af-ac47-4414-9feb-cb95c3788efb",
    "slug": "e05b56af-ac47-4414-9feb-cb95c3788efb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d87fe99411b5224fc1e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:19 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ashwani Baghel",
    "College": "Indian Institute of Information Technology, Nagpur (IIITN)",
    "Branch": "ECI ",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e05b56af-ac47-4414-9feb-cb95c3788efb.png",
    "Company Name": "Anand Rathi",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/anand-rathi.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/ashwani-baghel-028823259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "Missed campus placements because of academic criteria, but NxtWave didn’t judge me by marks. Their support helped me land my first offer at Anand Rathi. Feels great!",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "20",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "e0e59444-a019-4717-8612-a22ba2fb7220",
    "slug": "e0e59444-a019-4717-8612-a22ba2fb7220",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bccc8fbf05b4a5876f4",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sharon Raj Kondapaturi",
    "College": "Panimalar Engineering College (PEC), Chennai",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e0e59444-a019-4717-8612-a22ba2fb7220.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/sharon-raj-kondapaturi/",
    "One liner Testimonial": "I started in a non-IT role, kept learning with NxtWave, attended several interviews and finally moved into a tech job. My confidence in my skills is much better now.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue Oct 14 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "e488a95c-24aa-4a50-b96d-497e0b9344e0",
    "slug": "e488a95c-24aa-4a50-b96d-497e0b9344e0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4b9896b863004e6f28",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:19 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Burra Vikram",
    "College": "Gokaraju Rangaraju Institute of Engineering & Technology (GRIET), Bachupally",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e488a95c-24aa-4a50-b96d-497e0b9344e0.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "Java Developer",
    "linkedin profile link": "https://www.linkedin.com/in/vikramburra/",
    "One liner Testimonial": "I wanted to surprise my parents, so I didn’t tell them about my interviews. When I finally shared that I got placed at HighRadius, the joy on their faces was priceless. Thank you NxtWave.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "e4c29912-250d-4a6f-8ed1-2aa96971222c",
    "slug": "e4c29912-250d-4a6f-8ed1-2aa96971222c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b50d4dc91747b8e41d7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Dubaguntla Sandeep",
    "College": "K L University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e4c29912-250d-4a6f-8ed1-2aa96971222c.png",
    "Company Name": "Bridgesoft",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/bridgesoft.png",
    "Designation": "Trainee – Associate Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/sandeep-dubaguntla/",
    "One liner Testimonial": "I didn’t want to keep waiting on my campus offer. Applied through NxtWave, got regular updates, cleared the rounds and now I’m already working on real projects",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Nov 12 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "e690c445-fe59-4103-9b30-98d49471a52d",
    "slug": "e690c445-fe59-4103-9b30-98d49471a52d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4eaccaa53b4e5e919b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sanjiv Sukumar",
    "College": "Sri Venkateswara College of Engineering and Technology (SVCET), Thiruvallur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e690c445-fe59-4103-9b30-98d49471a52d.png",
    "Company Name": "PALC Networks",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/palc-networks.png",
    "Designation": "Python Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sanjiv-sukumar-6187292b4/",
    "One liner Testimonial": "Before NxtWave, I didn’t know how to approach companies or prepare for interviews. Their training and support helped me learn programming skills and land my first job at PALC Networks.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "e6915df8-149c-4fc4-844d-71fa9e8bf514",
    "slug": "e6915df8-149c-4fc4-844d-71fa9e8bf514",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d97779eeb394c441045",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Karthick Raja",
    "College": "Dr. M.G.R. Educational and Research Institute (MGR), Chennai",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e6915df8-149c-4fc4-844d-71fa9e8bf514.png",
    "Company Name": "Relific",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/relific.png",
    "Designation": "Data Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/karthick-raja--s/",
    "One liner Testimonial": "What helped me push through rejections was consistent support and motivation from NxtWave's team, until I cracked my first job at Relific.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "e7bf8458-d167-422f-af4a-e01e5a774686",
    "slug": "e7bf8458-d167-422f-af4a-e01e5a774686",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7b918f5cf3ea5fa47d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shavali Shaik",
    "College": "KOTTAM KARUNAKARA REDDY INSTITUTE OF SCIENCE AND TECHNOLOGY",
    "Branch": "Marketing",
    "Graduate year": "2014",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e7bf8458-d167-422f-af4a-e01e5a774686.png",
    "Company Name": "LovasIT",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lovasit.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/shaiksha41/",
    "One liner Testimonial": "After 8 years in banking, I switched to IT with NxtWave’s structured training and constant support. Today, I’m proud to start my tech career at LovasIT.",
    "Branch Filter": "Non - IT job to IT",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MBA",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "e7d89ff4-6d4f-4baa-8442-bfef159482f0",
    "slug": "e7d89ff4-6d4f-4baa-8442-bfef159482f0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d88c6a81cb06b2a6226",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vikas Chaudhary",
    "College": "National Institute of Technology, Andhra Pradesh",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e7d89ff4-6d4f-4baa-8442-bfef159482f0.png",
    "Company Name": "Anand Rathi",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/anand-rathi.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/vikas-chaudhary-a84624251/",
    "One liner Testimonial": "NxtWave kept sharing interviews, called after every round, and guided me with feedback. That support helped me finally land an SDE Intern offer at Anand Rathi.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "20",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "e92e55a7-831c-4d01-aae7-d00ae24efd3c",
    "slug": "e92e55a7-831c-4d01-aae7-d00ae24efd3c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcf9df886cbcde7e83d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sriram Kapaganti",
    "College": "St Joseph's University",
    "Branch": "Physics & Electronics",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e92e55a7-831c-4d01-aae7-d00ae24efd3c.png",
    "Company Name": "Smart Food Safe",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/smart-food-safe.png",
    "Designation": "Software Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sriram-kapaganti-62268b250/",
    "One liner Testimonial": "I’m from a non-IT background and went through many interviews. With NxtWave’s support, I finally started my first software role it feels good to see things moving.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BSc",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "e9c2942a-008d-44ca-92c7-763b4f978705",
    "slug": "e9c2942a-008d-44ca-92c7-763b4f978705",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d66ed62ac8a5b7fa5fd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:46 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bhanukiran Reddy",
    "College": "K L Es College of Engg. & Technology (KLE), Belgaum",
    "Branch": "Biomedical Engineering",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e9c2942a-008d-44ca-92c7-763b4f978705.png",
    "Company Name": "Position²",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/position².png",
    "Designation": "Web Development Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/bhanukiran-reddy889/",
    "One liner Testimonial": "I’m from a Biomedical background, so getting into software wasn’t easy. NxtWave helped me learn everything step by step and build real skills.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "ea9328e4-ec67-4e91-8ac1-4d9bb9bb359c",
    "slug": "ea9328e4-ec67-4e91-8ac1-4d9bb9bb359c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d86321554d94c469e36",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Udit Saini",
    "College": "Indian Institute of Information Technology Dharwad",
    "Branch": "Data Science and Artificial Intelligence (AI)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ea9328e4-ec67-4e91-8ac1-4d9bb9bb359c.png",
    "Company Name": "Anand Rathi",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/anand-rathi.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/udit-saini-a83b49206/",
    "One liner Testimonial": "Seeing the “Selected” message felt unreal.  NxtWave kept sending opportunities and feedback nonstop. Thanks to them, I’m now an SDE Intern at Anand Rathi.",
    "Branch Filter": "others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "eaebf329-86b4-43d7-9f42-9afb69d3d585",
    "slug": "eaebf329-86b4-43d7-9f42-9afb69d3d585",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d828428c65d6b54ab7f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rudra Raval",
    "College": "Indian Institute of Information Technology, Bhopal",
    "Branch": "Information Technology",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/eaebf329-86b4-43d7-9f42-9afb69d3d585.png",
    "Company Name": "Hyperfin Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/hyperfin-technologies.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/rudra-raval-7b431224b/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I couldn’t crack college placements, but NxtWave guided me step-by-step. With their timely support, I cleared Hyperfin and got selected as an SDE Intern.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "eba75893-1a8b-4abe-8db0-0ad3e40e43b3",
    "slug": "eba75893-1a8b-4abe-8db0-0ad3e40e43b3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b4f50f4b2bc0b060990",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Chakrin Yanamadala",
    "College": "Vellore Institute of Technology - Chennai",
    "Branch": "Computer Science Engineering (AIML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/eba75893-1a8b-4abe-8db0-0ad3e40e43b3.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/sai-chakrin-yanamadala-6b2271221/",
    "One liner Testimonial": "This was my first opportunity through NxtWave, and it turned out to be a great career start. The guidance and support during the drive really helped me.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Oct 15 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "ebb61d12-aec2-4824-8fe2-cb4a3c91caa4",
    "slug": "ebb61d12-aec2-4824-8fe2-cb4a3c91caa4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d88e70849ff1fc20630",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Md Saber Ahmad",
    "College": "Shadan College of Computer Studies For Boys, Khairatabad, Hyderabad",
    "Branch": "MCA (Master of Computer Application)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ebb61d12-aec2-4824-8fe2-cb4a3c91caa4.png",
    "Company Name": "Growth Market Intelligence",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/growth-market-intelligence.png",
    "Designation": "Jr. Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/mdsaberahmad/",
    "One liner Testimonial": "I struggled to get into IT after MCA. Then I joined NxtWave. Their guidance helped me build real skills and finally crack Growth Market Intelligence as a Jr. Software Developer.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "ebd193b1-c20d-4f25-b369-7481780b343c",
    "slug": "ebd193b1-c20d-4f25-b369-7481780b343c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5da02aea3343ba281694",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:44 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Chethan Gondrala",
    "College": "Madanapalle Institute of Technology & Science (MITS), Madanapalle",
    "Branch": "Computer Science and Engineering (Artificial Intelligence)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ebd193b1-c20d-4f25-b369-7481780b343c.png",
    "Company Name": "Skynetic Ventures",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/skynetic-ventures.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/chethan-gondrala/",
    "One liner Testimonial": "I wasn’t great at coding when I started. Now I’m building real projects and stepping into my first Software Engineer role, thanks to NxtWave",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "ed5102f8-6fd7-4a73-b84b-601f95b76c03",
    "slug": "ed5102f8-6fd7-4a73-b84b-601f95b76c03",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4b04cd9e6449ed486a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "S V Subramanyeswara Rao Samayamanthri",
    "College": "Bapatla Engineering College (BEC), Bapatla",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ed5102f8-6fd7-4a73-b84b-601f95b76c03.png",
    "Company Name": "OpenScale",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/openscale.png",
    "Designation": "Software Engineer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/s-v-subramanyeswara-rao-samayamanthri-97253b1b5/",
    "One liner Testimonial": "My journey with NxtWave had both highs and lows. The structure helped me stay consistent, and now I’m beginning my role as a Software Engineer Intern at OpenScale.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "ee7ddaf8-bfdb-47e8-82a5-e5f761e32d34",
    "slug": "ee7ddaf8-bfdb-47e8-82a5-e5f761e32d34",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bd092fac925ba80db2a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vaishnavi Kanipakam",
    "College": "Sri Kalahastiswara Institute of Information and Management Sciences",
    "Branch": "Finance & HR",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ee7ddaf8-bfdb-47e8-82a5-e5f761e32d34.png",
    "Company Name": "DOMS Global",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/doms-global.png",
    "Designation": "Full-Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/vaishnavi-kanipakam-a44126252/",
    "One liner Testimonial": "Even with an MBA background, I stayed focused on tech, faced many rejections, and didn’t accept non-IT roles. With NxtWave, I finally got shortlisted as a Full Stack Developer",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 11 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MBA",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "ef13a81f-cab8-4459-846e-9626e21dd972",
    "slug": "ef13a81f-cab8-4459-846e-9626e21dd972",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b50fbc80e340f21343d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Goutham Gujjari",
    "College": "Marri Laxman Reddy Institute of Technology & Management (MLRIT), Dundigal",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ef13a81f-cab8-4459-846e-9626e21dd972.png",
    "Company Name": "TinyKola",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/tinykola.png",
    "Designation": "Backend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/gouthamgujjari/",
    "One liner Testimonial": "After searching for over a year, I finally started my first job. What I learned at NxtWave is exactly what I use at work today.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Thu Jan 15 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "f113ab3f-8b56-4f8e-9428-0d1931f3879b",
    "slug": "f113ab3f-8b56-4f8e-9428-0d1931f3879b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7ae70849ff1fc1fb10",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:06 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anuj Dhanuka",
    "College": "Satya Institute of Technology & Management (SITM), Gajularega",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f113ab3f-8b56-4f8e-9428-0d1931f3879b.png",
    "Company Name": "Thechefkart",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/thechefkart.png",
    "Designation": "Frontend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/anuj-dhanuka/",
    "One liner Testimonial": "Even after graduating late and coming from Mechanical Engineering, NxtWave helped me stay on track and land a Frontend Developer role at Thechefkart.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "f180bd19-3dc3-4818-b9fd-802a35b9c9b6",
    "slug": "f180bd19-3dc3-4818-b9fd-802a35b9c9b6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d59ac57f86406558438",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:33 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Sreeja Meesala",
    "College": "Sri Bala Sai Degree College, Machilipatnam",
    "Branch": "Mathematics, Physics, Computer Science (MPCS)",
    "Graduate year": "2021",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f180bd19-3dc3-4818-b9fd-802a35b9c9b6.png",
    "Company Name": "Qwipo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qwipo.png",
    "Designation": "Junior Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/saisreeja-meesala/",
    "One liner Testimonial": "NxtWave's hands-on learning and assignments gave me confidence to build real applications. Today, I’m excited to begin my next chapter as a Junior Software Developer at Qwipo!",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BSc",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "f2464b26-051b-47e3-8554-84d2ef4ce5c5",
    "slug": "f2464b26-051b-47e3-8554-84d2ef4ce5c5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcec0a8e7dfef27107a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Keerti S Pattar",
    "College": "BLDEA's V P Dr PG Halakatti College of Engineering & Technology",
    "Branch": "Information Science & Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f2464b26-051b-47e3-8554-84d2ef4ce5c5.png",
    "Company Name": "Optimity Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/optimity-technologies.png",
    "Designation": "ReactJS Developer",
    "linkedin profile link": "https://www.linkedin.com/in/keerti-pattar-3433b629a/",
    "One liner Testimonial": "I tried campus and outside applications, but only through NxtWave I got proper guidance. I cracked my first tech interview and finally started my job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "f27f6183-24de-4c07-b0ad-ae6d4fe02ce0",
    "slug": "f27f6183-24de-4c07-b0ad-ae6d4fe02ce0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d91165187f9bcdf42bf",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shivagnanadeep Malepati",
    "College": "National Institute of Technology (NIT), Arunachal Pradesh",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f27f6183-24de-4c07-b0ad-ae6d4fe02ce0.png",
    "Company Name": "Relific",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/relific.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/shivagnanadeepmalepati/",
    "One liner Testimonial": "I joined NxtWave in my 2nd year because I wanted more than theory. Today, in my 4th year, I got my first Full Stack job at Relific and can build products from scratch.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "f2a8fe38-da46-4619-bdfe-e88f019b6339",
    "slug": "f2a8fe38-da46-4619-bdfe-e88f019b6339",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d65c6a81cb06b2a49ff",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:45 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Karan Kalaskar",
    "College": "Rajiv Gandhi College of Engineering, Research And Technology (RGCERT), Chandrapur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f2a8fe38-da46-4619-bdfe-e88f019b6339.png",
    "Company Name": "Baadalsoft",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/baadalsoft.png",
    "Designation": "Full Stack Developer [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/karan-kalaskar1016/",
    "One liner Testimonial": "When I joined NxtWave, I had zero coding knowledge. The step-by-step learning, and assignments helped me gain real confidence. I finally got placed as a Full Stack Developer",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "f2b6fbed-16b9-412d-9eed-4bcc9fa625b7",
    "slug": "f2b6fbed-16b9-412d-9eed-4bcc9fa625b7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958bcbbf39dbf4228cea3c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:52:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Samala Bhavya",
    "College": "Study World College Of Engineering",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f2b6fbed-16b9-412d-9eed-4bcc9fa625b7.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "AI Content Developer in Technical L&D",
    "linkedin profile link": "https://www.linkedin.com/in/samalabhavya/",
    "One liner Testimonial": "I went through many interviews before cracking my first tech job through NxtWave. Now I’m working on AI projects, and I’m really happy about it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Oct 22 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "f4d90a5a-6c60-49ed-93a7-2f1bbcdd0f50",
    "slug": "f4d90a5a-6c60-49ed-93a7-2f1bbcdd0f50",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d4b9896b863004e6ecc",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:19 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "DivyaVardhan Marrivada",
    "College": "Prasad V. Potluri Siddhartha Institute of Technology (PVPSIT), Kanuru",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f4d90a5a-6c60-49ed-93a7-2f1bbcdd0f50.png",
    "Company Name": "HighRadius",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/highradius.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/vardhanmarriwada/",
    "One liner Testimonial": "What started as small steps in my first year at NxtWave has now turned into my first job at HighRadius. The journey gave me both skills and the confidence to achieve it.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "f5302487-0ee2-4cfe-b325-5bec4a8006f0",
    "slug": "f5302487-0ee2-4cfe-b325-5bec4a8006f0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d52c6a81cb06b2a3b64",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "P Harini Srutakeerti",
    "College": "Neil Gogte Institute of Technology (NGIT), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f5302487-0ee2-4cfe-b325-5bec4a8006f0.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Associate Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/harini-srutakeerti/",
    "One liner Testimonial": "Even after prior experience and an internship, I struggled to find a full-time role. NxtWave’s consistent support, mentorship, helped me land a job at Cubic Corporation.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Sep 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8.2",
    "Full Testimonial": "",
    "Placed Month": "Sep"
  },
  {
    "UID": "f5e54dfe-f1e7-4ac3-96d4-f81bb1d5e684",
    "slug": "f5e54dfe-f1e7-4ac3-96d4-f81bb1d5e684",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d43c6a81cb06b2a3314",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Gowtham Kantubothu",
    "College": "Aditya Institute of Technology and Management",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f5e54dfe-f1e7-4ac3-96d4-f81bb1d5e684.png",
    "Company Name": "Phenom",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom.png",
    "Designation": "Product Development Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/gowtham-kantubothu-80040224b/",
    "One liner Testimonial": "From joining NxtWave to getting placed, the journey taught me patience, persistence, and real technical skills. The personalized guidance and detailed classes made all the difference.",
    "Branch Filter": "Placement Support",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "f67aad26-6d49-4630-8435-986a80e1cda5",
    "slug": "f67aad26-6d49-4630-8435-986a80e1cda5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70ca58734a8e5f57d8f7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Raga Sandeep Reddy Bobba",
    "College": "RGUKT Ongole",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f67aad26-6d49-4630-8435-986a80e1cda5.png",
    "Company Name": "Probe 42",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/probe-42.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/raga-sandeep-reddy-bobba/",
    "One liner Testimonial": "I joined NxtWave early in college and kept building skills alongside academics. That consistency helped me land this Software Engineer role at Probe 42.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "f712cc40-01cd-4d86-85f6-6e6b0c93e1f4",
    "slug": "f712cc40-01cd-4d86-85f6-6e6b0c93e1f4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "697c70c5e413503ef547b28c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jan 30 2026 08:50:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jan 30 2026 09:06:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jan 30 2026 09:21:30 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Koduru Suresh Chandra Reddy",
    "College": "Marri Laxman Reddy Institute of Technology & Management (MLRIT), Dundigal",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f712cc40-01cd-4d86-85f6-6e6b0c93e1f4.png",
    "Company Name": "Jaihokisan",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/jaihokisan.png",
    "Designation": "UI/MERN Developer",
    "linkedin profile link": "https://www.linkedin.com/in/kodurusureshchandrareddy/",
    "One liner Testimonial": "This opportunity reflects the skills I built through consistent practice. NxtWave’s clear learning path and hands-on approach prepared me well for this role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Nov 30 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "f79720fe-03ef-496a-a2d5-ea22901eda49",
    "slug": "f79720fe-03ef-496a-a2d5-ea22901eda49",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d719896b863004e83e3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:42:57 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:47 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Paidimuddala Shalini",
    "College": "Siddharth Institute of Engineering & Technology, Puttur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f79720fe-03ef-496a-a2d5-ea22901eda49.png",
    "Company Name": "LTI Mindtree",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/lti-mindtree.png",
    "Designation": "Graduate Engineer Trainee - CyberSecurity",
    "linkedin profile link": "https://www.linkedin.com/in/paidimuddala-shalini-8a366b1b3/",
    "One liner Testimonial": "Even when others doubted, I kept going with NxtWave’s guidance and my parents’ support, I’m proud to have started my career at LTI Mindtree.",
    "Branch Filter": "Got Into Top MNCs",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Oct 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "f7e2ac8f-d94f-4178-be23-acd6417b86e7",
    "slug": "f7e2ac8f-d94f-4178-be23-acd6417b86e7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b4fa0e3d79c33237dd1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Malga Shanthi Priya",
    "College": "Neil Gogte Institute of Technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f7e2ac8f-d94f-4178-be23-acd6417b86e7.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Engineering Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/malga-shanthi-priya-53b6a6255/",
    "One liner Testimonial": "I was applying to many companies but wasn’t getting replies. Through NxtWave, I finally started getting interview calls, and now I’m working as an Engineering Trainee.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Oct 22 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "8.5",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "f99f78cb-df70-4c39-bf2d-1716a22f3448",
    "slug": "f99f78cb-df70-4c39-bf2d-1716a22f3448",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69958b51fbc80e340f213549",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed Feb 18 2026 09:50:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed Feb 18 2026 10:07:18 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed Feb 18 2026 10:09:46 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bhargav Kammari",
    "College": "Vignan's Foundation for Science, Technology & Research",
    "Branch": "Robotics and Automation Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f99f78cb-df70-4c39-bf2d-1716a22f3448.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/bhargav-kammari/",
    "One liner Testimonial": "I started from zero in software, cracked my first interview, and got my first job at an MNC. Now I feel confident in my skills and ready to support my parents.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Jan 14 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "f9e63361-6955-4a62-a356-18d43371b2c9",
    "slug": "f9e63361-6955-4a62-a356-18d43371b2c9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d811c890ccb66467a71",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Dumpaala Umesh Chandra",
    "College": "Annamacharya Institute of Technology & Sciences (AITS), Kadapa",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f9e63361-6955-4a62-a356-18d43371b2c9.png",
    "Company Name": "Homes247.in",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/homes247.in.png",
    "Designation": "AI - Intern",
    "linkedin profile link": "https://www.linkedin.com/in/umesh-chandra-dumpaala-0282b2279/",
    "One liner Testimonial": "I used to finish delivery work at 2AM, attend my internship in the day, and learn with NxtWave in between. That consistency helped me land an AI Internship at Homes247.in.",
    "Branch Filter": "Non - IT job to IT",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Nov 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Nov"
  },
  {
    "UID": "f9eb8546-22cb-4ff5-a417-f21bf4c164af",
    "slug": "f9eb8546-22cb-4ff5-a417-f21bf4c164af",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69ae4a4c1f76c6e519fd05d3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Mar 09 2026 04:19:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Mar 09 2026 04:20:41 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Mar 09 2026 04:22:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shivareddy Nareddy",
    "College": "JNTUH College of Engineering (JNTU), Kukatpally",
    "Branch": "Software Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f9eb8546-22cb-4ff5-a417-f21bf4c164af.png",
    "Company Name": "Winfo Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/winfo-solutions.png",
    "Designation": "Trainee ",
    "linkedin profile link": "https://www.linkedin.com/in/shivareddy-nareddy-65666a247/",
    "One liner Testimonial": "I applied to many companies through NxtWave, faced ups and downs, but stayed consistent. Now I’m in my first job, and everything feels on track.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "M Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "fc0187d7-3dcb-4b4e-82c5-a1872f76d47e",
    "slug": "fc0187d7-3dcb-4b4e-82c5-a1872f76d47e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d7e9896b863004e8ab0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:45 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Baba Subhani Shaik",
    "College": "Sri Mittapalli College of Engineering (SMCE), Tummalapalem",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/fc0187d7-3dcb-4b4e-82c5-a1872f76d47e.png",
    "Company Name": "Pragma Edge Inc",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/pragma-edge-inc.png",
    "Designation": "Program Analyst ",
    "linkedin profile link": "https://www.linkedin.com/in/subhani-shaik-0bb6b622b/",
    "One liner Testimonial": "NxtWave turned my IT career dream into reality. Their training and guidance helped me secure a Program Analyst position at Pragma Edge.",
    "Branch Filter": "Transformational Journey",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Aug 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Aug"
  },
  {
    "UID": "fef4964c-3a9e-4fdf-9581-10017ef6d588",
    "slug": "fef4964c-3a9e-4fdf-9581-10017ef6d588",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "695b5d9ce70849ff1fc21113",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Jan 05 2026 06:43:40 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Jan 05 2026 06:44:46 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Jan 05 2026 06:48:09 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "J. Vishnu Vardhan Babu",
    "College": "Visvodaya Engineering College",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/fef4964c-3a9e-4fdf-9581-10017ef6d588.png",
    "Company Name": "Media Nv",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/media-nv.png",
    "Designation": "Associate Fullstack Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/vishnu-jangam/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I joined another platform after college, but nothing moved. NxtWave felt different because someone actually guided me step by step.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Dec 24 2025 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Dec"
  },
  {
    "UID": "d43a27bf-7a40-4afa-8abb-6ee2f7aadf30",
    "slug": "d43a27bf-7a40-4afa-8abb-6ee2f7aadf30",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aab8e4a4173273796a1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:55 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Manikanta Revanth Valluru",
    "College": "VIT-AP University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d43a27bf-7a40-4afa-8abb-6ee2f7aadf30.png",
    "Company Name": "Destini.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/destini.ai.png",
    "Designation": "Full Stack Development Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sai-manikanta-revanth-valluru-a36198272/",
    "One liner Testimonial": "After multiple attempts through NxtWave, I finally cracked it, started my first tech job, and now I’m learning something new every day.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Oct 24 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Oct"
  },
  {
    "UID": "fefc9dd4-ad9e-4acd-a637-45ead80d2f8f",
    "slug": "fefc9dd4-ad9e-4acd-a637-45ead80d2f8f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aabb550d788265f0e93",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:55 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shubham Upadhyay",
    "College": "Chandigarh University (CU), Ludhiana",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/fefc9dd4-ad9e-4acd-a637-45ead80d2f8f.png",
    "Company Name": "Airdit Software Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/airdit-software-services.png",
    "Designation": "Software Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/shubhamupadhyay7976/",
    "One liner Testimonial": "I was selected in TCS but never received the offer letter. After multiple interviews, I finally landed my first role at Airdit Software Services. Grateful to NxtWave for the opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "492dbd78-345d-4bc4-bd47-66fdb456d035",
    "slug": "492dbd78-345d-4bc4-bd47-66fdb456d035",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aacac12c51011319561",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:56 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Tarun Daladuri",
    "College": "Sathyabama University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/492dbd78-345d-4bc4-bd47-66fdb456d035.png",
    "Company Name": "Hexagon Capability",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/hexagon-capability.png",
    "Designation": "Software Development Engineer in Test (SDET)",
    "linkedin profile link": "https://www.linkedin.com/in/tarun-daladuri-92347a239/",
    "One liner Testimonial": "Honestly, I didn’t know anything at first. Just stayed consistent, practiced a lot and NxtWave helped me figure things out along the way.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jan 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "d1e09ce7-ea5d-4b29-a1a4-af16b01630e3",
    "slug": "d1e09ce7-ea5d-4b29-a1a4-af16b01630e3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aad8e4a4173273796f0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:57 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shruti Kumari",
    "College": "Asansol Engineering College",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d1e09ce7-ea5d-4b29-a1a4-af16b01630e3.png",
    "Company Name": "Capillary technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/capillary-technologies.png",
    "Designation": "Product Support Intern",
    "linkedin profile link": "https://www.linkedin.com/in/shruti-kumari-34b2b9243/",
    "One liner Testimonial": "There were a lot of attempts and waiting in between but through NxtWave, I finally got an opportunity that felt right",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jan 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Jan"
  },
  {
    "UID": "dbbb0138-9af5-41e4-bc0c-7e0d5e69ef0f",
    "slug": "dbbb0138-9af5-41e4-bc0c-7e0d5e69ef0f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aad9ad5e03b4a82d32c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:57 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Yash Goyal",
    "College": "Indraprastha Institute of Information Technology, Delhi",
    "Branch": "Computer Science & Applied Mathematics",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/dbbb0138-9af5-41e4-bc0c-7e0d5e69ef0f.png",
    "Company Name": "Uber Freight",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/uber-freight.png",
    "Designation": "Software Engineer II",
    "linkedin profile link": "https://www.linkedin.com/in/yash-goyal-8642b1253/",
    "One liner Testimonial": "I didn’t really have a clear plan before. NxtWave helped me figure things out and things moved faster than I expected",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "15",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "3d9c43bc-4db5-40b0-b470-352cd797b0b8",
    "slug": "3d9c43bc-4db5-40b0-b470-352cd797b0b8",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aade0b27d6b87a9de02",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:57 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shiva Krishna Baigalla",
    "College": "KG Reddy College of Engineering and Technology",
    "Branch": "Computer Science Engineering (Data Science)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3d9c43bc-4db5-40b0-b470-352cd797b0b8.png",
    "Company Name": "Corpus Software",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/corpus-software.png",
    "Designation": "Manual Testing Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/baigalla-shiva-krishna-24aa20291/",
    "One liner Testimonial": "I was a bit unsure for a while, things weren’t really working out, then through NxtWave, I got an opportunity and things started falling into place.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "c199e21d-e375-44c0-8ae1-bba62fdf2d88",
    "slug": "c199e21d-e375-44c0-8ae1-bba62fdf2d88",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aaee0b27d6b87a9de53",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:58 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Aman Parmar",
    "College": "Indian Institute of Information Technology Surat",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c199e21d-e375-44c0-8ae1-bba62fdf2d88.png",
    "Company Name": "Uber Freight",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/uber-freight.png",
    "Designation": "Software Engineer II",
    "linkedin profile link": "https://www.linkedin.com/in/aman-parmar-876238262/",
    "One liner Testimonial": "I was consistently trying for roles, but things weren’t clicking. With NxtWave’s support and interview guidance, I was able to crack this one.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "15",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "a4fe903e-0d74-4b16-a696-f9db36ff4934",
    "slug": "a4fe903e-0d74-4b16-a696-f9db36ff4934",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aaf9387f1448ad3b304",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:59 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pentala Ajay Kumar",
    "College": "Vignana Bharathi Institute of Technology",
    "Branch": "Computer Science Engineering",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a4fe903e-0d74-4b16-a696-f9db36ff4934.png",
    "Company Name": "iOPEX Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/iopex-technologies.png",
    "Designation": "Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/ajay-kumar-pentala-0b960126b/",
    "One liner Testimonial": "I was still searching after graduation while many around me were stuck. Through NxtWave, I was able to convert one of the opportunities I got.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "1a33a8c6-5fa4-491c-a027-549eea9a5182",
    "slug": "1a33a8c6-5fa4-491c-a027-549eea9a5182",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38aafe0b27d6b87a9ded0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:27:59 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Arnav Jain",
    "College": "The LNM Institute of Information Technology, Jaipur",
    "Branch": "Computer Science Engineering",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1a33a8c6-5fa4-491c-a027-549eea9a5182.png",
    "Company Name": "StrideOne",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/strideone.png",
    "Designation": "Software Engineer Intern (Backend)",
    "linkedin profile link": "https://www.linkedin.com/in/arnav-jain-139608279/",
    "One liner Testimonial": "Getting interview calls was the hardest part for me in college. With NxtWave, I finally got that chance and was able to crack it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "6399212b-2583-4dd2-8367-a4d45f6402d7",
    "slug": "6399212b-2583-4dd2-8367-a4d45f6402d7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab09ad5e03b4a82d497",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:00 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Snehil Dwivedi",
    "College": "KL University,  Vijayawada",
    "Branch": "Computer Science Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6399212b-2583-4dd2-8367-a4d45f6402d7.png",
    "Company Name": "HTC Global Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/htc-global-services.png",
    "Designation": "Software Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/snehil-dwivedi-597033226/",
    "One liner Testimonial": "After college, I kept trying for months without results. Through NxtWave, I finally landed my first opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "2f2d2417-ca5a-4255-ad7b-a5370a905cc0",
    "slug": "2f2d2417-ca5a-4255-ad7b-a5370a905cc0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab0aee6eb59178c764d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:00 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manav Daga",
    "College": "Indian Institute of Information Technology Senapati, Manipur",
    "Branch": "Computer Science Engineering",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2f2d2417-ca5a-4255-ad7b-a5370a905cc0.png",
    "Company Name": "256 Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/256-technologies.png",
    "Designation": "Frontend Intern",
    "linkedin profile link": "https://www.linkedin.com/in/manav-daga/",
    "One liner Testimonial": "I had tried campus placements but didn’t see much success. Through NxtWave, I finally landed my first role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "1bfcf4f0-880b-4cac-8915-cbc99b2eeb7a",
    "slug": "1bfcf4f0-880b-4cac-8915-cbc99b2eeb7a-f6f65",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab0aee6eb59178c7667",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:00 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "E Anurag",
    "College": "Malla Reddy University",
    "Branch": "Computer Science Engineering",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1bfcf4f0-880b-4cac-8915-cbc99b2eeb7a.png",
    "Company Name": "HTC Global Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/htc-global-services.png",
    "Designation": "Software Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/e-anurag-a18087211/",
    "One liner Testimonial": "I was only looking for IT roles and wasn’t getting responses elsewhere. Through NxtWave, I finally got my first job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "ea3f5be2-6666-4236-98b7-3fd244ec90df",
    "slug": "ea3f5be2-6666-4236-98b7-3fd244ec90df-3599b",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab1d7286e79db76988d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:01 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sanjay Kumar Thadaka",
    "College": "Vaagdevi College of Engineering (VCE), Warangal",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ea3f5be2-6666-4236-98b7-3fd244ec90df.png",
    "Company Name": "iOPEX Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/iopex-technologies.png",
    "Designation": "Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sanjay-kumar-thadaka/",
    "One liner Testimonial": "I’d been waiting for this moment for a long time. I'm truly thankful to NxtWave because, they gave me way more chances than applying outside.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "e2e3c629-c644-4031-98dd-3a9e062724b4",
    "slug": "e2e3c629-c644-4031-98dd-3a9e062724b4-b48d1",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab1e1b7c019b90b52e5",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:01 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Komal Gupta Batchu",
    "College": "Raghu Engineering College (REC), Dakamarri",
    "Branch": "Computer Science Engineering with Internet of Things",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e2e3c629-c644-4031-98dd-3a9e062724b4.png",
    "Company Name": "iOPEX Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/iopex-technologies.png",
    "Designation": "Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/komal-gupta-batchu-384150292/",
    "One liner Testimonial": "I switched between roles, even faced a phase without salary. Eventually, through NxtWave, I found something that actually felt right.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "a012e35b-a7d0-4fb1-bc45-68dd10c8c627",
    "slug": "a012e35b-a7d0-4fb1-bc45-68dd10c8c627-1ad3f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab23615384be7557fe7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:02 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Aluka Vamshi Krishna Reddy",
    "College": "Guru Nanak Institutions(GNI)",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a012e35b-a7d0-4fb1-bc45-68dd10c8c627.png",
    "Company Name": "RESKOM",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/reskom.png",
    "Designation": "Associate Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/aluka-vamshi-krishna-reddy-743175229/",
    "One liner Testimonial": "I started learning early, even before college properly began. Through NxtWave, I was able to turn that into my first job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "b3b06ece-a970-4416-a7b5-f6d6a39617b9",
    "slug": "b3b06ece-a970-4416-a7b5-f6d6a39617b9-f4115",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab29387f1448ad3b463",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:02 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Saksham Jaiswal",
    "College": "United College Of Engineering & Research - [UCER], Allahabad",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b3b06ece-a970-4416-a7b5-f6d6a39617b9.png",
    "Company Name": "Ashvad Tech Private Limited",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ashvad-tech-private-limited.png",
    "Designation": "Jr. Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/saksham-jaiswal-3273a7250/",
    "One liner Testimonial": "I had already faced a “selected but no joining” situation. Kept applying through NxtWave, and it finally worked.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "e7077505-9793-41bb-9cc9-56d4f8b5ca3f",
    "slug": "e7077505-9793-41bb-9cc9-56d4f8b5ca3f-aa148",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab344b3870278afa758",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:03 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nagarjuna Reddy Kaipu",
    "College": "Andhra Loyola Institute of Engineering & Technology (ALIET), Vijayawada",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2022",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e7077505-9793-41bb-9cc9-56d4f8b5ca3f.png",
    "Company Name": "AADHI SOFTECH SOLUTIONS PVT LTD",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aadhi-softech-solutions-pvt-ltd.png",
    "Designation": "Fresher Developer",
    "linkedin profile link": "https://www.linkedin.com/in/nagarjuna-reddy-k-838103231/",
    "One liner Testimonial": "I was selected before but never got to join, and even lost a job in between. After all that, I kept trying and finally got back into IT through NxtWave.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "4619a7a5-919d-4bb7-a17b-2b53d5f36a46",
    "slug": "4619a7a5-919d-4bb7-a17b-2b53d5f36a46-6f7be",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab39387f1448ad3b47d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:03 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mohan Krishna Reddy Vangala",
    "College": "Sri Venkateswara College of Engineering (SVCE), Tirupati",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/4619a7a5-919d-4bb7-a17b-2b53d5f36a46.png",
    "Company Name": "ADA Global",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ada-global.png",
    "Designation": "Data Analyst",
    "linkedin profile link": "https://www.linkedin.com/in/mohankrishna280823/?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "One liner Testimonial": "I assumed campus would be enough. When it didn’t work out, I joined NxtWave and that’s where I got placed.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "d92f9042-746e-4129-a481-f661d239516d",
    "slug": "d92f9042-746e-4129-a481-f661d239516d-68071",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab3e1b7c019b90b5346",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:03 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shashi Preetham Baindla",
    "College": "Indian Institute of Information Technology Nagpur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d92f9042-746e-4129-a481-f661d239516d.png",
    "Company Name": "Prolifics Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/prolifics-corporation.png",
    "Designation": "Software Engineer Trainee (AI/ML)",
    "linkedin profile link": "https://www.linkedin.com/in/shashi-preetham-baindla-74bab22ab/",
    "One liner Testimonial": "I didn’t have a full-time role even after two internships. Through NxtWave, I was able to convert one soon after.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "4c8be80d-b8b1-4b23-8cd0-e5f11d2a7665",
    "slug": "4c8be80d-b8b1-4b23-8cd0-e5f11d2a7665-e6f40",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab4d7286e79db769a94",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:04 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pavan Raj Chodavarapu",
    "College": "Pragati Engineering College (PEC), Surampalem",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/4c8be80d-b8b1-4b23-8cd0-e5f11d2a7665.png",
    "Company Name": "iOPEX Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/iopex-technologies.png",
    "Designation": "Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/pavanraj79/",
    "One liner Testimonial": "I took up a non-IT job just to not sit idle. Kept trying for IT roles, and through NxtWave, I finally made the switch.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "ac92d437-3e01-4b16-ac8b-7d757b7c1d43",
    "slug": "ac92d437-3e01-4b16-ac8b-7d757b7c1d43-5bfcd",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab4e7da7e4f8fd8ceef",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:04 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nori Rohit Pavan",
    "College": "National Institute of Technology, Agartala",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ac92d437-3e01-4b16-ac8b-7d757b7c1d43.png",
    "Company Name": "iOPEX Technologies",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/iopex-technologies.png",
    "Designation": "Trainee Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/rohit-nori/",
    "One liner Testimonial": "Even with prior experience, it took time to hear back from companies. Through NxtWave, I got faster responses and was able to land this role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "7a567262-24bc-433e-a62d-72921c79a5e3",
    "slug": "7a567262-24bc-433e-a62d-72921c79a5e3-b4cb2",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab500d6b2d4eb67a4f4",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:05 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Venkat Eluri",
    "College": "Parul University, Vadodara",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7a567262-24bc-433e-a62d-72921c79a5e3.png",
    "Company Name": "DeepKlarity",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/deepklarity.png",
    "Designation": "Full-Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/elurisaivenkat/",
    "One liner Testimonial": "I missed out on joining after a campus selection. Through NxtWave, I got another shot and secured a role before graduating.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "c552b455-a479-4abb-9339-37a68d0dfe6b",
    "slug": "c552b455-a479-4abb-9339-37a68d0dfe6b-1c7bc",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab51c93927b25c142eb",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:05 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Dhanush Reddy Veerati",
    "College": "Jayamukhi Institute of Technological Sciences (JITS), Narsampet",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c552b455-a479-4abb-9339-37a68d0dfe6b.png",
    "Company Name": "RESKOM",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/reskom.png",
    "Designation": "Associate Software Developer",
    "linkedin profile link": "https://www.linkedin.com/in/veerati-dhanush-reddy-6b85532b1/",
    "One liner Testimonial": "Freelancing was going well until AI changed things. I had to rethink my path, and through NxtWave, I landed my first full-time role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "f14b4227-da42-4348-b01b-c3329eb5069e",
    "slug": "f14b4227-da42-4348-b01b-c3329eb5069e-98262",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab600d6b2d4eb67a61c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:06 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nantha K",
    "College": "Anna University, BIT Campus, Tiruchirappalli",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f14b4227-da42-4348-b01b-c3329eb5069e.png",
    "Company Name": "ITOrizon",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/itorizon.png",
    "Designation": "Level 1- Associate",
    "linkedin profile link": "https://www.linkedin.com/in/nantha001/",
    "One liner Testimonial": "I turned down a core EEE role to switch to IT. Worked night shifts, kept preparing and finally got placed through NxtWave.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "f3385031-4d7b-40cc-af46-724fc3d8d2c0",
    "slug": "f3385031-4d7b-40cc-af46-724fc3d8d2c0-e24a0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab61c93927b25c1435a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:06 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mahesh Kolupula",
    "College": "Maturi Venkata Subba Rao (MVSR) Engineering, Balapur",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f3385031-4d7b-40cc-af46-724fc3d8d2c0.png",
    "Company Name": "moksa.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/moksa.ai.png",
    "Designation": "Machine Learning Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/maheshkolupula/",
    "One liner Testimonial": "The difference was clear the roles I got through NxtWave felt more aligned with what I was looking for.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "7f3ec4ca-0560-47b6-9349-fbc89e5b6fc6",
    "slug": "7f3ec4ca-0560-47b6-9349-fbc89e5b6fc6-40cac",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab6ab00d66a89bdf83c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:06 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mohammed Arshath",
    "College": "Sethu Institute of Technology (SIT), Kariapatti",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7f3ec4ca-0560-47b6-9349-fbc89e5b6fc6.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Associate Functional Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/mohammed-arsath-2355a63b3/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I attended 30+ interviews and even travelled to different places for opportunities. Through NxtWave, I finally got the break I was waiting for.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "f07f41d3-3297-4a7d-89a0-ac2760730226",
    "slug": "f07f41d3-3297-4a7d-89a0-ac2760730226-58028",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab7a8b065f945465399",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Aswini Sanku",
    "College": "VIT-AP University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f07f41d3-3297-4a7d-89a0-ac2760730226.png",
    "Company Name": "Innoira",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innoira.png",
    "Designation": "Associate Agentic AI Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/aswini-sanku/",
    "One liner Testimonial": "I was already selected elsewhere but still waiting. Through NxtWave, I got another opportunity and chose to move forward with it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "910a680a-0b4b-4727-bcd4-fbd57428a23b",
    "slug": "910a680a-0b4b-4727-bcd4-fbd57428a23b-b0c89",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab7b550d788265f13a9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Chiranjeevi K",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), Srikakulam",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/910a680a-0b4b-4727-bcd4-fbd57428a23b.png",
    "Company Name": "ADP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/adp.png",
    "Designation": "Associate Function Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/k-chiranjeevi/",
    "One liner Testimonial": "I kept getting close, even selected a couple of times, but nothing stuck. Through NxtWave, I finally landed something stable.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "0d8849e3-3c8c-4011-a4fc-991a368755b0",
    "slug": "0d8849e3-3c8c-4011-a4fc-991a368755b0-08915",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab7e1b7c019b90b550a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jagriti Singh",
    "College": "Government Engineering College (GEC), Koni",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0d8849e3-3c8c-4011-a4fc-991a368755b0.png",
    "Company Name": "ACG World",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/acg-world.png",
    "Designation": "Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/jagriti-singh02/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "Applying outside didn’t get me many responses. Through NxtWave, I kept getting opportunities and finally cracked one.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "de4f3822-618f-45f7-9a05-2b501545caea",
    "slug": "de4f3822-618f-45f7-9a05-2b501545caea-7802d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab8b550d788265f13c3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Praveen Kumar Bandela",
    "College": "CMR Engineering College",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/de4f3822-618f-45f7-9a05-2b501545caea.png",
    "Company Name": "Innoira",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innoira.png",
    "Designation": "AI Web Developer",
    "linkedin profile link": "https://www.linkedin.com/in/praveen-kumar-bandela-616065224/",
    "One liner Testimonial": "I had a gap after graduation because I didn’t take non-IT roles. Through NxtWave, I finally got the opportunity I was waiting for.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "d6c52684-26c3-48db-8eb7-6e43e0385c7c",
    "slug": "d6c52684-26c3-48db-8eb7-6e43e0385c7c-5f719",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab8e1b7c019b90b5590",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Buddana Sankeerthana",
    "College": "Vignan's Institute of Engineering for Women",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d6c52684-26c3-48db-8eb7-6e43e0385c7c.png",
    "Company Name": "Alvyl Consulting",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/alvyl-consulting.png",
    "Designation": "Software Engineering Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sankeerthana-buddana/",
    "One liner Testimonial": "I applied to 50+ companies and faced multiple rejections over a year. Through NxtWave, I finally landed an opportunity.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "b794217a-03ed-41f5-84c9-844a8085e485",
    "slug": "b794217a-03ed-41f5-84c9-844a8085e485-d9b09",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38ab8e1b7c019b90b55aa",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anudeep Mergu",
    "College": "ACE Engineering College, Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b794217a-03ed-41f5-84c9-844a8085e485.png",
    "Company Name": "Alvyl Consulting",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/alvyl-consulting.png",
    "Designation": "Software Engineering Intern",
    "linkedin profile link": "https://www.linkedin.com/in/mergu-anudeep/",
    "One liner Testimonial": "I had just started receiving opportunities through NxtWave. Within a couple of attempts, I was able to crack one.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "a1903ae8-202a-4fea-8eef-b9b2e0d028d2",
    "slug": "a1903ae8-202a-4fea-8eef-b9b2e0d028d2-cf0a8",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abb00d6b2d4eb67a8e7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Gajula Shiva Chaitanya",
    "College": "Kalasalingam University",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a1903ae8-202a-4fea-8eef-b9b2e0d028d2.png",
    "Company Name": "OVI Learning LLP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ovi-learning-llp.png",
    "Designation": "QA Freshers",
    "linkedin profile link": "https://www.linkedin.com/in/shiva-chaitanya-gajula-b31562237/",
    "One liner Testimonial": "I was selective with roles, didn’t try everything. The support from NxtWave made a difference, and this became my first opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "5950bb15-77ea-4866-88f9-3c1874df2596",
    "slug": "5950bb15-77ea-4866-88f9-3c1874df2596-09fc2",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abc00d6b2d4eb67a989",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manikanta Galipalli",
    "College": "Vijay Rural Engineering College",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5950bb15-77ea-4866-88f9-3c1874df2596.png",
    "Company Name": "OVI Learning LLP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ovi-learning-llp.png",
    "Designation": "Gen AI Content Intern",
    "linkedin profile link": "https://www.linkedin.com/in/manikanta-galipalli/",
    "One liner Testimonial": "I got selected in more than one company, but this role made more sense to me. It was in Gen AI, which I wanted. Thanks to NxtWave for that opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "564f60c6-5610-4343-9cba-4c6f8e92ab47",
    "slug": "564f60c6-5610-4343-9cba-4c6f8e92ab47-a175e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abc067e13852e361e0d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Peddi Gowtham Balaji",
    "College": "Amrita School Of Engineering (ASE), Bengaluru",
    "Branch": "Computer Science Engineering (AIML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/564f60c6-5610-4343-9cba-4c6f8e92ab47.png",
    "Company Name": "TARDID Technologies Pvt Ltd",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/tardid-technologies-pvt-ltd.png",
    "Designation": "AI Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/gowthampeddi/",
    "One liner Testimonial": "I wasn’t applying everywhere. I was selective about roles and packages. One of those attempts worked out through NxtWave.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "971756f2-562e-480f-afb6-0cd1ccf2314f",
    "slug": "971756f2-562e-480f-afb6-0cd1ccf2314f-c1fed",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abd88c4c6d40914e079",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Reddy Raju Vandadi",
    "College": "Vemu Institute of Technology (VIT), P.Kothakota",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/971756f2-562e-480f-afb6-0cd1ccf2314f.png",
    "Company Name": "Smart Food Safe",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/smart-food-safe.png",
    "Designation": "Soft Developer Intern",
    "linkedin profile link": "https://www.linkedin.com/in/reddy-raju-vandadi/",
    "One liner Testimonial": "I had a job, but not in the domain I wanted. I kept pushing for a dev role and eventually got one. Thanks to NxtWave",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "8a30dfab-19b3-40f5-befd-0e424b2bc60d",
    "slug": "8a30dfab-19b3-40f5-befd-0e424b2bc60d-67728",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abdd7286e79db769e04",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rock Jason Bandugula",
    "College": "JNTUH College of Engineering Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8a30dfab-19b3-40f5-befd-0e424b2bc60d.png",
    "Company Name": "FedEx ACC",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fedex-acc.png",
    "Designation": "Software Engineering Intern [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/rock-jason-bandugula/",
    "One liner Testimonial": "I was waiting for the right kind of role, not just any offer. Through NxtWave, I got into a product-based company.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "Integrated B.Tech + M.Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "87dae977-73a5-4e07-88c9-ac81a8a009c4",
    "slug": "87dae977-73a5-4e07-88c9-ac81a8a009c4-2c739",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abe44b3870278afaa20",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Dhruva Pratap Singh",
    "College": "Harcourt Butler Technical University",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/87dae977-73a5-4e07-88c9-ac81a8a009c4.png",
    "Company Name": "ZET",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/zet.png",
    "Designation": "Software Engineering Intern",
    "linkedin profile link": "https://www.linkedin.com/in/dhruva-pratap-singh-b9a913257/",
    "One liner Testimonial": "Took me a few attempts and some waiting, but the opportunities and mock feedback from NxtWave really made the difference",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "9fc6d30a-2137-435a-9c86-ec3951a31dfd",
    "slug": "9fc6d30a-2137-435a-9c86-ec3951a31dfd-9eba4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abed7286e79db769e1e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Karthikeya Konduru",
    "College": "CMR Institute of Technology (CMRIT), Kandlakoya",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9fc6d30a-2137-435a-9c86-ec3951a31dfd.png",
    "Company Name": "FedEx ACC",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fedex-acc.png",
    "Designation": "Software Engineering Intern",
    "linkedin profile link": "https://www.linkedin.com/in/sai-karthikeya-konduru-2a0400229/",
    "One liner Testimonial": "I had been preparing for this kind of role since my first year. When the opportunity came, I was ready and cracked it in my first interview through NxtWave.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "27a7f6ac-5a12-49c6-9217-c9bc235faec0",
    "slug": "27a7f6ac-5a12-49c6-9217-c9bc235faec0-4adda",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69d38abf00d6b2d4eb67abd9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Mon Apr 06 2026 10:28:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Mon Apr 06 2026 10:33:58 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Mon Apr 06 2026 10:39:06 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shivam Samediya",
    "College": "Indian Institute of Information Technology(IIIT), Sonepat",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/27a7f6ac-5a12-49c6-9217-c9bc235faec0.png",
    "Company Name": "QAD",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qad.png",
    "Designation": "Graduate Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/shivam-samediya/?skipRedirect=true",
    "One liner Testimonial": "I chose not to go with my campus offer, waited for the right opportunity, and cracked my first interview through NxtWave.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "30bf2ab4-a3e4-4426-bbc7-b9fd445e3fde",
    "slug": "30bf2ab4-a3e4-4426-bbc7-b9fd445e3fde",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e236e419079c677f0a1e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vittal Yakari",
    "College": "Keshav Memorial Institute of Technology (KMIT), Narayanguda",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/30bf2ab4-a3e4-4426-bbc7-b9fd445e3fde.png",
    "Company Name": "Prolifics Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/prolifics-corporation.png",
    "Designation": "Software Engineer Trainee (AI/ML) [Offline Drive]",
    "linkedin profile link": "https://www.linkedin.com/in/yakari-vittal-rahul-0811272b8/",
    "One liner Testimonial": "I was a CS student, but college was all theory. NxtWave’s practical learning built my confidence and helped me turn my goal into a job.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "15193bed-4669-4ef4-b5f2-62b66b74f33d",
    "slug": "15193bed-4669-4ef4-b5f2-62b66b74f33d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e237b71290a3f329ff3c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:19 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anudeep Chitthaluri",
    "College": "Balaji Institute of Technology & Science, Narasampet",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/15193bed-4669-4ef4-b5f2-62b66b74f33d.png",
    "Company Name": "Milestone Technologies Inc",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/milestone-technologies-inc.png",
    "Designation": "Apprentice - Junior Remote Support Technician",
    "linkedin profile link": "https://www.linkedin.com/in/chanudeep/",
    "One liner Testimonial": "NxtWave supported me with skills, placements, and Telugu explanations whenever needed. That helped me crack my first tech job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Feb 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Feb"
  },
  {
    "UID": "b863beff-047d-47fd-9a43-76a8694d42d8",
    "slug": "b863beff-047d-47fd-9a43-76a8694d42d8",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e2382f8bc51b7e386cde",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Kalpana Dasari",
    "College": "N.B.K.R. Institute of Science & Technology (NBKRIST), Vidya Nagar",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b863beff-047d-47fd-9a43-76a8694d42d8.png",
    "Company Name": "OVI Learning LLP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ovi-learning-llp.png",
    "Designation": "Gen AI Intern",
    "linkedin profile link": "https://www.linkedin.com/in/saikalpanadasari/",
    "One liner Testimonial": "My father always wanted me to build a strong career. With structured learning and constant guidance at NxtWave, I proudly landed my first job.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "7714fcc7-790e-453f-b9cf-8c6c2af73aac",
    "slug": "7714fcc7-790e-453f-b9cf-8c6c2af73aac",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e238d0264038bfe97944",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Mahima Nishad",
    "College": "Quantum University Roorkee",
    "Branch": "MCA (Master of Computer Application)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/7714fcc7-790e-453f-b9cf-8c6c2af73aac.png",
    "Company Name": "Innoira",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/innoira.png",
    "Designation": "AI Web Developer Executive",
    "linkedin profile link": "https://www.linkedin.com/in/llmahima/",
    "One liner Testimonial": "COVID changed my plans and I had to take a drop. I kept trying, and when outside companies didn’t respond, NxtWave helped me finally get the opportunity I wanted.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "0edcec0f-acfc-4b27-aff3-ca5996e0c222",
    "slug": "0edcec0f-acfc-4b27-aff3-ca5996e0c222",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e239e419079c677f0b46",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pindi Punith Naga Venkata Sai",
    "College": "VIT Chennai",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0edcec0f-acfc-4b27-aff3-ca5996e0c222.png",
    "Company Name": "Crecientech",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/crecientech.png",
    "Designation": "Associate Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/pindipunith/",
    "One liner Testimonial": "I always wanted to enter tech. With timely job updates and constant support from NxtWave, I got my first offer and the right start to my career.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "ed2865e9-6ba7-4743-af82-f22489dd997d",
    "slug": "ed2865e9-6ba7-4743-af82-f22489dd997d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23a2c446314c0a5ce2e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Alankar Saxena",
    "College": "IIIT-Naya Raipur",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ed2865e9-6ba7-4743-af82-f22489dd997d.png",
    "Company Name": "QAD",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qad.png",
    "Designation": "Graduate Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/alankarsaxena25/",
    "One liner Testimonial": "Campus placements didn’t work out for me. I trusted NxtWave, applied only to roles matching my goals, and cracked a good job in a short time.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "c89e4316-f234-4682-adbe-fc29350b5b15",
    "slug": "c89e4316-f234-4682-adbe-fc29350b5b15",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23b9c85e142a72dc069",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Divyanshu Sharma",
    "College": "Indian Institute of Technology, Ropar",
    "Branch": "Electrical Engineering",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c89e4316-f234-4682-adbe-fc29350b5b15.png",
    "Company Name": "QAD",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qad.png",
    "Designation": "Graduate Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/divyanshu-sharma-6003b5284/",
    "One liner Testimonial": "I’m still an undergraduate, and this is my first job. While campus placements didn’t work out, NxtWave gave me many opportunities and helped me land one.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "d8c80790-5397-4bf6-aa82-47e7e93c31d6",
    "slug": "d8c80790-5397-4bf6-aa82-47e7e93c31d6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23be7bf6314941d23e2",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:02 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anant Saini",
    "College": "Indian Institute of Information Technology, Bhagalpur",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d8c80790-5397-4bf6-aa82-47e7e93c31d6.png",
    "Company Name": "QAD",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qad.png",
    "Designation": "Graduate Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/anant-saini-44b328259/",
    "One liner Testimonial": "I got my first tech offer in final year itself. With interview guidance and constant support from NxtWave, I cracked my very first interview opportunity.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "bb32b65f-56ec-4998-8035-ac054fb06faa",
    "slug": "bb32b65f-56ec-4998-8035-ac054fb06faa",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23c9c85e142a72dc083",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ali Mehdi Syed",
    "College": "Dwarkadas J. Sanghvi College of Engineering",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/bb32b65f-56ec-4998-8035-ac054fb06faa.png",
    "Company Name": "FedEx ACC",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fedex-acc.png",
    "Designation": "Software Engineering Intern",
    "linkedin profile link": "https://www.linkedin.com/in/ali-mehdi-syed/",
    "One liner Testimonial": "I kept doing internships, faced failures, and kept moving forward. With mock interviews and support from NxtWave, I got placed.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "b5268dcf-62ea-4489-9f9e-6b18700035f4",
    "slug": "b5268dcf-62ea-4489-9f9e-6b18700035f4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23c9c85e142a72dc09d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ankur Yadav",
    "College": "Indian Institute of Information Technology, Una",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b5268dcf-62ea-4489-9f9e-6b18700035f4.png",
    "Company Name": "QAD",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/qad.png",
    "Designation": "Graduate Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/ankur-yadav-a103a4257/",
    "One liner Testimonial": "I faced final-round rejections many times, but I kept going. With active support and real opportunities from NxtWave, I finally got my breakthrough job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "f6c79ada-a073-4182-b79a-ca88958f98d1",
    "slug": "f6c79ada-a073-4182-b79a-ca88958f98d1",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23c9c85e142a72dc0b7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shivateja Annaram",
    "College": "MLR Institute of Technology (MLRIT), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f6c79ada-a073-4182-b79a-ca88958f98d1.png",
    "Company Name": "OroGlee",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/oroglee.png",
    "Designation": "MERN Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/shivateja24/",
    "One liner Testimonial": "I had a gap after graduation and delayed joining offers. I restarted with NxtWave, stayed ready, and cracked my first interview for my first tech job.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "842a3ec6-3b37-448e-9fac-3d4688f653e5",
    "slug": "842a3ec6-3b37-448e-9fac-3d4688f653e5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23cc321bebe24b504b2",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Lakshmi Devi Mallela",
    "College": "RCR Institute of Technology and Management",
    "Branch": "MCA (Master of Computer Application)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/842a3ec6-3b37-448e-9fac-3d4688f653e5.png",
    "Company Name": "Effigent Software Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/effigent-software-solutions.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/mallela-lakshmi-7bb625296/",
    "One liner Testimonial": "I paused my journey for MCA, then came back stronger. With consistent learning and placement support from NxtWave, I cracked my first Software Engineer job.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "824e464a-aaeb-4764-9f26-45f0479aee5c",
    "slug": "824e464a-aaeb-4764-9f26-45f0479aee5c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23d1a77ab28151f70b3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Namandeep Singh",
    "College": "Indian Institute of Information Technology Bhopal",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/824e464a-aaeb-4764-9f26-45f0479aee5c.png",
    "Company Name": "Raja Software Labs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/raja-software-labs.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/naman991/?skipRedirect=true",
    "One liner Testimonial": "I already had job experience, but wanted better growth. With the right opportunities and timely support from NxtWave, I cracked my next Software Engineer role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "7",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "25bf97d5-bc61-4838-b8eb-c0cb4aea9e7a",
    "slug": "25bf97d5-bc61-4838-b8eb-c0cb4aea9e7a",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23e7211763e4193ae7d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Saisree Munjeti",
    "College": "JB Institute Of Engineering and Technology (JBIET)",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/25bf97d5-bc61-4838-b8eb-c0cb4aea9e7a.png",
    "Company Name": "Prolifics Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/prolifics-corporation.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/saisree-munjeti/",
    "One liner Testimonial": "NxtWave didn’t just share job openings, they supported me till the end. That guidance helped me land my first and most awaited tech job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "65781394-4d1a-4672-8f6a-a1bff2c7b1b3",
    "slug": "65781394-4d1a-4672-8f6a-a1bff2c7b1b3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e23ee7bf6314941d24b6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kishan A",
    "College": "City Engineering College (CEC), Doddakallasandra",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/65781394-4d1a-4672-8f6a-a1bff2c7b1b3.png",
    "Company Name": "Poper.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/poper.ai.png",
    "Designation": "Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/kishan-a-04705b234/",
    "One liner Testimonial": "I wanted a job in my own location while studying in college. With consistent learning and support from NxtWave, I made it happen with my first Fullstack role.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "22a3748f-4098-4ea3-9311-f6a01f0b7957",
    "slug": "22a3748f-4098-4ea3-9311-f6a01f0b7957",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e2402c446314c0a5d198",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:28 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anil Kumar Raju Addepalli Balaraju",
    "College": "Potti Sriramulu Chalavadi Mallikarjuna Rao College Of Engineering And Technology",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/22a3748f-4098-4ea3-9311-f6a01f0b7957.png",
    "Company Name": "Shift.AI",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/shift.ai.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/anil-kumar-rajuab/",
    "One liner Testimonial": "I faced setbacks for 2 years and almost gave up on IT. After many attempts, NxtWave’s constant support helped me finally become a Software Engineer.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.8",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "701ba495-51a6-4b28-9fb8-2077baa5e5a0",
    "slug": "701ba495-51a6-4b28-9fb8-2077baa5e5a0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e24051e0e7d1284020c8",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:28 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vishnuvardhan Reddy Bhavanam",
    "College": "R. V. R. & J. C. College of Engineering",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/701ba495-51a6-4b28-9fb8-2077baa5e5a0.png",
    "Company Name": "ACCELQ",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/accelq.png",
    "Designation": "Intern",
    "linkedin profile link": "https://www.linkedin.com/in/vishnuvardhan-reddy-bhavanam-633b22207?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "One liner Testimonial": "I joined NxtWave in my second year and stayed consistent alongside college. Through continuous effort and support, I earned my first job as an Intern.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "068d419b-0f5e-45fa-9a4f-3b63bb1be321",
    "slug": "068d419b-0f5e-45fa-9a4f-3b63bb1be321",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e2411a77ab28151f7361",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Chigullapally Sai Prakash",
    "College": "MLR Institute of Technology",
    "Branch": "Cybersecurity",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/068d419b-0f5e-45fa-9a4f-3b63bb1be321.png",
    "Company Name": "ACCELQ",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/accelq.png",
    "Designation": "Associate Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/chigullapally-sai-prakash/",
    "One liner Testimonial": "My campus offer was on hold, but I didn’t stop trying. With quick responses and strong support from NxtWave, I got my first job.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "38e90358-b12e-4306-9140-6880f9830539",
    "slug": "38e90358-b12e-4306-9140-6880f9830539",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e241c321bebe24b508ad",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bhargava Surendra Chekuri",
    "College": "ELURU COLLEGE OF ENGINEERING & TECHNOLOGY, Chuttigunta,Apparaopalem",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/38e90358-b12e-4306-9140-6880f9830539.png",
    "Company Name": "The Money Club",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/the-money-club.png",
    "Designation": "Python Developer",
    "linkedin profile link": "https://www.linkedin.com/in/chekuri-bhargava-surendra-b34380252/",
    "One liner Testimonial": "Campus offered mostly non-IT roles, but I wanted tech. NxtWave gave me more opportunities, and I cracked my very first interview for a Python Developer job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "bd3d74f2-285a-4463-b2a0-cd2fae19f0af",
    "slug": "bd3d74f2-285a-4463-b2a0-cd2fae19f0af",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e242ae6e576993751dc0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:30 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:30:56 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sravani Kurella",
    "College": "Indur Institute Of Engineering & Technology",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/bd3d74f2-285a-4463-b2a0-cd2fae19f0af.png",
    "Company Name": "Enmovil",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/enmovil.png",
    "Designation": "Jnr Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sravani-kurella-46801b271/",
    "One liner Testimonial": "From a tier 3 college with fewer placements, I kept trying through 20+ interviews. With NxtWave’s roadmap and support, I landed my first developer job.\n",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "cf7fcf64-9e78-44df-b678-b5eb5ad76fdf",
    "slug": "cf7fcf64-9e78-44df-b678-b5eb5ad76fdf",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e247ae6e576993751ea9",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pragati Aggarwal",
    "College": "NIT Jalandhar",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/cf7fcf64-9e78-44df-b678-b5eb5ad76fdf.png",
    "Company Name": "Arcserve",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/arcserve.png",
    "Designation": "Frontend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/pragati-aggarwal-6b7878249/",
    "One liner Testimonial": "I’m still an undergraduate, and getting my first job offer feels amazing. With good opportunities and support from NxtWave, I became a Frontend Developer.\n",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "7",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "5e5cd97d-708d-4421-9c75-fb8236c99661",
    "slug": "5e5cd97d-708d-4421-9c75-fb8236c99661",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e247bb81c268bfbe93c6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kasula Siddarth",
    "College": "Vidya Jyothi Institute of Technology",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5e5cd97d-708d-4421-9c75-fb8236c99661.png",
    "Company Name": "Htc global services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/htc-global-services.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/k-siddarth18/",
    "One liner Testimonial": "Getting shortlisted so early after graduation feels like the perfect start to my career.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "e580a9c1-36f2-4693-a20a-400ef7666e42",
    "slug": "e580a9c1-36f2-4693-a20a-400ef7666e42",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "69e9e248e419079c677f10ed",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Thu Apr 23 2026 09:11:36 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Thu Apr 23 2026 09:16:01 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Thu Apr 23 2026 09:19:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ravi Kumar Suddala",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), RK Valley",
    "Branch": "Civil Engineering (CE)",
    "Graduate year": "2020",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e580a9c1-36f2-4693-a20a-400ef7666e42.png",
    "Company Name": "Effigent Software Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/effigent-software-solutions.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/ravi-kumar-suddala-91b25a172/",
    "One liner Testimonial": "I carried pain, odd jobs, and setbacks for years. The day I got my first tech job, it felt like life finally turned in my favor.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "5d770aa0-803e-459e-bb9a-a40625d2a7a6",
    "slug": "5d770aa0-803e-459e-bb9a-a40625d2a7a6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041afbcb9879efabdbf861",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Yaswanth Sai Gonuguntla",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT), Ongole",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5d770aa0-803e-459e-bb9a-a40625d2a7a6.png",
    "Company Name": "Nablon AI",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/nablon-ai.png",
    "Designation": "AI/ ML Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/yaswanth-sai-gonuguntla/",
    "One liner Testimonial": "I joined early to stay ahead of the market. By final year, I didn’t just get a job, I got my dream role as an AI/ML Engineer.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "41809daa-80ba-49bc-8b16-e38e6ac8afcc",
    "slug": "41809daa-80ba-49bc-8b16-e38e6ac8afcc",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041afd359999b3b75d3698",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:29 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ragula Manogna",
    "College": "Malla Reddy Engineering College for Women (MRECW)",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/41809daa-80ba-49bc-8b16-e38e6ac8afcc.png",
    "Company Name": "Capgemini",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/capgemini.png",
    "Designation": "Data Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/manognareddy-ragula-7ba553339/",
    "One liner Testimonial": "After many attempts and self-doubt, I cracked my very first interview. Getting my first job felt like the moment I had been waiting for.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5.5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "66644ecc-a1d7-413f-a4ca-19e4436571e7",
    "slug": "66644ecc-a1d7-413f-a4ca-19e4436571e7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041aff8f5565d39a234751",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:31 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Harshit Singh",
    "College": "Indian Institute of Information Technology Ranchi",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/66644ecc-a1d7-413f-a4ca-19e4436571e7.png",
    "Company Name": "Indiamart",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/indiamart.png",
    "Designation": "SDE Intern",
    "linkedin profile link": "https://www.linkedin.com/in/harshit-singh-97b055265/",
    "One liner Testimonial": "I kept showing up through many tests and interviews. The day I got selected, all that effort finally felt worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "9",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "914733f9-5142-49b5-997d-94fdc8106e64",
    "slug": "914733f9-5142-49b5-997d-94fdc8106e64",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b00c27e474436620152",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:32 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Abhishek C H",
    "College": "Cambridge Institute of Technology (CIT), Bengaluru",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/914733f9-5142-49b5-997d-94fdc8106e64.png",
    "Company Name": "kristalball",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kristalball.png",
    "Designation": "Intern",
    "linkedin profile link": "https://www.linkedin.com/in/errorwithabhich/",
    "One liner Testimonial": "I started learning early and stayed consistent for years. Still in final year, I’ve already begun my career with another internship win.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "6085bbcc-244b-439f-a132-29a98f0b3bcb",
    "slug": "6085bbcc-244b-439f-a132-29a98f0b3bcb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b03c27e47443662042d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:35 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anudeep Kaddala",
    "College": "Vidya Jyothi Institute Of Technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6085bbcc-244b-439f-a132-29a98f0b3bcb.png",
    "Company Name": "Digitap.ai",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/digitap.ai.png",
    "Designation": "Python Backend Intern",
    "linkedin profile link": "https://www.linkedin.com/in/anudeepkaddala/",
    "One liner Testimonial": "A health setback cost me my first job. I couldn't go back to the office, so I had to leave. NxtWave let me learn from home, and within months, I had my next offer.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "6",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "9aa93aff-f68e-462f-85f2-550151e8c6c7",
    "slug": "9aa93aff-f68e-462f-85f2-550151e8c6c7",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b06c27e47443662080a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:38 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jammula Mohan Sai Ritesh",
    "College": "VIT AP",
    "Branch": "Computer Science and Engineering (AI & ML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9aa93aff-f68e-462f-85f2-550151e8c6c7.png",
    "Company Name": "ARTH",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/arth.png",
    "Designation": "AI Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/mohan-sai-ritesh/?skipRedirect=true",
    "One liner Testimonial": "I spent months applying everywhere and barely got calls. With NxtWave, I stopped hunting and started choosing. Now I'm an AI Engineer.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "ad6ada7f-3b50-4070-97fd-bd2879b989fd",
    "slug": "ad6ada7f-3b50-4070-97fd-bd2879b989fd",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b07c27e47443662092a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:39 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sathvika ",
    "College": "Sasi Institute of Technology and Engineering ",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ad6ada7f-3b50-4070-97fd-bd2879b989fd.png",
    "Company Name": "Bridgesoft",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/bridgesoft.png",
    "Designation": "Trainee – Business Analyst",
    "linkedin profile link": "https://www.linkedin.com/in/sathvika-vuddagiri-a07710253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_ayouyoupp",
    "One liner Testimonial": "EEE student, no IT background, no campus offers. But here I am, a Business Analyst, making my parents proud. This was my first shot, and it landed. All because of NxtWave.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "1c46b7aa-508c-4059-b41f-566b1cd1e85c",
    "slug": "1c46b7aa-508c-4059-b41f-566b1cd1e85c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b08c27e474436620a66",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:40 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Renuka Kancharla",
    "College": "Mohan Babu University (MBU), Tirupati",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1c46b7aa-508c-4059-b41f-566b1cd1e85c.png",
    "Company Name": "Arcserve",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/arcserve.png",
    "Designation": "Frontend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/renuka-kancharla/",
    "One liner Testimonial": "I was unsure about my career until my mom pushed me to try this path. Getting placed before graduation proved I was on the right track and seeing my family proud made it all worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "7",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "348292f5-b650-4284-a8d5-91271a9ffacd",
    "slug": "348292f5-b650-4284-a8d5-91271a9ffacd",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b08cb9879efabdbfe77",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:40 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Muthana Keerthana",
    "College": "Anantha Lakshmi Institute of Technology & Sciences",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/348292f5-b650-4284-a8d5-91271a9ffacd.png",
    "Company Name": "Enmovil",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/enmovil.png",
    "Designation": "Jr. Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/keerthana-muthana-73b271284/",
    "One liner Testimonial": "I waited for offers, tried different paths, and faced a gap I was scared to explain. Then NxtWave placed me and nobody even asked about the gap.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "29517d82-d664-4fe4-9270-d0aba42977eb",
    "slug": "29517d82-d664-4fe4-9270-d0aba42977eb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b0920b2d6df82e64d45",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:41 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Thivyan Ks",
    "College": "SRM MADURAI COLLEGE FOR ENGINEERING AND TECHNOLOGY",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2027",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/29517d82-d664-4fe4-9270-d0aba42977eb.png",
    "Company Name": "Vindago Innovations LLP",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/vindago-innovations-llp.png",
    "Designation": "Frontend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/thivyan-ks/?skipRedirect=true",
    "One liner Testimonial": "My college barely talked about placements. I stopped waiting and built my own path. Now I'm on my second internship, and the growth feels very real.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed Mar 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "",
    "Full Testimonial": "",
    "Placed Month": "Mar"
  },
  {
    "UID": "d7491761-4904-4ff1-9b69-dd83217d9f2d",
    "slug": "d7491761-4904-4ff1-9b69-dd83217d9f2d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b09f9b90d594100a904",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:41 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nandika Saini",
    "College": "Manipal University Jaipur ",
    "Branch": "Computer and communication",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d7491761-4904-4ff1-9b69-dd83217d9f2d.png",
    "Company Name": "Emergent Labs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/emergent-labs.png",
    "Designation": "AI Agent Reliability Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/nandika-saini-a89078275/",
    "One liner Testimonial": "Still in college, and I already have my offer letter. An AI role, a dream company, and a career that's starting sooner than I ever imagined.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "15",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "24d9a8aa-6a50-4557-ba7b-df3f6a7f4717",
    "slug": "24d9a8aa-6a50-4557-ba7b-df3f6a7f4717",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b0a445a74b41b9e2030",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:42 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Maheswar Reddy Bala Obanna Gari",
    "College": "Siddharth Institute of Engineering and Technology (SIETK), Puttur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/24d9a8aa-6a50-4557-ba7b-df3f6a7f4717.png",
    "Company Name": "AiZen Algo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aizen-algo.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/maheswar-reddy-bala-obanna-gari/",
    "One liner Testimonial": "60+ applications. 2 unpaid internships. Countless rejections. I kept going anyway. Nobody asked about my gap. My skills did the talking.",
    "Branch Filter": "Career Gap",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "9a02e07d-42c7-4dc5-9373-9fbc4dc5b02f",
    "slug": "9a02e07d-42c7-4dc5-9373-9fbc4dc5b02f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b0a63108ee23aaa37e0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:42 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 06:33:57 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 06:36:41 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vamshi Bommishetty",
    "College": "B V Raju Institute of Technology (BVRIT), Narsapur, Medak",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9a02e07d-42c7-4dc5-9373-9fbc4dc5b02f.png",
    "Company Name": "Toorey",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/toorey.png",
    "Designation": "Associate SDE",
    "linkedin profile link": "https://www.linkedin.com/in/vamshi-bommishetty-5a3360228/",
    "One liner Testimonial": "I was scared of interviews and even thought of quitting. I still showed up, and in my very first attempt, I proved to myself that I could do it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "224a5490-d20f-4b92-86d3-485803fa1036",
    "slug": "224a5490-d20f-4b92-86d3-485803fa1036",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a041b0b0c00d1ae2d2dfd00",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Wed May 13 2026 06:32:43 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Wed May 13 2026 12:02:48 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Wed May 13 2026 12:03:12 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Pitla Harsha Vardhan",
    "College": "CMR College of Engineering & Technology (CMRCET), Kandlakoya",
    "Branch": "Artificial Intelligence and Machine Learning (AI/ML)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/224a5490-d20f-4b92-86d3-485803fa1036.png",
    "Company Name": "Toorey",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/toorey.png",
    "Designation": "Associate SDE",
    "linkedin profile link": "https://www.linkedin.com/in/pitlaharshavardhan/",
    "One liner Testimonial": "I lost my first opportunity and faced a lot of noise around me. I stayed consistent, and being one of the few selected out of many proved it was all worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "fd549431-1260-4b88-94fb-c6b11456ad49",
    "slug": "fd549431-1260-4b88-94fb-c6b11456ad49",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c7f37eb0e50b1d402e7",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:07 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "P. Sri Vardhan",
    "College": "Centurion University, Vizianagaram",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/fd549431-1260-4b88-94fb-c6b11456ad49.png",
    "Company Name": "Sysrek",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/sysrek.png",
    "Designation": "Python Developer",
    "linkedin profile link": "https://www.linkedin.com/in/pnssrivardhan/",
    "One liner Testimonial": "Campus placements didn’t work out for me, and the wait felt long. After many applications, getting my first developer job finally made everything feel worth it.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "d1d8d180-1354-42d7-93d8-067d02d59dd8",
    "slug": "d1d8d180-1354-42d7-93d8-067d02d59dd8",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c804a3a1859691dd3c1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sriram Komma",
    "College": "CMR College of Engineering & Technology (CMRCET), Kandlakoya",
    "Branch": "AIML ",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/d1d8d180-1354-42d7-93d8-067d02d59dd8.png",
    "Company Name": "Toorey",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/toorey.png",
    "Designation": "Associate SDE",
    "linkedin profile link": "https://www.linkedin.com/in/sriramkomma/",
    "One liner Testimonial": "Getting placed before graduation gave me a different kind of confidence. It felt like the first real step toward building my own future independently.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "1b7cb341-cc66-4815-a203-34665f29cc51",
    "slug": "1b7cb341-cc66-4815-a203-34665f29cc51",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c80edb77f923b59d3dd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:08 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Venkata Sai Krishna Mettakanti",
    "College": "G.Pulla Reddy Engineering College (GPREC), Kurnool",
    "Branch": "Computer Science Engineering (Data Science)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1b7cb341-cc66-4815-a203-34665f29cc51.png",
    "Company Name": "Toorey",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/toorey.png",
    "Designation": "Associate SDE",
    "linkedin profile link": "https://www.linkedin.com/in/venkata-sai-krishna-mettakanti-28474b270/",
    "One liner Testimonial": "I once doubted whether I had real skills. Building real projects and cracking my very first interview changed the way I saw myself completely.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "0d4ad07e-c361-4390-ab62-00d86a8af750",
    "slug": "0d4ad07e-c361-4390-ab62-00d86a8af750",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c814a3a1859691dd50b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Jayanth Anna",
    "College": "G. Pullaiah College of Engineering and Technology (GPCET), Kurnool",
    "Branch": "Computer Science and Engineering (Data Science)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0d4ad07e-c361-4390-ab62-00d86a8af750.png",
    "Company Name": "Toorey",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/toorey.png",
    "Designation": "Associate SDE",
    "linkedin profile link": "https://www.linkedin.com/in/jayanth-anna-3913b423b/",
    "One liner Testimonial": "I kept hearing AI would replace jobs and honestly felt scared. But staying consistent, building projects, and showing up for interviews changed everything for me.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "b9a7625e-d4d1-4835-b301-7951ebe4dc8d",
    "slug": "b9a7625e-d4d1-4835-b301-7951ebe4dc8d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c822bf4400589846795",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shivakumar Bojanapu",
    "College": "Rajiv Gandhi University of Knowledge Technologies, Basar",
    "Branch": "Computer Science and Engineering (AI & ML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b9a7625e-d4d1-4835-b301-7951ebe4dc8d.png",
    "Company Name": "Aizen Algo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aizen-algo.png",
    "Designation": "Trainee Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/shivakumar-bojanapu-6a304724b/",
    "One liner Testimonial": "In today’s tough market, I was losing confidence in my job search. Getting shortlisted again and finally landing this role gave me hope that my efforts were worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "ef9ae3b7-3126-4124-8954-b4041c4f0201",
    "slug": "ef9ae3b7-3126-4124-8954-b4041c4f0201",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c826a3d2d2bfc1398d0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nandika Mohith",
    "College": "Vellore Institute of Technology",
    "Branch": "Computer Science and Engineering (AI & ML)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ef9ae3b7-3126-4124-8954-b4041c4f0201.png",
    "Company Name": "Zoo Media",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/zoo-media.png",
    "Designation": "AI Intern",
    "linkedin profile link": "https://www.linkedin.com/in/mohith-nandika/",
    "One liner Testimonial": "I was applying everywhere but barely hearing back. The moment I finally started getting interview responses, my confidence completely changed.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "cc22ad58-e5d7-41d8-8418-76edce004e66",
    "slug": "cc22ad58-e5d7-41d8-8418-76edce004e66",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c832bf440058984696f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Anusha Gaddam",
    "College": "NRI Institute of Technology",
    "Branch": "Artificial Intelligence and Machine Learning",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/cc22ad58-e5d7-41d8-8418-76edce004e66.png",
    "Company Name": "KonnectNXT",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/konnectnxt.png",
    "Designation": "Full-Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/anusha-gaddam-80278b257/",
    "One liner Testimonial": "My campus didn’t bring many good opportunities, so every rejection started affecting me. Cracking this role after multiple interviews felt deeply personal and rewarding.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "710204f4-f6b7-4c44-8a92-b7c87892a0e2",
    "slug": "710204f4-f6b7-4c44-8a92-b7c87892a0e2",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8337eb0e50b1d4054a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Atul Kumar Pandey",
    "College": "Sharda University, Noida",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/710204f4-f6b7-4c44-8a92-b7c87892a0e2.png",
    "Company Name": "Emplay Inc.",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/emplay-inc..png",
    "Designation": "Frontend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/atulpandeyy7/?isSelfProfile=false",
    "One liner Testimonial": "Between family health issues and career pressure, I lost consistency for a while. Getting this role reminded me that it’s never too late to restart and move forward.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "4933a917-7221-466f-a69e-3db0745b4799",
    "slug": "4933a917-7221-466f-a69e-3db0745b4799",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c84350705df5d67600d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Katta Nanda Kishore",
    "College": "Lakireddy Bali Reddy College of Engineering (LBRCE), Mylavaram",
    "Branch": "Electronics & Communication Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/4933a917-7221-466f-a69e-3db0745b4799.png",
    "Company Name": "Phenom Cloud",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom-cloud.png",
    "Designation": "Python Developer",
    "linkedin profile link": "https://www.linkedin.com/in/nanda-kishore-katta-425040289/?isSelfProfile=false",
    "One liner Testimonial": "I came from an ECE background with only basic coding knowledge. Cracking my very first interview and getting my first tech job still feels unreal.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "2e1bfa03-066c-4a98-bab2-9d27c5ac27d4",
    "slug": "2e1bfa03-066c-4a98-bab2-9d27c5ac27d4",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c85350705df5d67602e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Koduru Naga Venkata Akash",
    "College": "KITS Akshar Institute of Technology",
    "Branch": "Computer Science and Engineering (AI & ML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/2e1bfa03-066c-4a98-bab2-9d27c5ac27d4.png",
    "Company Name": "Phenom Cloud",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/phenom-cloud.png",
    "Designation": "Python Developer",
    "linkedin profile link": "https://www.linkedin.com/in/akash-koduru-20b25225a/?isSelfProfile=false",
    "One liner Testimonial": "After graduation, I kept facing rejections and uncertainty. Getting my first job finally made me feel like all those attempts were worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "45b71f81-7041-4f61-9f66-726fe17fba5e",
    "slug": "45b71f81-7041-4f61-9f66-726fe17fba5e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c85350705df5d676057",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Devansh Gupta",
    "College": "Harcourt Butler Technical University Kanpur",
    "Branch": "Information Technology",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/45b71f81-7041-4f61-9f66-726fe17fba5e.png",
    "Company Name": "Probe42",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/probe42.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/devansh-gupta-521402253/?isSelfProfile=false",
    "One liner Testimonial": "Getting multiple offers while still in my final year felt surreal. I just wanted one chance to prove myself, and everything changed after that",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "fe76f54c-0371-419f-a2b9-a87ebaf25340",
    "slug": "fe76f54c-0371-419f-a2b9-a87ebaf25340",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c86047c8484b2d69b65",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Prudhvi Likhit Gangadhar",
    "College": "Anurag University",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/fe76f54c-0371-419f-a2b9-a87ebaf25340.png",
    "Company Name": "Htc global services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/htc-global-services.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/likhit-prudhvi/",
    "One liner Testimonial": "Coming from an ECE background, getting my first tech job feels like a big personal win. I’m genuinely happy that I stayed consistent and kept trying.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "b7f40c23-c015-454c-bdb3-1de85ada9c9c",
    "slug": "b7f40c23-c015-454c-bdb3-1de85ada9c9c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c86047c8484b2d69bfa",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Akula Bharath",
    "College": "Rajiv Gandhi University of Knowledge Technologies (RGUKT) Nuzvid",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b7f40c23-c015-454c-bdb3-1de85ada9c9c.png",
    "Company Name": "Milestone Technologies Inc",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/milestone-technologies-inc.png",
    "Designation": "Apprentice - Junior Remote Support Technician",
    "linkedin profile link": "https://www.linkedin.com/in/akula-bharath-844722251/?isSelfProfile=false",
    "One liner Testimonial": "My campus had very limited placements, and I didn’t even have strong coding skills initially. Restarting seriously and getting my first tech job changed my confidence completely.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "c278055f-5ec2-4ff4-af5c-f33460083a7e",
    "slug": "c278055f-5ec2-4ff4-af5c-f33460083a7e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c86f7190bbdf6075d86",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Vardhan Gurijala",
    "College": "Malla Reddy University ",
    "Branch": "Computer Science and Engineering (AI/ML)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/c278055f-5ec2-4ff4-af5c-f33460083a7e.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/sai-vardhan-gurijala/?isSelfProfile=false",
    "One liner Testimonial": "My college felt too theoretical, so I started searching for something more practical. Getting my first tech job now feels like that decision paid off.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "927716df-95b5-40c3-91d1-2fd3e2dab228",
    "slug": "927716df-95b5-40c3-91d1-2fd3e2dab228",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c874dcc81eac23df820",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manichandra Duddukuri",
    "College": "Gudlavalleru Engineering College (GEC), Gudlavalleru",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/927716df-95b5-40c3-91d1-2fd3e2dab228.png",
    "Company Name": "Freedom With AI",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/freedom-with-ai.png",
    "Designation": "Jr. AI Intern",
    "linkedin profile link": "https://www.linkedin.com/in/manichandraduddukuri/?isSelfProfile=false",
    "One liner Testimonial": "I already had technical skills, but I was waiting for the right breakthrough. Cracking a job in my very first interview finally gave me that confidence.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "a03deb11-f359-4661-b451-28ceee81f03c",
    "slug": "a03deb11-f359-4661-b451-28ceee81f03c",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8764bf22b607933884",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "L.N.Gupta Vema",
    "College": "Vikas College of Engineering and Technology (VCET), Nunna",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a03deb11-f359-4661-b451-28ceee81f03c.png",
    "Company Name": "Nirvesh Enterprises",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/nirvesh-enterprises.png",
    "Designation": "Full-Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/v-l-n-gupta/?isSelfProfile=false",
    "One liner Testimonial": "Coming from a tier-3 college, I always felt I needed something beyond academics. Cracking my first job after multiple attempts felt deeply personal for me and my family.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "87edb203-4fe2-43c7-bfae-b58b69d92272",
    "slug": "87edb203-4fe2-43c7-bfae-b58b69d92272",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c88af0c3e1a7d072040",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Saubhagay Goyal",
    "College": "KG Reddy College of Engineering and Technology",
    "Branch": "Computer Science Engineering (Data Science)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/87edb203-4fe2-43c7-bfae-b58b69d92272.png",
    "Company Name": "Saambavilabs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/saambavilabs.png",
    "Designation": "Fullstack AI Intern",
    "linkedin profile link": "https://www.linkedin.com/in/saubhagay0109/?isSelfProfile=false",
    "One liner Testimonial": "Getting placed while still in college made me feel I’m moving in the right direction. The practical learning approach genuinely changed how I understood tech.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "09c4e46f-acb4-43e6-b53e-9354187f4c57",
    "slug": "09c4e46f-acb4-43e6-b53e-9354187f4c57",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c89035188e3f403caec",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Ambati Venkateswarlu",
    "College": "Kallam Haranadha Reddy Institute of Technology ",
    "Branch": "Computer Science Engineering (CSE) AIML ",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/09c4e46f-acb4-43e6-b53e-9354187f4c57.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/venkateswarlu-ambati-aa50a4315?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "One liner Testimonial": "I kept hearing AI would replace jobs. Getting placed before graduation proved to me that consistent learning still matters.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "69bb124f-4983-4c8c-9284-f284cb851fc8",
    "slug": "69bb124f-4983-4c8c-9284-f284cb851fc8",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c89048d3fade1ab1f2e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:17 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Saikiran Yarlagadda",
    "College": "DVR & Dr HS Mic college of Technology ",
    "Branch": "Computer Science and Engineering ",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/69bb124f-4983-4c8c-9284-f284cb851fc8.png",
    "Company Name": "Freedom With AI",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/freedom-with-ai.png",
    "Designation": "AI Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/saikiran-yarlagadda-3b48b731b/",
    "One liner Testimonial": "I stopped focusing only on theory and started building real projects consistently. Getting an AI role before graduation felt like proof that the effort was worth it.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "741f64c3-860a-49b2-927a-0b84a6eb6b69",
    "slug": "741f64c3-860a-49b2-927a-0b84a6eb6b69",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8b048d3fade1ab21ed",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:19 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "E Jayanth Madhav",
    "College": "Chaitanya Bharathi Institute of Technology",
    "Branch": "AIML ",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/741f64c3-860a-49b2-927a-0b84a6eb6b69.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/jayanth-madhav/",
    "One liner Testimonial": "Getting my first full-time offer felt special, but seeing my parents genuinely proud of me made that moment unforgettable.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "db93f7ad-f55f-467d-8c5d-72b650b9b0bb",
    "slug": "db93f7ad-f55f-467d-8c5d-72b650b9b0bb",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8bc8811b662ef88e52",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:19 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kavyasri Regalla",
    "College": "Sai Spurthi Institute Of Technology ",
    "Branch": "Computer Science and Engineering ",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/db93f7ad-f55f-467d-8c5d-72b650b9b0bb.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/kavyasri-regalla-463863281/?isSelfProfile=false",
    "One liner Testimonial": "Every rejection taught me something. When I finally got my first offer, it felt like all those failures had prepared me for it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "ca92472c-bece-44fc-bb9c-428aad01bbc6",
    "slug": "ca92472c-bece-44fc-bb9c-428aad01bbc6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8c2bf440058984720f",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Atla Yaswanth ",
    "College": "KKR & KSR Institute of Technology and Sciences (KKRKSRITAS), Vinjanampadu",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ca92472c-bece-44fc-bb9c-428aad01bbc6.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/atlayaswanth",
    "One liner Testimonial": "College gave me theory, but real confidence came when I started building and practicing consistently. That’s what helped me crack my first job.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "a9937037-97ac-4862-86ee-5f295430cbb8",
    "slug": "a9937037-97ac-4862-86ee-5f295430cbb8",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8c37eb0e50b1d408a6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nissy Jakkula",
    "College": "Kamala Institute of Technology & Science (KITS), Telangana",
    "Branch": "Civil Engineering (CE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a9937037-97ac-4862-86ee-5f295430cbb8.png",
    "Company Name": "AiZen Algo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/aizen-algo.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/jakkula-nissy/",
    "One liner Testimonial": "Coming from Civil Engineering with a career gap, I never thought I’d break into tech. Getting my first software job felt deeply personal.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "aaeb086d-ed70-4130-8494-3762273ba254",
    "slug": "aaeb086d-ed70-4130-8494-3762273ba254",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8d200654eca166833b",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Naga Revanth Gurram",
    "College": "Holy Mary Institute of Technology and Science",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/aaeb086d-ed70-4130-8494-3762273ba254.png",
    "Company Name": "QuantifyAI",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/quantifyai.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/nagarevanth/?isSelfProfile=false",
    "One liner Testimonial": "I started with zero coding knowledge and spent nights learning consistently. Every rejection taught me something, and eventually, it all paid off.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "a9111813-26cf-4314-ad5e-3bbc1e343a5e",
    "slug": "a9111813-26cf-4314-ad5e-3bbc1e343a5e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8d6a3d2d2bfc139d68",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shaik Sarfaraz",
    "College": "St.Ann's college of Engineering and Technology ",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a9111813-26cf-4314-ad5e-3bbc1e343a5e.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/shaik-sarfaraz-reactjs-mernstack/",
    "One liner Testimonial": "After struggling for a year without giving up, getting my first tech job felt emotional. Seeing my aunt and uncle proud of me meant everything.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "136628ba-0f91-4302-b123-1ae52687c5c9",
    "slug": "136628ba-0f91-4302-b123-1ae52687c5c9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8dc8811b662ef890a3",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Kunal Nemade",
    "College": "Thadomal Shahani Engineering College (TSEC), Mumbai",
    "Branch": "Information Technology (IT)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/136628ba-0f91-4302-b123-1ae52687c5c9.png",
    "Company Name": "BlaZop",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/blazop.png",
    "Designation": "Full-stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/kunal-nemade-kn244/?isSelfProfile=false",
    "One liner Testimonial": "Getting a remote tech job before graduation felt unreal, especially in today’s market. Consistency and learning from failures changed everything for me.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "3.5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "3cf7cd0d-f097-4d8e-9012-7e50202250cc",
    "slug": "3cf7cd0d-f097-4d8e-9012-7e50202250cc",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8e73bba3061a70c663",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Himanshu Raj",
    "College": "Lovely Professional University, Punjab",
    "Branch": "Computer Science and Engineering ",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3cf7cd0d-f097-4d8e-9012-7e50202250cc.png",
    "Company Name": "Shopflo",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/shopflo.png",
    "Designation": "Associate Software Engineer ",
    "linkedin profile link": "https://www.linkedin.com/in/hr7657316/?isSelfProfile=false",
    "One liner Testimonial": "I already had internship experience, but this role finally gave me the confidence that I’m building a strong career in tech.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "e8ad9d75-9611-4580-bb9c-e7d16f0c0c3f",
    "slug": "e8ad9d75-9611-4580-bb9c-e7d16f0c0c3f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8f047c8484b2d6a2cf",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Medapati Manmohan Reddy",
    "College": "Kakinada Institute of Engineering and Technology",
    "Branch": "Computer Science and Engineering (Data Science)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e8ad9d75-9611-4580-bb9c-e7d16f0c0c3f.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/manmohanreddy1111/",
    "One liner Testimonial": "After many failed job attempts, I finally cracked my first role. Every interview taught me something, and this win made all the struggles worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "b5d1b98e-21dd-4485-9c06-59eb29e48902",
    "slug": "b5d1b98e-21dd-4485-9c06-59eb29e48902",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c8f7a57d365ed07b563",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Nekkala Harshita ",
    "College": "Vignan's Institute of Information Technology",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/b5d1b98e-21dd-4485-9c06-59eb29e48902.png",
    "Company Name": "Cubic Corporation",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/cubic-corporation.png",
    "Designation": "Trainee- Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/harshita-nekkala-972346284/overlay/background-photo/",
    "One liner Testimonial": "I waited almost a year for the right opportunity. There were moments I felt lost, but getting my first tech job made every setback feel worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "4659b7e7-5fd7-444e-b417-f147a06219d9",
    "slug": "4659b7e7-5fd7-444e-b417-f147a06219d9",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c90047c8484b2d6a440",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Venkata Ashok Kumar Reddy Yeduru",
    "College": " Rajiv Gandhi University of Knowledge Technologies,Ongole",
    "Branch": "Electronics & Communication Engineering",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/4659b7e7-5fd7-444e-b417-f147a06219d9.png",
    "Company Name": "Kajkarma",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kajkarma.png",
    "Designation": "Full Stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/venkata-ashok-kumar-reddy-yeduru-b5824b24a/?isSelfProfile=false",
    "One liner Testimonial": "I joined early because I didn’t want to struggle after graduation. Cracking my first interview in final year made that decision feel completely worth it.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sat Apr 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Apr"
  },
  {
    "UID": "8feaf4a6-a371-4c8c-b0b0-d320a88e816e",
    "slug": "8feaf4a6-a371-4c8c-b0b0-d320a88e816e",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c904a3a1859691dde9e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri May 22 2026 09:10:49 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri May 22 2026 09:13:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vanumu Sri Ram Prasad",
    "College": "MVGR College of Engineering",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/8feaf4a6-a371-4c8c-b0b0-d320a88e816e.png",
    "Company Name": "FINEXCORE Software Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/finexcore-software-solutions.png",
    "Designation": "Associate Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sri-ram-prasad-vanumu-926695250/",
    "One liner Testimonial": "Getting my first tech job felt unreal after so many unanswered applications. This opportunity gave me confidence that my efforts were finally paying off.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "5a4efb25-50c2-4326-af47-5e13b8461870",
    "slug": "5a4efb25-50c2-4326-af47-5e13b8461870",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a101c91c55e6c6e8a49a1fb",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri May 22 2026 09:06:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 06:36:22 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 06:43:33 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Appalanaidu Routhu",
    "College": "Visakha Institute of Engineering & Technology (VIET), Visakhapatnam",
    "Branch": "Computer Science",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5a4efb25-50c2-4326-af47-5e13b8461870.png",
    "Company Name": "Robokalam",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/robokalam.png",
    "Designation": "Full-stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/appalanaidu-routhu-400654257/?isSelfProfile=false",
    "One liner Testimonial": "I came from a non-tech background and even prepared for government exams once. Today, starting my first tech job feels like a complete life shift.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 25 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "MCA",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "73b4df83-4157-4ecd-9ef0-2d67dbed37df",
    "slug": "73b4df83-4157-4ecd-9ef0-2d67dbed37df",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2a5cd95320e8f6c96bd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:09 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 10:02:09 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 10:04:03 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Manimela Ankammarao",
    "College": "Swarnandhra College of Engineering and Technology",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/73b4df83-4157-4ecd-9ef0-2d67dbed37df.png",
    "Company Name": "Image Infosystem",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/image-infosystems.png",
    "Designation": "Software Programmer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/manimela-ankammarao-242b85265/?isSelfProfile=false",
    "One liner Testimonial": "I kept applying despite the tough job market and many rejections. Cracking my first interview finally gave me the confidence to keep believing.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 11 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.3",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "0a22fcd4-8032-4418-b582-f82e9a71c343",
    "slug": "0a22fcd4-8032-4418-b582-f82e9a71c343",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2a68591cf5b61a18978",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 10:02:22 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 10:04:03 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Yugesh Erukula",
    "College": "Kallam Haranadhareddy Institute of Technology",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0a22fcd4-8032-4418-b582-f82e9a71c343.png",
    "Company Name": "Image Infosystem",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/image-infosystems.png",
    "Designation": "Software Programmer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/yugesherukula/?isSelfProfile=false",
    "One liner Testimonial": "I spent months upskilling after graduation and kept applying despite the rejections. Landing my first tech job finally made it all worth it.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 11 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.3",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "12e7d315-5e13-4210-8cb8-9c81f6f29f2d",
    "slug": "12e7d315-5e13-4210-8cb8-9c81f6f29f2d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2a6f0f93a174c8ee285",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:10 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 07:08:22 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:10:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Suraj Tetarwal",
    "College": "Indira Gandhi National Open University (IGNOU), New Delhi",
    "Branch": "Computer Applications",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/12e7d315-5e13-4210-8cb8-9c81f6f29f2d.png",
    "Company Name": "Pear Media",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/pear-media.png",
    "Designation": "Full-stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/tetarwal-suraj/?skipRedirect=true",
    "One liner Testimonial": "I missed my JEE dream and chose distance education. After many rejections, cracking my first interview proved I could still build a tech career.",
    "Branch Filter": "Non - Engineering background",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Wed May 13 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BCA",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "ba7a0355-db37-465f-9df8-33df3aee84d0",
    "slug": "ba7a0355-db37-465f-9df8-33df3aee84d0",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2a7fc8e0a8975a91950",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:11 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 07:08:13 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:10:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Adinarayana Anandswaroop Addanki",
    "College": "Sree Vidyanikethan Engineering College (SVEC), Tirupati",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ba7a0355-db37-465f-9df8-33df3aee84d0.png",
    "Company Name": "TARDID Technologies Pvt Ltd",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/tardid-technologies-pvt-ltd.png",
    "Designation": "UI-UX Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/anandswaroop30/",
    "One liner Testimonial": "I chose tech over Mechanical, kept going despite rejections, and landed my first UI/UX role. Seeing my family proud made it all worth it.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4.5",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "9bb35a19-243b-4c06-ad23-c561ddbefe26",
    "slug": "9bb35a19-243b-4c06-ad23-c561ddbefe26",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2a8a30a4ec8283bfca1",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:12 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 07:08:08 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:10:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sindhu Sri Gavini",
    "College": "Kakatiya Institute of Technology & Science, Yerragattu Hillocks, Bheemaram, Hasanparthy, Warangal",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/9bb35a19-243b-4c06-ad23-c561ddbefe26.png",
    "Company Name": "IdeyaLabs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/ideyalabs.png",
    "Designation": "Full-stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sindhusrigavini/?skipRedirect=true",
    "One liner Testimonial": "I almost gave up after facing so many setbacks. Cracking my dream company in my very first NxtWave interview felt unreal, and my family couldn't be happier.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "62bb1aae-c097-4651-9c6c-7591de9d7fb5",
    "slug": "62bb1aae-c097-4651-9c6c-7591de9d7fb5",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2a98591cf5b61a18ac0",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:13 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 07:07:55 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:10:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Neela Pavan Sai ",
    "College": "Anurag University (AU), Venkatapur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/62bb1aae-c097-4651-9c6c-7591de9d7fb5.png",
    "Company Name": "Deepija Telecom Pvt Ltd",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/deepija-telecom-pvt-ltd.png",
    "Designation": "Software Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/neela-pavan-sai/",
    "One liner Testimonial": "I had to pause my learning when life got difficult, and my future felt uncertain. Landing my first job after that comeback means everything to me.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "3b663a29-ad73-484d-b71a-f26dca96bf3d",
    "slug": "3b663a29-ad73-484d-b71a-f26dca96bf3d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2aafc8e0a8975a91b43",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 06:55:08 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:01:34 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Akhil Kumar Jinukuntla",
    "College": "Sri Indu College of Engineering & Technology (SICET), Ibrahimpatnam",
    "Branch": "CSE (AIDS) ",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/3b663a29-ad73-484d-b71a-f26dca96bf3d.png",
    "Company Name": "Emergent Labs",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/emergent-labs.png",
    "Designation": "AI Product Experience Specialist",
    "linkedin profile link": "https://www.linkedin.com/in/jinukuntla-akhil-kumar-3a4b99247/",
    "One liner Testimonial": "I came from a college with limited tech placements and zero coding confidence. Landing my first AI role feels like the start of everything I dreamed of.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue May 26 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "8",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "097eb8f8-a3a2-47ba-9fbe-4416b054557f",
    "slug": "097eb8f8-a3a2-47ba-9fbe-4416b054557f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2aafe9784a2b85982ce",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:14 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 07:07:26 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:10:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Dhupati Bala Chakravarthi ",
    "College": "Tirumala Engineering College",
    "Branch": "Computer Science and Engineering",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/097eb8f8-a3a2-47ba-9fbe-4416b054557f.png",
    "Company Name": "Mediamint",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/mediamint.png",
    "Designation": "Jr. Python Developer",
    "linkedin profile link": "https://www.linkedin.com/in/dhupati-balachakravarthi-4ab2932a9/?isSelfProfile=false",
    "One liner Testimonial": "In a tough job market, I wasn’t getting responses anywhere. Landing my first job in a role that truly matches my skills feels unreal.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon May 18 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "ff1b9153-aabb-4560-895e-85cd5318af13",
    "slug": "ff1b9153-aabb-4560-895e-85cd5318af13",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2abb838e59a94af9521",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 06:54:37 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:01:34 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Arun Reddy Kavvam",
    "College": "Marri Laxman Reddy Institute of Technology & Management (MLRIT), Dundigal",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ff1b9153-aabb-4560-895e-85cd5318af13.png",
    "Company Name": "MoEngage",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/moengage.png",
    "Designation": "SDE - 1",
    "linkedin profile link": "https://www.linkedin.com/in/arunkumarreddy-kavvam/",
    "One liner Testimonial": "I turned down roles that didn’t match my goals and kept preparing for what I really wanted. Landing my dream SDE role made the wait worth it.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Thu May 28 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "13",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "0c455518-eb72-4f32-ae1b-5195585e5933",
    "slug": "0c455518-eb72-4f32-ae1b-5195585e5933",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2abfc8e0a8975a91b68",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:15 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 06:54:30 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:01:34 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shambanagouda Kallannanavar",
    "College": "Government Engineering College Haveri",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/0c455518-eb72-4f32-ae1b-5195585e5933.png",
    "Company Name": "GeekSynergy Technologies Pvt. Ltd.",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/geeksynergy-technologies-pvt.-ltd..png",
    "Designation": "Full-stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/shambhunk/",
    "One liner Testimonial": "I came from a government college with almost no placements. Building real skills gave me the confidence to land my first tech job.",
    "Branch Filter": "Others ",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue May 26 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "BE",
    "Package in lpa": "2.5",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "1cd680c4-b8f0-4b3a-ae9b-0f0cab9fe6b3",
    "slug": "1cd680c4-b8f0-4b3a-ae9b-0f0cab9fe6b3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a34e2acc1970a233b89ee69",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Fri Jun 19 2026 06:33:16 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Fri Jun 19 2026 07:06:21 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Fri Jun 19 2026 07:10:37 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Devi Sri Pranav Kota",
    "College": "Pragati Engineering College (PEC), Surampalem",
    "Branch": "Mechanical Engineering (ME)",
    "Graduate year": "2023",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1cd680c4-b8f0-4b3a-ae9b-0f0cab9fe6b3.png",
    "Company Name": "Delta Technology and Management Services",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/delta-technology-and-management-services.png",
    "Designation": "Associate Consultant",
    "linkedin profile link": "https://www.linkedin.com/in/pranav-kota/",
    "One liner Testimonial": "Despite coming from a Mechanical Engineering background, I transitioned into IT and secured my first role as an Associate Consultant through consistent learning.",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Thu May 28 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "May"
  },
  {
    "UID": "25ab251c-b024-4c5a-8ab5-13bd06ab2d4f",
    "slug": "25ab251c-b024-4c5a-8ab5-13bd06ab2d4f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce836fc4ef2e8b895d559",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:18 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sri Naga Thanmai Navudu",
    "College": "Amity University (AU), Rajasthan",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/25ab251c-b024-4c5a-8ab5-13bd06ab2d4f.png",
    "Company Name": "Infyair",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/infyair.png",
    "Designation": "Full-stack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/thanmai-navudu-887337246/",
    "One liner Testimonial": "I stayed consistent, treated every interview as a learning opportunity, and eventually secured my first job as a Full-stack Developer through persistence and practical learning.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Jun 08 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "2.65",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "80b489c7-c97a-4d3a-935f-e8f4abc3513f",
    "slug": "80b489c7-c97a-4d3a-935f-e8f4abc3513f",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce8388467007459ae2130",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "L V S Janaki Rama Raju Kanumuri",
    "College": "Anil Neerukonda Institute of Technology & Sciences (ANITS), Visakhapatnam",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/80b489c7-c97a-4d3a-935f-e8f4abc3513f.png",
    "Company Name": "Kotak Mahindra Bank",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kotak-mahindra-bank.png",
    "Designation": "SDE- 1",
    "linkedin profile link": "https://www.linkedin.com/in/lvsjanakiramarajukanumuri/",
    "One liner Testimonial": "Consistent learning, stronger projects, and improving after every interview helped me turn rejections into a 10 LPA SDE offer at Kotak.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jun 07 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "a6a3b92a-f99f-4206-aff3-658d4eb32ffe",
    "slug": "a6a3b92a-f99f-4206-aff3-658d4eb32ffe",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce838d84119ed0a2fe38c",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:20 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Rangasai mangalagiri",
    "College": "ACE Engineering College (ACE), Ghatkesar",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/a6a3b92a-f99f-4206-aff3-658d4eb32ffe.png",
    "Company Name": "Kotak Mahindra Bank",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kotak-mahindra-bank.png",
    "Designation": "SDE-1",
    "linkedin profile link": "https://www.linkedin.com/in/rangasai-mangalagiri/",
    "One liner Testimonial": "My first interview became my first job offer. Practical learning, consistent preparation, and the right guidance helped me secure my dream SDE role at Kotak.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jun 07 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "6aca1950-2344-49e1-a5cd-34dae9530787",
    "slug": "6aca1950-2344-49e1-a5cd-34dae9530787",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce8393c095f8d7f529f17",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Tadana Vamsi Krishna",
    "College": "Satya Institute of Technology & Management (SITM), Gajularega",
    "Branch": "Electrical & Electronics Engineering (EEE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/6aca1950-2344-49e1-a5cd-34dae9530787.png",
    "Company Name": "Fishery News",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fishery-news.png",
    "Designation": "Junior Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/tadana-vamsi-krishna-b09428247/",
    "One liner Testimonial": "From an ECE background to my first Full-stack Developer role, consistent learning and hands-on projects gave me the confidence to build a career in tech.\n",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue Jun 02 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.6",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "5fdf579a-e135-4119-a848-303c1f4d03a3",
    "slug": "5fdf579a-e135-4119-a848-303c1f4d03a3",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce8393cb69ea2822483f6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:21 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Bhanu Sirikonda",
    "College": "VNR Vignana Jyothi Institute of Engineering and Technology (VNRVJIET), Hyderabad",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5fdf579a-e135-4119-a848-303c1f4d03a3.png",
    "Company Name": "Kotak Mahindra Bank",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kotak-mahindra-bank.png",
    "Designation": "SDE- 1",
    "linkedin profile link": "https://www.linkedin.com/in/bhanu-prasad-sirikonda-513650278/",
    "One liner Testimonial": "Getting my dream SDE role in Hyderabad became possible with the right opportunities, consistent preparation, and continuous placement support.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jun 07 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "30fd4380-3998-4b6b-a76c-3072ebef4509",
    "slug": "30fd4380-3998-4b6b-a76c-3072ebef4509",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83a053b3afe277d9501",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:22 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Sai Patnana",
    "College": "Sri Venkateswara College of Engineering And Technology (SVCET), Etcherla",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/30fd4380-3998-4b6b-a76c-3072ebef4509.png",
    "Company Name": "trytvara",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/trytvara.png",
    "Designation": "Frontend Developer",
    "linkedin profile link": "https://www.linkedin.com/in/sai-patnana/",
    "One liner Testimonial": "Joining NxtWave in my second year helped me turn my passion for coding into real opportunities, leading to my second tech job while still in college.\n",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Mon Jun 01 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "5",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "75a60669-4982-4f5e-bb23-ce029c6cd3d6",
    "slug": "75a60669-4982-4f5e-bb23-ce029c6cd3d6",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83b0cda7014a5527ebd",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Baddi Govinda rao",
    "College": "Anil Neerukonda Institute of Science and Technology",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/75a60669-4982-4f5e-bb23-ce029c6cd3d6.png",
    "Company Name": "Fishery News",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/fishery-news.png",
    "Designation": "Junior Fullstack Developer",
    "linkedin profile link": "https://www.linkedin.com/in/baddi-govinda-rao/",
    "One liner Testimonial": "I'm grateful to NxtWave Placements for helping me land my first job. Working on a real project from day one has been an incredible learning experience and a great start to my career.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Tue Jun 02 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "dcd2509c-7ca4-4674-a6f5-35e90bb01650",
    "slug": "dcd2509c-7ca4-4674-a6f5-35e90bb01650",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83bde438ba9037472a8",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:23 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Venkata Sai Teja",
    "College": "NRI Vijayawada",
    "Branch": "Electronics & Communication Engineering (ECE)",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/dcd2509c-7ca4-4674-a6f5-35e90bb01650.png",
    "Company Name": "Vedant Tech Solutions",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/vedant-tech-solutions.png",
    "Designation": "Associate Java Developer",
    "linkedin profile link": "https://www.linkedin.com/in/teja-gundreddy-4a200626a",
    "One liner Testimonial": "Coming from an ECE background, I secured my first job as an Associate Java Developer through persistence, continuous learning, and the right placement opportunities.\n",
    "Branch Filter": "Non IT branch to IT side",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Thu Jun 11 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "5233fb4c-9d8a-477f-bd8b-47ca3defa0b8",
    "slug": "5233fb4c-9d8a-477f-bd8b-47ca3defa0b8",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83cd84119ed0a2fe79e",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "A Tribhuvan",
    "College": "VVIT",
    "Branch": "CSM (AIML )",
    "Graduate year": "2025",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/5233fb4c-9d8a-477f-bd8b-47ca3defa0b8.png",
    "Company Name": "kristalball",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kristalball.png",
    "Designation": "Full-stack Engineer",
    "linkedin profile link": "https://www.linkedin.com/in/tribhuvanagni",
    "One liner Testimonial": "NxtWave's learning, interview preparation, and placement support helped me land my first Full-stack Engineer role. I'm grateful to have started my career with confidence.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Thu Jun 04 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "4",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "1fecd637-10d9-4d4b-835c-1317e8054706",
    "slug": "1fecd637-10d9-4d4b-835c-1317e8054706",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83ce340fe0b1ef08f6d",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:24 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Lakshmi Venkata Prasad Gotham",
    "College": "Sri Vasavi Engineering College",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2024",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/1fecd637-10d9-4d4b-835c-1317e8054706.png",
    "Company Name": "Image InfoSystems",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/image-infosystems.png",
    "Designation": "Software Programmer Trainee",
    "linkedin profile link": "https://www.linkedin.com/in/lakshmi-venkata-prasad-gotham-751747366/",
    "One liner Testimonial": "Despite my career gap, NxtWave's placement support and timely guidance helped me land my first Software Programmer Trainee role. I'm truly grateful for this opportunity.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Fri Jun 05 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "3.3",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "f6f618b5-f1a4-4270-841e-e2d2c23a36e9",
    "slug": "f6f618b5-f1a4-4270-841e-e2d2c23a36e9-a3b61",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83da2ba4ed6bb1730d6",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:25 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Vijayprashanth G",
    "College": "Bannari Amman Institute of Technology",
    "Branch": "Computer Science and Business Systems (CSBS)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/f6f618b5-f1a4-4270-841e-e2d2c23a36e9.png",
    "Company Name": "Kotak Mahindra Bank",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kotak-mahindra-bank.png",
    "Designation": "SDE-1",
    "linkedin profile link": "https://www.linkedin.com/in/vijayprasanth-g/",
    "One liner Testimonial": "NxtWave's placement support and interview guidance helped me secure an SDE role at Kotak Mahindra Bank. I'm grateful for the opportunity and support throughout my journey.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jun 07 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "ed4b8b21-384a-47dd-afa3-39ac62435264",
    "slug": "ed4b8b21-384a-47dd-afa3-39ac62435264-0744d",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83ee340fe0b1ef09000",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:26 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shahid",
    "College": "Indian Institute of Information Technology (IIIT) Bhagalpur",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/ed4b8b21-384a-47dd-afa3-39ac62435264.png",
    "Company Name": "Kotak Mahindra Bank",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kotak-mahindra-bank.png",
    "Designation": "SDE-1",
    "linkedin profile link": "https://www.linkedin.com/in/mohd-shahid-548191328/",
    "One liner Testimonial": "NxtWave's placement support and interview guidance helped me land my dream SDE role at Kotak. I'm grateful for the opportunity and the confidence they gave me throughout my journey.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jun 07 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  },
  {
    "UID": "e8b5e325-bcee-4cb6-a640-d21ba61105fa",
    "slug": "e8b5e325-bcee-4cb6-a640-d21ba61105fa-8487a",
    "Collection ID": "68ef4ae75871fb56a24d5281",
    "Locale ID": "657d9d4754838aafd23a3df4",
    "Item ID": "6a4ce83f4806e47ce6bbf96a",
    "Archived": "false",
    "Draft": "false",
    "Created On": "Tue Jul 07 2026 11:51:27 GMT+0000 (Coordinated Universal Time)",
    "Updated On": "Tue Jul 07 2026 11:53:52 GMT+0000 (Coordinated Universal Time)",
    "Published On": "Tue Jul 07 2026 11:58:02 GMT+0000 (Coordinated Universal Time)",
    "Stundent Name": "Shishpal Polampally",
    "College": "IIIT Pune",
    "Branch": "Computer Science Engineering (CSE)",
    "Graduate year": "2026",
    "Student profile image Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/profile-images/e8b5e325-bcee-4cb6-a640-d21ba61105fa.png",
    "Company Name": "Kotak Mahindra Bank",
    "Company logo Url": "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/reviews/company-logos/kotak-mahindra-bank.png",
    "Designation": "SDE-1",
    "linkedin profile link": "https://www.linkedin.com/in/shishpal-polampally/",
    "One liner Testimonial": "NxtWave's placement support and interview guidance helped me secure an SDE role at Kotak Mahindra Bank. I'm grateful for the opportunity and support throughout my journey.",
    "Branch Filter": "Others",
    "Page-specific filters Tags": "python-full-stack-training-in-hyderabad; read-more; fee; irc; eligibility; placement-support; training-details; nxtwave; tech-blog; intensive-brandsearch; software-training-institute; instance-query-resolution; intensive-new-v2; intensive-new; intensive; non-it-job-to-it-job; lack-of-confidence; learned-previously-at-other-training-centers; impact-stories; career-growth-hike-in-salary; without-a-degree-joined-while-in-schooling-and-got-a-job; high-paid-jobs; top-mnc-companies; non-engineering-background-bsc-msc-mba-b-pharmacy; career-gap; zero-coding-knowledge; women-in-tech; non-it-to-software",
    "Placed month Date Formate": "Sun Jun 07 2026 18:30:00 GMT+0000 (Coordinated Universal Time)",
    "Shortened Degree": "B Tech",
    "Package in lpa": "10",
    "Full Testimonial": "",
    "Placed Month": "Jun"
  }
] as const satisfies readonly IntensiveReview[];
